webpackJsonp([35],{

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export translateTime */
/* harmony export (immutable) */ __webpack_exports__["b"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["a"] = deepCopy;
/* harmony export (immutable) */ __webpack_exports__["d"] = versioncodeFormat;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUrlParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("ZLEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("hRKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


/**
 * [translateTime  剩余时间戳转为剩余天时分秒]
 * @param   {number}  time  [时间戳]
 * @return  {string}  [剩余天时分秒]
 */
function translateTime(time) {
  var days = time / 1000 / 60 / 60 / 24;
  var daysRound = Math.floor(days);
  var hours = time / 1000 / 60 / 60 - 24 * daysRound;
  var hoursRound = Math.floor(hours);
  var minutes = time / 1000 / 60 - 24 * 60 * daysRound - 60 * hoursRound;
  var minutesRound = Math.floor(minutes);
  // let seconds = time / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound)
  if (daysRound !== 0) {
    return daysRound + '天' + hoursRound + '时' + minutesRound + '分';
  } else if (hoursRound !== 0) {
    return hoursRound + '时' + minutesRound + '分';
  } else if (minutesRound !== 0) {
    return minutesRound + '分';
  } else {
    return time / 1000 + '秒';
  }
}

/**
 * [formatDate  时间戳转为年月日时分秒]
 * @param   {object}  time  [时间对象]
 * @param   {string}  sign  [需要转换的类型，默认为date]
 * @return  {string}  [年月日时分秒]
 */
function formatDate(time) {
  var sign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'date';

  var date = new Date(Number(time));
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  var s = date.getSeconds() < 10 ? ':' + '0' + date.getSeconds() : ':' + date.getSeconds();
  if (sign === 'date') {
    return Y + M + D;
  } else if (sign === 'time') {
    return h + m;
  } else if (sign === 'half') {
    return Y + M + D + ' ' + h;
  } else if (sign === 'total') {
    return Y + M + D + ' ' + h + m;
  } else if (sign === 'all') {
    return Y + M + D + ' ' + h + m + s;
  } else if (sign === 'allTime') {
    return h + m + s;
  }
}

/*
 * js对象深拷贝
 * @param  {Object} obj 被拷贝的对象
 * @return {Object} 返回新对象
 */
function deepCopy(obj) {
  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== 'object') {
    return obj;
  }

  // if obj is hit, it is in circular structure
  var hit = cache.filter(function (c) {
    return c.original === obj;
  })[0];
  if (hit) {
    return hit.copy;
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
}

// 版本转化code
function versioncodeFormat(code) {
  if (!code) {
    return 0;
  }
  return Number(code.split('.').map(function (i) {
    return i.padStart(3, '0');
  }).join().replace(/,/g, ''));
}
// 获取地址栏参数
function getUrlParams(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var url = location.href;
  var temp1 = url.split('?');
  var pram = temp1[1] || [];
  var keyValue = pram.split('&');
  var obj = {};
  for (var i = 0; i < keyValue.length; i++) {
    var item = keyValue[i].split('=');
    var key = item[0];
    var value = item[1];
    obj[key] = value;
  }
  return obj[name];
}

/***/ }),

/***/ "2rVw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Ia3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7cbB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_axios@0.17.1@axios/index.js
var _axios_0_17_1_axios = __webpack_require__("2sCs");
var _axios_0_17_1_axios_default = /*#__PURE__*/__webpack_require__.n(_axios_0_17_1_axios);

// EXTERNAL MODULE: ./node_modules/_element-ui@2.15.14@element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("88IO");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./src/store/index.js + 6 modules
var store = __webpack_require__("IcnI");

// CONCATENATED MODULE: ./src/utils/sys_fetch.js



// import { getToken } from './auth'

window.localStorage.baseURL = "http://new.xiniuboss.com:28480";
// 创建axios实例
var service = _axios_0_17_1_axios_default.a.create({
  baseURL: window.localStorage.baseURL, // api的base_url
  timeout: 30000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(function (config) {
  var loginInfo = JSON.parse(localStorage.getItem('operateLoginInfo')) || {};
  if (!config.data) {
    config.data = {};
  }
  config.data.common = {
    apiVer: loginInfo.apiVer || 1,
    platformId: loginInfo.platformId || 6,
    requestId: loginInfo.requestId || Date.now(),
    token: loginInfo.token,
    uuid: loginInfo.uuid || '',
    packageName: 'web',
    versionCode: 1,
    versionName: '1.0',
    langCode: localStorage.getItem('LOCALE_KEY') || 'zh-cn'
  };
  return config;
}, function (error) {
  console.log(error); // for debug
});

// respone拦截器
service.interceptors.response.use(function (response) {
  var res = response.data;
  if (res.code === 10402 || res.code === -3 || res.code === '-3') {
    element_ui_common["MessageBox"].alert('登录信息过期，请重新登录', '提示信息', {
      confirmButtonText: '确定',
      callback: function callback(action) {
        store["a" /* default */].dispatch('LoginOut').then(function (res) {
          location.reload();
        });
      }
    });
    return res;
  } else if (res.code === 20000) {
    return res;
  } else {
    Object(element_ui_common["Message"])({
      showClose: true,
      message: res.msg || '服务器异常',
      type: 'error'
    });
    return res;
  }
}, function (error) {
  Object(element_ui_common["Message"])({
    message: '网络超时，请稍后重试',
    type: 'error'
  });
  console.error('err' + error);
  return {
    code: -20000
  };
});

/* harmony default export */ var sys_fetch = (service);
// CONCATENATED MODULE: ./src/api/management/v2/login.js
/* harmony export (immutable) */ __webpack_exports__["b"] = login;
/* unused harmony export loginOut */
/* harmony export (immutable) */ __webpack_exports__["a"] = getLoginInfoByToken;
/* unused harmony export companyWechatAuthCode */


function login(_ref) {
  var account = _ref.account,
      companyCode = _ref.companyCode,
      password = _ref.password;

  return sys_fetch({
    url: 'enterprise.login',
    method: 'post',
    data: {
      data: { account: account, companyCode: companyCode, password: password }
    }
  });
}

function loginOut(_ref2) {
  var data = _ref2.data;

  return sys_fetch({
    url: 'enterprise.loginOut',
    method: 'post',
    data: {
      data: data
    }
  });
}

function getLoginInfoByToken(_ref3) {
  var token = _ref3.token;

  return sys_fetch({
    url: '/pos/getLoginInfoByToken',
    method: 'post',
    data: {
      data: {
        token: token
      }
    }
  });
}
function companyWechatAuthCode(data) {
  return sys_fetch({
    url: '/companyWechatAuthCode.add',
    method: 'post',
    data: {
      data: data
    }
  });
}

/***/ }),

/***/ "FGqP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GK83":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vue@2.7.16@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("nhZ1");

// EXTERNAL MODULE: ./node_modules/_vuex@3.6.2@vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("bSIt");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/promise.js
var promise = __webpack_require__("rVsN");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./src/router/index.js + 3 modules
var router = __webpack_require__("YaEn");

// CONCATENATED MODULE: ./src/store/modules/management.js



var management = {
  state: {
    // view视图tab
    tabNumber: 0,
    // 授权店铺数量
    storeNum: 0,
    // 授权仓库数量
    wareHouseNum: 0,
    // 仓库容量
    wareHouseNumSum: 0,
    // 已开通的服务
    server: [],
    // 是否配置了物流模块
    logisticsConfig: false
  },
  mutations: {
    SET_TABNUMBER: function SET_TABNUMBER(state, tabNumber) {
      state.tabNumber = tabNumber;
    },
    SET_AUTHORIZEDSTORENUM: function SET_AUTHORIZEDSTORENUM(state, num) {
      state.storeNum = num;
    },
    SET_AUTHORIZEDWAREHOUSENUM: function SET_AUTHORIZEDWAREHOUSENUM(state, num) {
      state.wareHouseNum = num;
    },
    SET_AUTHORIZEDWAREHOUSENUMSUM: function SET_AUTHORIZEDWAREHOUSENUMSUM(state, num) {
      state.wareHouseNumSum = num;
    },
    SET_SERVER: function SET_SERVER(state, server) {
      state.server = server;
    },
    SET_LOGISTICSCONFIG: function SET_LOGISTICSCONFIG(state, bool) {
      state.logisticsConfig = bool;
    }
  },
  actions: {
    // 管理后台
    // 前端登录
    // LoginIn({ commit }, userInfo) {
    //   return new Promise(resolve => {
    //     commit('SET_TOKEN', userInfo.token)
    //     setToken(userInfo.token)
    //     resolve()
    //   })
    // },
    // 前端登出
    LoginOut: function LoginOut(_ref) {
      var commit = _ref.commit;

      return new promise_default.a(function (resolve) {
        commit('SET_TABNUMBER', '');
        commit('SET_AUTHORIZEDSTORENUM', '');
        commit('SET_LOGISTICSCONFIG', '');
        commit('SET_SERVER', '');
        localStorage.removeItem('manageLoginInfo');
        router["a" /* default */].push('/management/login');
        resolve();
      });
    }
  }
};

/* harmony default export */ var modules_management = (management);
// CONCATENATED MODULE: ./src/store/modules/operation.js

// import { sysGetToken, sysSetToken, sysRemoveToken } from '../../utils/sys_auth'
var operation = {
  state: {
    // 运营后台
    sysToken: '',
    sysCode: '',
    sysName: '',
    // 企业管理模块数据绑定，视图切换字段
    viewCompany: {
      status: false,
      name: '',
      id: '',
      ifinfo: true,
      server: ''
    },
    // 激活码管理模块数据绑定，视图切换字段
    viewActiveCodeModule: {
      status: false,
      ifactiveModule: true,
      name: '',
      id: '',
      notActiveNumber: 0,
      activedNumber: 0
    }
  },
  mutations: {
    // 运营后台
    SET_SYSTOKEN: function SET_SYSTOKEN(state, sysToken) {
      state.sysToken = sysToken;
    },
    SET_SYSCODE: function SET_SYSCODE(state, sysCode) {
      state.sysCode = sysCode;
    },
    SET_SYSNAME: function SET_SYSNAME(state, sysName) {
      state.sysName = sysName;
    },
    SET_VIEWCOMPANY: function SET_VIEWCOMPANY(state, companyInfo) {
      state.viewCompany = companyInfo;
    },
    SET_VIEWACTIVECODEMODULE: function SET_VIEWACTIVECODEMODULE(state, activeCodeInfo) {
      state.viewActiveCodeModule = activeCodeInfo;
    }
  },
  actions: {
    sysLoginOut: function sysLoginOut(_ref) {
      var commit = _ref.commit;

      return new promise_default.a(function (resolve) {
        commit('SET_SYSTOKEN', '');
        commit('SET_SYSNAME', '');
        localStorage.removeItem('operateLoginInfo');
        resolve();
      });
    },

    // 设置企业信息
    SetOperateInfo: function SetOperateInfo(_ref2, userInfo) {
      var commit = _ref2.commit;

      return new promise_default.a(function (resolve) {
        commit('SET_SYSTOKEN', userInfo.token);
        commit('SET_SYSNAME', userInfo.name);
        resolve();
      });
    },
    sysSetViewCompany: function sysSetViewCompany(_ref3, companyInfo) {
      var commit = _ref3.commit;

      commit('SET_VIEWCOMPANY', companyInfo);
    },
    sysSetviewActiveCodeModule: function sysSetviewActiveCodeModule(_ref4, activeCodeInfo) {
      var commit = _ref4.commit;

      commit('SET_VIEWACTIVECODEMODULE', activeCodeInfo);
    }
  }
};

/* harmony default export */ var modules_operation = (operation);
// CONCATENATED MODULE: ./src/store/modules/app.js
/*
 * @Author: wolfsheller
 * @Description: 用来全局管理
 * @Date: 2018-07-19 17:22:26
 * @Last Modified by: hongmeiting
 * @Last Modified time: 2020-01-07 14:32:12
 */
var app = {
  state: {
    globalLoading: false,
    language: '',
    manageLoginInfo: []
  },
  mutations: {
    // 设置收银全局loading
    SET_GLOBAL_LOADING: function SET_GLOBAL_LOADING(state, loading) {
      state.globalLoading = loading;
    },
    SET_LANGUAGE_CHANGE: function SET_LANGUAGE_CHANGE(state, val) {
      state.language = val;
    },
    SET_MANAGE_LOGIN_INFO: function SET_MANAGE_LOGIN_INFO(state, val) {
      state.manageLoginInfo = val;
    }
  }
};

/* harmony default export */ var modules_app = (app);
// CONCATENATED MODULE: ./src/store/modules/payset.js
/*
 * @Author: wolfsheller
 * @Description: 支付配置管理
 * @Date: 2018-07-19 17:22:26
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-02 11:15:36
 */
var payset = {
  state: {
    channelSet: [],
    channelSetFlag: ''
  },
  mutations: {
    SET_CHANNEL_SET: function SET_CHANNEL_SET(state, val) {
      state.channelSet = val;
    },
    SET_CHANNELSET_FLAG: function SET_CHANNELSET_FLAG(state, val) {
      state.channelSetFlag = val;
    }
  }
};

/* harmony default export */ var modules_payset = (payset);
// CONCATENATED MODULE: ./src/store/modules/newreceipt.js
/*
 * @Author: wolfsheller
 * @Description: 小票配置管理
 * @Date: 2018-07-19 17:22:26
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-03-14 14:36:02
 */
var newreceipt = {
  state: {
    saleSlipType: '',
    receiptModelSetFlag: '',
    setChannel: [],
    setAllChannel: [],
    channelSetModelFlag: ''
  },
  mutations: {
    SET_RECEIPTMODELSET_FLAG: function SET_RECEIPTMODELSET_FLAG(state, val) {
      state.receiptModelSetFlag = val;
    },
    SET_SETCHANNEL_ARR: function SET_SETCHANNEL_ARR(state, _ref) {
      var _ref$selectData = _ref.selectData,
          selectData = _ref$selectData === undefined ? [] : _ref$selectData,
          _ref$selectAllData = _ref.selectAllData,
          selectAllData = _ref$selectAllData === undefined ? [] : _ref$selectAllData;

      state.setChannel = selectData;
      state.setAllChannel = selectAllData;
    },
    SET_CHANNELSETMODEL_FLAG: function SET_CHANNELSETMODEL_FLAG(state, val) {
      state.channelSetModelFlag = val;
    },
    SET_SALESLIPTYPE: function SET_SALESLIPTYPE(state, val) {
      state.saleSlipType = val;
    }
  }
};

/* harmony default export */ var modules_newreceipt = (newreceipt);
// CONCATENATED MODULE: ./src/store/modules/authorized.js
/*
 * @Author: fangchutao
 * @Description: 授权信息配置
 * @Date: 2019-08-20 14:21:13
 * @Last Modified by: fangchutao
 * @Last Modified time: 2019-08-20 14:28:36
 */
var authorized = {
  state: {
    // 点击某一个合同跳转时的row
    rowData: {}
  },
  mutations: {
    SET_ROWDATA: function SET_ROWDATA(state, rowData) {
      state.rowData = rowData;
    }
  }
};
/* harmony default export */ var modules_authorized = (authorized);
// CONCATENATED MODULE: ./src/store/index.js








vue_esm["default"].use(vuex_esm["a" /* default */]);

var Store = new vuex_esm["a" /* default */].Store({
  modules: {
    Management: modules_management,
    Operation: modules_operation,
    app: modules_app,
    payset: modules_payset,
    newreceipt: modules_newreceipt,
    authorized: modules_authorized
  }
});

/* harmony default export */ var store = __webpack_exports__["a"] = (Store);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("3cXf");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/_vue@2.7.16@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("nhZ1");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("4YfN");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/_vuex@3.6.2@vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("bSIt");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//



/* harmony default export */ var App = ({
  name: 'app',
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  data: function data() {
    return {
      isRouterAlive: true
    };
  },

  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])({
    globalLoading: function globalLoading(state) {
      return state.app.globalLoading;
    }
  })),
  methods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-284a3758","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.body",value:(_vm.globalLoading),expression:"globalLoading",modifiers:{"body":true}}],attrs:{"id":"app","element-loading-spinner":"el-icon-loading"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("FGqP")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-284a3758"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./src/store/index.js + 6 modules
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./node_modules/_element-ui@2.15.14@element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("88IO");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/_element-ui@2.15.14@element-ui/lib/locale/index.js
var locale = __webpack_require__("rgz9");
var locale_default = /*#__PURE__*/__webpack_require__.n(locale);

// EXTERNAL MODULE: ./node_modules/_element-ui@2.15.14@element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("GK83");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./node_modules/_nprogress@0.2.0@nprogress/nprogress.js
var nprogress = __webpack_require__("E4C3");
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);

// EXTERNAL MODULE: ./node_modules/_nprogress@0.2.0@nprogress/nprogress.css
var _nprogress_0_2_0_nprogress_nprogress = __webpack_require__("ve9D");
var _nprogress_0_2_0_nprogress_nprogress_default = /*#__PURE__*/__webpack_require__.n(_nprogress_0_2_0_nprogress_nprogress);

// EXTERNAL MODULE: ./src/styles/common.scss
var common = __webpack_require__("5Ia3");
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./src/router/index.js + 3 modules
var router = __webpack_require__("YaEn");

// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__("TIfe");

// EXTERNAL MODULE: ./node_modules/_js-cookie@2.2.1@js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("sqb0");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/utils/sys_auth.js


var TokenKey = 'operation-token';

function sysGetToken() {
  var operateLoginInfo = JSON.parse(localStorage.getItem('operateLoginInfo')) || {};
  return operateLoginInfo.token || '';
}

function sysSetToken(token) {
  return js_cookie_default.a.set(TokenKey, token);
}

function sysRemoveToken() {
  return js_cookie_default.a.remove(TokenKey);
}
// EXTERNAL MODULE: ./node_modules/_plupload@2.3.9@plupload/js/plupload.full.min.js
var plupload_full_min = __webpack_require__("ZV2s");
var plupload_full_min_default = /*#__PURE__*/__webpack_require__.n(plupload_full_min);

// EXTERNAL MODULE: ./node_modules/_lodash@4.18.1@lodash/lodash.js
var lodash = __webpack_require__("L60p");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/_vue-i18n@8.28.2@vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("bGz6");

// CONCATENATED MODULE: ./src/i18n/zh-cn/main.js
/*
 * @Author: JamesWong
 * @Description: 首页中文
 * @Date: 2018-11-29 10:34:46
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-13 13:12:41
 */

/* harmony default export */ var main = ({
  productName: '犀牛EPOS企业管理后台',
  companyNo: '企业编号',
  companyEnterTips: '请输入企业编号',
  account: '登陆账号',
  accountEnterTips: '请输入登陆账号',
  password: '输入密码',
  passwordEnterTips: '请输入密码',
  login: '登陆',
  Logout: '退出',
  backHome: '返回首页',
  openedService: '已开通的服务',
  sellModel: '收银模块',
  foundational: '基础物流',
  appVersion: '应用版本',
  authChannel: '授权店铺',
  allAuthChannel: '总授权店铺数',
  authWarehouse: '授权仓库',
  authMumber: '已授权数',
  remainAuthNum: '剩余可授权数',
  whalesaleSelected: '批发零售版选用',
  deviceActivateManagement: '激活码管理',
  subScreen: '副屏交互设置',
  displayMode: '显示模式',
  rollingDisplay: '轮播图片',
  advertisementVideo: '广告视频',
  ticketDisposition: '小票配置',
  selfcashierDisposition: '自收银配置',
  onlinePayDisposition: '线上支付配置',
  accountModule: '账户',
  collaboraivePlatformSet: '协同平台设置',
  foundationalSet: '物流模块配置',
  depositReceipt: '定金单配置',
  loginNumTips: '企业编号不能为空！',
  '剩余天数': '，剩余天数',
  loginAccountTips: '登录账号不能为空！',
  alipayCall: '完成授权，请回到犀牛EPOS管理后台查看授权结果',
  noSet: '未配置, 物流功能不能正常使用',
  authorizedMessage: '授权信息',
  storeAuthorizaedManage: '店铺授权管理',
  manageAllFacility: '设备归属管理',
  record: '门店登录记录',
  '收银模块': '收银模块',
  '物流模块': '物流模块',
  '其他': '其他',
  changeLog: '设备变更记录',
  'deviceChangeLog': '设备变更记录',
  'deviceUntiedLog': '设备解绑记录',
  'Web端使用ERP物流模块': 'Web端使用ERP物流模块',
  styleTicketManager: '单据打印样式管理',
  onlineMonitoring: '设备在线监管'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/appversion.js
/*
 * @Author: JamesWong
 * @Description: 应用版本中文包
 * @Date: 2018-11-29 15:14:04
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-29 16:02:07
 */
/* harmony default export */ var appversion = ({
  appVersion: '应用版本',
  backstageVersion: '后台版本',
  enabledIOSVersion: '可使用的IOS版本',
  enabledAndroidVersion: '可使用的安卓版本',
  enabledPadVersion: '可使用的安卓平板版本',
  versionUpdateDesc: '版本更新说明',
  downloadQRcode: '下载二维码',
  downloadAddress: '下载地址',
  downloadArticle: '详细迭代推文',
  '版本详情': '版本详情',
  Close: '关闭',
  '点击详情': '点击详情',
  '未启用': '未启用',
  '可联系商务开通': '可联系商务开通',
  '下载链接': '下载链接',
  '下载': '下载'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/channel.js
/*
 * @Author: JamesWong
 * @Description: 授权店铺中文包
 * @Date: 2018-11-29 17:15:51
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-07-30 10:00:43
 */
/* harmony default export */ var channel = ({
  authorizedChannel: '已授权店铺',
  deletedStore: '删除店铺',
  hint: '提示',
  deletedStoreTips: '删除后该店铺将不能使用POS登陆，确定删除该店铺吗? ',
  cancel: '取消',
  confirmDelete: '确定删除',
  addChannel: '新增店铺',
  addAuthorizedChannel: '新增授权店铺',
  order: '序号',
  storeNumber: '店铺编号',
  storeAbbreviation: '店铺简称',
  storeFullname: '店铺全称',
  confirm: '确定',
  searchAuthorizedChannel: '搜索已授权店铺',
  searchChannel: '搜索未授权店铺',
  authorizedChannelDeleted: '授权店铺删除成功！',
  authorizedChannelAdded: '授权店铺新增成功！',
  '渠道配置中心': '渠道配置中心',
  '下载模版': '下载模版',
  '导入': '导入',
  '导入教程': '导入教程',
  '支持通过本地excel表快速导入渠道,点击': '支持通过本地excel表快速导入渠道,点击',
  '下载模板': '下载模板',
  '模板第二行开始填写需导入的渠道编号，依次往下录入': '模板第二行开始填写需导入的渠道编号，依次往下录入',
  '选择全部': '选择全部',
  '取消': '取消',
  '确定': '确定',
  '提示': '提示',
  '行导入成功，以下': '行导入成功，以下',
  '行数据导入失败': '行数据导入失败',
  '渠道编号': '渠道编号',
  '知道了': '知道了'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/warehouse.js
/*
 * @Author: JamesWong
 * @Description: 仓库模块中文包
 * @Date: 2018-11-29 18:56:25
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-17 11:22:59
 */
/* harmony default export */ var warehouse = ({
  authorizedWarehouse: '已授权仓库',
  deleteWarehouse: '删除仓库',
  hint: '提示',
  deleteWarehouseTips: '删除后该仓库将不能使用POS登录，确定删除该仓库吗?',
  cancel: '取消',
  confirmDelete: '确定删除',
  addWarehouse: '新增仓库',
  addAuthorizedWarehouse: '新增授权仓库',
  searchAuthorizedWarehouse: '搜索已授权仓库',
  Order: '序号',
  warehouseNumber: '仓库编号',
  warehouseAbbreviation: '仓库简称',
  warehouseFullname: '仓库全称',
  confirm: '确定',
  searchWarehouse: '搜索仓库',
  authorizedWarehouseAdded: '授权仓库新增成功！',
  authorizedWarehouseDeleted: '授权仓库删除成功！'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/activeCode.js
/*
 * @Author: JamesWong
 * @Description: 激活码模块中文包
 * @Date: 2018-11-29 19:12:37
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-02 11:35:13
 */
/* harmony default export */ var activeCode = ({
  activated: '已激活',
  unactivated: '未激活',
  order: '序号',
  activeCode: '激活码',
  machineNumber: '机器编码',
  machineCode: '设备机器码',
  activeTime: '激活时间',
  operation: '操作',
  delete: '删除',
  dataNotAvailable: '暂无数据',
  cancelActived: '取消激活',
  cancel: '取消',
  comfirm: '确定',
  subactiveCodeCanceled: '取消激活',
  subactiveCodeCanceledTips: '确定取消该设备的激活码？',
  subactiveCodeDeleted: '删除子激活码',
  subactiveCodeDeletedTips: '确定删除该条激活码吗？'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/account.js
/*
 * @Author: JamesWong
 * @Description: 账户配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 14:46:55
 */
/* harmony default export */ var account = ({
  basicInformation: '基本资料',
  enterpriseNumber: '企业编号',
  enterpriseName: '企业名称'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/payment.js
/*
 * @Author: JamesWong
 * @Description: 支付配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-08 14:13:44
 */
/* harmony default export */ var payment = ({
  channelPaymentMethods: '渠道支付方式',
  set: '设置',
  setPaymentMethods: '设置支付方式',
  confirm: '确定',
  cancel: '取消',
  channel: '渠道',
  order: '序号',
  channelNumber: '渠道编号',
  account: '户口',
  accountFilter: '户口筛选',
  weChatScanPayment: '微信扫码付',
  paymentSetTips: '提示：同时编辑多个渠道时，支付方式需要重新选择，不选择将被置为空',
  pleaseSelectAgain: '请重新选择',
  selectPaymentMethod: '选择支付方式',
  paymentNumber: '支付编号',
  merchantID: '商户ID',
  submerchantID: '子商户ID',
  Note: '备注',
  appId: '商户ID',
  token: '授权Token',
  tokenTime: '授权时间',
  wechatFaceIDPay: '微信刷脸支付',
  wechatClientSelfpay: '微信客户自付',
  alipayScancodePay: '支付宝扫码付',
  alipayNumber: '支付宝编号',
  systemBusinessNumber: '系统商编号',
  enterChannelTips: '请输入渠道编号、名称搜索',
  channelName: '渠道名称',
  wechatPaymentDisposition: '微信支付配置',
  wechatPaymentTips: '微信支付支持三种支付类型：',
  wechatPaymentTips1: '1.扫码支付：收银员扫客户的付款码，适用于POS收银；',
  wechatPaymentTips2: '2.刷脸支付：客户在特定自助机器上，自主完成刷脸支付，适用于自主购物机；',
  wechatPaymentTips3: '3.客户自支付：客户在个人手机中点击付款，调用微信支付，适用于微商城、扫码购程序；',
  wechatPaymentTipsPlus: '注意：三种类型只能各自默认一个支付，渠道没有单独配置支付方式时，将自动使用默认的支付方式。',
  Mode: '模式',
  type: '类型',
  defaultTips: '是否默认',
  default: '默认',
  operate: '操作',
  detail: '详情',
  paymentMethodDetail: '支付方式详情',
  paymentType: '支付类型',
  APPKEY: 'APPKEY',
  certification: '证书',
  certificationDocument: '证书文件',
  certificationPassword: '证书密码',
  alipayPaymentDisposition: '支付宝支付配置',
  status: '状态',
  authorizedMerchantID: '授权商户ID',
  authorized: '已授权',
  authorize: '授权',
  unAuthorized: '未授权',
  privateKey: '私钥',
  publicKey: '公钥',
  signatureType: '签名类型',
  selectedTips: '请先选择渠道再设置支付方式',
  success: '成功',
  configuredChannel: '已配置渠道',
  reauthorize: '重新授权'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/screen.js
/*
 * @Author: JamesWong
 * @Description: 副屏幕中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 16:54:06
 */
/* harmony default export */ var screen = ({
  interactMode: '交互模式',
  rollingPhotos: '轮播图片',
  advertisementVideo: '广告视频',
  interactModeTips1: '1.收银机没有进行收银操作时，副屏全屏显示图片轮播/视频轮播',
  interactModeTips2: '2.收银过程中，副屏幕左侧显示图片/视频，右侧显示销售明细及交易金额',
  interactModeTips3: '3.结算完成后，副屏幕再次恢复全屏模式',
  fullscreenPhoto: '全屏图片',
  fullscreenVideo: '全屏视频',
  photoSalesDetail: '图片 + 销售明细',
  videoSalesDetail: '视频 + 销售明细',
  upload: '上传',
  preview: '预览',
  previewPhotos: '预览图片',
  delete: '删除',
  photoDeleted: '图片删除成功',
  previewVideo: '预览视频',
  videoUploaded: '上传视频成功！',
  videoSizeTips: '文件大小不能超过200M！',
  photoUploaded: '上传图片成功！',
  phoneSizeTips: '文件大小不能超过10M！',
  longNameTips: '文件名不能过长！',
  moreFileTips: '最多只能上传一个视频，请先删除原有的视频再尝试上传！',
  uploadingTips: '文件正在上传中...  请稍等',
  notSupportTips: '您的浏览器不支持 video 标签。',
  uploadProgress: '上传进度',
  noVideoTips: '你还没有上传视频，赶快上传吧',
  noPhotoTips: '你还没有上传图片，赶快上传吧',
  Unnamed: '未命名'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/slip.js
/*
 * @Author: JamesWong
 * @Description: 小票配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2021-03-18 20:06:04
 */
/* harmony default export */ var slip = ({
  styleDisposition: '样式配置',
  ticketPreview: '小票预览',
  createDeposit: '定金单',
  detail: '详情',
  edit: '编辑',
  save: '保存',
  cancel: '取消',
  printLabel: '打印标示',
  reprintLabel: '重打印标示（仅在重打印的小票上显示）',
  headPhotos: '头部图片',
  headPart: '头部',
  ticketInfo: '单据信息',
  ticketNo: '小票号',
  operateTime: '操作时间',
  cashier: '收银员',
  assistant: '营业员',
  assistantCode: '营业员编号',
  assistantName: '营业员名称',
  storeNo: '店铺编号',
  storeAddr: '店铺地址',
  storePhone: '店铺电话',
  storeMobile: '店铺手机',
  VIPNo: '会员编号',
  remarks: '销售备注',
  Goods: '货品',
  Quty: '数量',
  Amt: '金额',
  Total: '合计',
  PriceTotal: '总额',
  Benefit: '优惠',
  VIPPrice: '会员价',
  DCT: '折扣',
  DiscountedPrice: '折后价',
  ValueBalance: '储值余额',
  TagPrice: '吊牌价',
  goodsInfo: '货品信息',
  promotionInfo: '促销信息',
  allPromotionsTicket: '该单所有的促销',
  promotionDesc: '促销描述',
  promotionNotes: '促销备注',
  paymentMethod: '付款明细',
  defaultPayment: '默认样式：应付+所有应用到的支付方式',
  tailPhotos: '尾部图片',
  salesExplanation: '销售说明',
  tailpart: '尾部',
  quantitySet: '张数配置',
  salesCreateReciept: '销售做单',
  numberChannelVersion: '店铺联打印张数',
  complete: '完成',
  numberCustomerVersion: '顾客联打印张数',
  reprintSalesReciept: '重打印销售单',
  tips: '提示',
  updatedTips: '更新小票配置成功',
  precept: '方案',
  cashierAndName: '收银员：张三',
  assistantAndName: '营业员：1001-王晓',
  storeNoAndName: '店铺编号：1009-店铺',
  storeAddrAndName: '店铺地址：广州市番禺区天安节能科技园15号楼',
  payable: '应付',
  cash: '现金支付',
  integralBalance: '积分余额',
  printThirtpartOrder: '支付流水号',
  thridSeralNumber: '第三方支付的商户支付流水号',
  TicketNumberEdited: '小票数修改成功！',
  TicketNumberEditedError1: '请输入0-3之间的数字',
  TicketNumberEditedError2: '数量不能超过 3',
  photoUploadTips: '注：请先选择图片，可用鼠标滑动调整图片的大小、位置，已达到理想打印效果。如超过边框，图片会按照300:130进行裁切。',
  selectPhotos: '选择图片',
  leftTurn: '向左旋转',
  rightTurn: '向右旋转',
  upload: '上传',
  confirm: '确定',
  markSet: '标示设置',
  markSetMsg: '隐藏"店铺联/顾客联"标示',
  markSetCustomer: '顾客联',
  invoiceScanUrlText: '发票二维码',
  invoiceScanUrl: '显示发票二维码(ERP配置后生效)',
  invoiceDesc: '发票描述',
  '添加二维码': '添加二维码',
  '请输入二维码内容': '请输入二维码内容',
  '自定义二维码': '自定义二维码',
  '二维码描述': '二维码描述',
  '销售单号': '销售单号',
  '手工单号': '手工单号',
  '会员卡号': '会员卡号',
  '会员手机': '会员手机',
  etc: '等',
  Coupon: '代用券',
  Date: '日期',
  printCoupons: '打印代用券',
  promoteCounpon: '促销赠券',
  rechargeCounpon: '充值赠券',
  primeCostInfo: '原价总额',
  primeCostInfoDetail: '(货品总吊牌额)',
  DiscountTotal: '优惠总额',
  alreadyDiscountInfo: '已优惠',
  alreadyDiscountInfoDetail: '(已优惠=吊牌额-应付)',
  实付: '实付',
  生意额: '生意额',
  getIntegrateInfo: '获得积分',
  remainingIntegrateInfo: '积分余额',
  uploadPhoto: '上传图片',
  autoSavePhoto: '自动生成条码图片',
  autoSelectNum: '选择自动生成条形码的单号',
  Saleno: '销售单号',
  manualSaleNo: '手工单号',
  barCode: '条形码',
  qrCode: '二维码',
  qrCodeText: '二维码内容',
  takeCareMsg: '注意：手工单号相对较长，转成条形码可能过长，导致扫描不出来，建议使用二维码',
  cancelMsg: '取 消',
  saveMsg: '保 存',
  addParagraph: '+新增段落',
  addEmptyParagraph: '+新增空行',
  paragraphMsg: '段落',
  leftAlign: '左对齐',
  centerAlign: '居中',
  deleteMsg: '删除',
  blankLine: '空行',
  goodsSpace: '货品显示',
  goodsSpaceMsg: '货品之间空行隔开',
  showGoodsTotal: '货品合计',
  showGoodsTotalMsg: '显示合计',
  middlePic: '自定义图片',
  tailImageDesc: '图片描述',
  barCodeStyle: '条码样式',
  smallTicketNum: '小票号',
  goodsType10: '条形码',
  goodsType10Unique: '唯一码',
  goodsType17: '条形码/唯一码',
  goodsType2: '条形码/品名',
  goodsType2Unique: '唯一码/品名',
  goodsType22: '条形码/品类',
  goodsType22Unique: '唯一码/品类',
  goodsType4: '条形码/品名/吊牌价',
  goodsType4Unique: '唯一码/品名/吊牌价',
  goodsType44: '条形码/品类/吊牌价',
  goodsType44Unique: '唯一码/品类/吊牌价',
  goodsType5: '条形码/品名/会员价/折后价',
  goodsType5Unique: '唯一码/品名/会员价/折后价',
  goodsType55: '条形码/品类/会员价/折后价',
  goodsType55Unique: '唯一码/品类/会员价/折后价',
  goodsType7: '条形码/品名/会员价/折扣/折后价',
  goodsType7Unique: '唯一码/品名/会员价/折扣/折后价',
  goodsType77: '条形码/品类/会员价/折扣/折后价',
  goodsType77Unique: '唯一码/品类/会员价/折扣/折后价',
  goodsType1: '货号-品名/颜色/内长/尺码',
  goodsType6: '货号-品名/颜色/内长/尺码/会员价/折后价',
  goodsType8: '货号-品名/颜色/内长/尺码/会员价/折扣/折后价',
  goodsType3: '货号-品名/颜色/内长/尺码/吊牌价',
  goodsType9: '货号-品名/颜色/内长/尺码/吊牌价/折扣/折后价',
  goodsType11: '货号-品类/颜色/内长/尺码',
  goodsType66: '货号-品类/颜色/内长/尺码/会员价/折后价',
  goodsType88: '货号-品类/颜色/内长/尺码/会员价/折扣/折后价',
  goodsType33: '货号-品类/颜色/内长/尺码/吊牌价',
  goodsType99: '货号-品类/颜色/内长/尺码/吊牌价/折扣/折后价',
  goodsType100: '货号-品名/颜色/内长/尺码/零售价/零售折扣/折后价',
  goodsType101: '货号-品类/颜色/内长/尺码/零售价/零售折扣/折后价',
  categoryReplaceName: '使用品类替换品名',
  uniqueReplaceBarcode: '使用唯一码替换条形码',
  Amt_mang: '满',
  Available: '可用',
  '渠道配置中心': '渠道配置中心',
  '单据打印样式管理': '单据打印样式管理',
  '配置样式请至渠道配置中心操作': '配置样式请至"渠道配置中心"操作',
  '单据': '单据',
  '新增简易版样式': '新增简易版样式',
  '新增定义版样式': '新增自定义版样式',
  '自定义版': '自定义版',
  '简易版': '简易版',
  '简易版编辑器': '简易版编辑器',
  '自定义编辑器': '自定义编辑器',
  '空样式': '样式',
  '样式名称': '样式名称',
  '样式文档名称': '样式文档名称',
  '输入样式文档名称': '输入样式文档名称',
  '建议备注宽度以便区分': '建议备注宽度以便区分',
  '图片大小不超过': '图片大小不超过',
  '选择单据': '选择单据',
  '选择模版': '选择模版',
  '空白模版': '空白模版',
  '请检查样式是否缺漏': '请检查样式是否缺漏',
  '您正在进行模版编辑操作, 是否放弃编辑?': '您正在进行模版编辑操作, 是否放弃编辑?',
  '销售单': '销售单',
  '定金单': '定金单',
  '日结': '日结',
  '交接班': '交接班',
  '本机日收银': '本机日收银',
  '充值单': '充值单',
  '调拨收货': '调拨收货',
  '采购收货': '采购收货',
  '渠道收货': '渠道收货',
  '渠道调拨': '渠道调拨',
  '渠道退货': '渠道退货',
  '仓库出货': '仓库出货',
  '渠道采购到货通知': '渠道采购到货通知',
  '渠道调出通知': '渠道调出通知',
  '退货通知': '退货通知',
  '渠道采购退货通知': '渠道采购退货通知',
  '线上订单发货': '线上订单发货',
  '收货单': '收货单',
  '成品采购入库单(基础)': '成品采购入库单(基础)',
  '发货单': '发货单',
  '采购退货': '采购退货',
  '紧急发货(基础)': '紧急发货(基础)',
  '配货单(基础)': '配货单(基础)',
  '发货退货(基础)': '发货退货(基础)',
  '到货通知单(基础)': '到货通知单(基础)',
  '采购退货(基础)': '采购退货(基础)',
  '采购退货通知(基础)': '采购退货通知(基础)',
  '验货(基础)': '验货(基础)',
  '自定义文本': '自定义文本',
  '模版名称': '模版名称',
  '模板已保存': '模板已保存',
  '可通过渠道配置中心配置渠道使用': '可通过"渠道配置中心"配置渠道使用',
  '选择样式': '选择样式',
  '税额': '税额',
  '显示税额': '显示税额',
  '买满立减(按单)': '买满立减(按单)',
  '买满打折(按货品)': '买满打折(按货品)',
  '买满送优惠券': '买满送优惠券',
  '顾客签名栏': '顾客签名栏',
  '打印太阳码': '打印太阳码',
  '显示顾客签名栏': '显示顾客签名栏',
  '显示已用代用券券号': '显示已用代用券券号',
  '已用代用券': '已用代用券',
  '折扣取反(适用于非中国大陆地区)': '折扣取反(适用于非中国大陆地区)',
  '会员姓名': '会员姓名',
  '会员等级': '会员等级',
  '营业员(货品)': '营业员(货品)',
  '代用券': '代用券',
  'A4显示货品营业员': 'A4显示货品营业员',
  '营业员': '营业员',
  '渠道调入': '渠道调入',
  '发货': '发货',
  '配单': '配单',
  '退货': '退货',
  '定金单号': '定金单号',
  '核销单号': '核销单号',
  'printCounterChannelAbb': '专柜(商场打印)',
  'printCounterChannelAbbs': '专柜',
  '活动说明': '活动说明',
  '显示赠送代用券活动说明': '显示赠送代用券活动说明',
  '请选择要编辑的模版': '请选择要编辑的模版',
  '批量打印': '批量打印',
  '顺丰面单打印': '顺丰面单打印',
  '零售配单验货': '零售配单验货',
  '销补发货': '销补发货',
  '收货工作台': '收货工作台',
  '线上订单工作台': '线上订单工作台',
  维修单: '维修单',
  补货: '补货',
  '发快递（影儿）': '发快递（影儿）',
  '价签打印': '价签打印'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/self.js
/*
 * @Author: JamesWong
 * @Description: 自助收银中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-03 16:05:06
 */
/* harmony default export */ var zh_cn_self = ({
  authorizedDevice: '授权设备',
  remainDevices: '剩余可用授权设备数',
  order: '序号',
  authorizationTime: '授权时间',
  machineNumber: '机器编码',
  machineCode: '设备机器码',
  operate: '操作',
  cancelAuthorization: '取消授权',
  cancelAuthorizeDevice: '取消授权设备',
  cancelAuthorizationTips: '确定取消授权设备',
  cancel: '取消',
  confirm: '确定',
  rollingPhotos: '轮播图片',
  uploadPhotosTips: '图片比例16：9，大小不超过5M',
  upload: '上传',
  previewPhotos: '预览图片',
  delete: '删除',
  deleted: '删除成功',
  createQRcode: '开卡二维码',
  uploadQRcodeTips: '图片比例1：1，大小不超过1M',
  uploadingTips: '文件正在上传中...  请稍等',
  uploadProgress: '上传进度',
  Unnamed: '未命名',
  photoUploaded: '上传图片成功！',
  phoneSizeTips: '文件大小不能超过1M！',
  phoneSizeTips5: '文件大小不能超过5M！',
  longNameTips: '文件名不能过长！',
  noPhotoTips: '你还没有上传图片，赶快上传吧',
  deletedError: '删除失败!',
  cancelAuthorized: '取消授权成功！'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/inout.js
/*
 * @Author: JamesWong
 * @Description: 物流配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-19 17:42:21
 */
/* harmony default export */ var inout = ({
  receive: '收货',
  deliver: '发货',
  inventory: '盘点',
  createInvoice: '自建单据',
  dispose: '配置',
  modelDisposition: '模块配置',
  modelName: '模块名称',
  enterModelnameTips: '请填写模块名称',
  modelId: '模块ID',
  enterModelIdTips: '请填写模块ID',
  noticeName: '通知单名称',
  noticeName1: '盘点单名称',
  enterNoticenameTips: '请填写通知单名称',
  enterNoticenameTips1: '请填写盘点单名称',
  noticeId: '通知单ID',
  noticeId1: '盘点单ID',
  enterNoticeIdTips: '请填写通知单ID',
  enterNoticeIdTips1: '请填写盘点单ID',
  confirm: '确定',
  cancel: '取消',
  noticeModelName: '通知单模块名称',
  noticeModelId: '通知单模块ID',
  operate: '操作',
  edit: '编辑',
  delete: '删除',
  stockCheckPlan: '盘点计划',
  stockCheckAnalysis: '盘点分析',
  stockChecklist: '盘点单',
  modelAddSuccess: '模块新增成功！',
  modelUpdateSuccess: '模块更新成功！',
  deliveryNotice: '发货通知单',
  replenishment: '补货'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/newSlip.js
/*
 * @Author: JamesWong
 * @Description: 3.2小票配置
 * @Date: 2019-01-04 14:59:12
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-07 11:40:21
 */
/* harmony default export */ var newSlip = ({
  confirm: '确定',
  cancel: '取消',
  channel: '渠道',
  order: '序号',
  edit: '编辑',
  defaults: '默认',
  Operation: '操作',
  templateName: '模板名称',
  enterTemplateName: '请输入模板名称',
  added: '新增',
  review: '预览',
  delete: '删除',
  filters: '渠道性质筛选',
  channelNumber: '渠道编号',
  createDeposit: '定金单',
  salesCreateReciept: '销售做单',
  account: '户口',
  pleaseSelectAgain: '请重新选择',
  channelRecipetConfiguration: '渠道小票配置',
  recipetTemplate: '小票模板',
  depositTemplate: '定金单模板',
  numberTemplate: '张数模板',
  channelType: '渠道性质',
  recipetStyle: '小票样式',
  saleVersion: '做单店铺/顾客联',
  reprintVersion: '重打印店铺/顾客联',
  selectChannelSettings: '选择渠道设置',
  setChannelType: '按渠道性质设置',
  setbyAccount: '按户口设置',
  channelSelected: '已选渠道',
  SaleNum: '店铺/顾客联张数',
  ReprintNum: '重打印-店铺/顾客联张数',
  selectChannel: '请选择渠道',
  saleRecipetNumberTemplate: '销售做单张数模板',
  depositRecipetNumberTemplate: '定金单张数模板',
  reprintNumberTemplate: '重打印张数模板',
  businessType: '业务类型',
  number: '张数',
  selectTips: '请先选择渠道在进行设置小票样式',
  setTips: '设置成功！',
  styleWarn: '请选择 "小票样式" 模板',
  sellWarn: '请选择 "销售做单-店铺/顾客联张数" 模板',
  sellWarn2: '请选择 "定金单-店铺/顾客联张数" 模板',
  reprintWarn: '请选择 "重打印-店铺/顾客联张数" 模板',
  noset: '暂无配置渠道性质',
  select: '已选择',
  numTypeSale: '小票-店铺联/顾客联',
  numTypeReprint: '重打印-店铺联/顾客联',
  deleteReceiptModel: '删除小票模板',
  deleteTips: '确定删除该小票模板？',
  addtips: '添加成功',
  edittips: '修改成功'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/contract.js
/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-26 16:58:06
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-11-02 13:05:01
 */
/* harmony default export */ var contract = ({
  '序号': '序号',
  '含扩容：': '含扩容：',
  'EPOS授权信息': 'EPOS授权信息',
  '汇总：': '汇总：',
  '剩余': '剩余',
  '绑定类型：': '绑定类型：',
  '剩余天数': '剩余天数',
  '操作': '操作',
  '查看': '查看',
  '店务': '店务',
  '店铺授权容量': '店铺授权容量',
  'WEB授权容量': 'WEB授权容量',
  '移动授权容量': '移动授权容量',
  '合同编号': '合同编号',
  '开始/结束时间': '开始/结束时间',
  'Android平板': 'Android平板',
  'Android手机': 'Android手机',
  'IPhone': 'IPhone',
  'IPAD': 'IPAD',
  'WEB': 'WEB',
  '授权信息': '授权信息',
  '查看变更记录': '查看变更记录',
  '店铺授权清单': '店铺授权清单',
  '设备归属清单': '设备归属清单',
  '新增授权店铺': '新增授权店铺',
  '管理': '管理',
  '数量': '数量',
  '已过期': '已过期',
  '未生效': '未生效',
  '不足一天': '不足一天',
  '管理所有店铺授权': '管理所有店铺授权',
  '管理所有归属设备': '管理所有归属设备',
  '关闭': '关闭',
  '授权全部渠道': '授权全部渠道',
  '确认授权所有店铺？': '确认授权所有店铺？',
  '操作日期': '操作日期',
  '类型': '类型',
  '操作内容': '操作内容',
  '操作人': '操作人',
  '店铺编号': '店铺编号',
  '店铺简称': '店铺简称',
  '店铺全称': '店铺全称',
  'WEB设备': 'WEB设备',
  '移动': '移动',
  '机器编号': '机器编号',
  '机器码': '机器码',
  '设备类型': '设备类型',
  '绑定类型': '绑定类型',
  '绑定日期': '绑定日期',
  '状态': '状态',
  '余量：': '余量：',
  '（含扩容：': '（含扩容：',
  '该店铺不存在或已授权': '该店铺不存在或已授权',
  '请输入': '请输入',
  '授权设备类型': '授权设备类型',
  '绑定状态': '绑定状态',
  '请选择': '请选择',
  '筛选': '筛选',
  '清空': '清空',
  '返回': '返回',
  '设备绑定列表': '设备绑定列表',
  '解除授权': '解除授权',
  '移出黑名单': '移出黑名单',
  '加入黑名单': '加入黑名单',
  '全选': '全选',
  '提示': '提示',
  '取消': '取消',
  '确定': '确定',
  '正常': '正常',
  '白名单': '白名单',
  '黑名单': '黑名单',
  '激活码': '激活码',
  '安卓手机': '安卓手机',
  '安卓平板': '安卓平板',
  '禁用': '禁用',
  '启用': '启用',
  'EPOS版本': 'EPOS版本',
  '企业': '企业',
  '企业编号': '企业编号',
  '设备机型': '设备机型',
  '系统版本号': '系统版本号',
  'EPOS版本号': 'EPOS版本号',
  '解除往期的激活码/店铺容量绑定，避免影响店铺pos数量超出限额，确认提示框提醒是否继续操作': '解除往期的激活码/店铺容量绑定，避免影响店铺pos数量超出限额，确认提示框提醒是否继续操作',
  '允许登陆pos': '允许登陆pos',
  '释放往期的激活码/店铺容量': '释放往期的激活码/店铺容量',
  '限制登陆pos，需解除绑定激活码、解除店铺归属，是否继续操作': '限制登陆pos，需解除绑定激活码、解除店铺归属，是否继续操作',
  '是否解除绑定': '是否解除绑定',
  '解除绑定': '解除绑定',
  '是否': '是否',
  '解绑成功': '解绑成功',
  '店铺授权': '店铺授权',
  '新增店铺授权': '新增店铺授权',
  '总量': '总量',
  '授权日期': '授权日期',
  '合同编号：': '合同编号：',
  '请输入合同编号': '请输入合同编号',
  '店铺编号：': '店铺编号：',
  '请输入店铺编号': '请输入店铺编号',
  '店铺授权列表': '店铺授权列表',
  'WEB限额': 'WEB限额',
  'WEB限额余量': 'WEB限额余量',
  '移动限额': '移动限额',
  '移动限额余量': '移动限额余量',
  '扩容': '扩容',
  '移动扩容:': '移动扩容',
  'WEB扩容:': 'WEB扩容',
  '扩容成功': '扩容成功',
  '将影响已授权的店铺登录，是否确定调整': '将影响已授权的店铺登录，是否确定调整',
  '登录记录查看': '登录记录查看',
  '请输入收银员名称': '请输入收银员名称',
  '请输入机器编号': '请输入机器编号',
  '请输入版本号': '请输入版本号',
  '至': '至',
  '开始日期': '开始日期',
  '结束日期': '结束日期',
  '搜索': '搜索',
  '登录时间': '登录时间',
  '收银员': '收银员',
  '门店': '门店',
  '设备型号': '设备型号',
  '系统版本': '系统版本',
  '经纬度': '经纬度',
  '定位地址': '定位地址',
  '最近一周': '最近一周',
  '最近一个月': '最近一个月',
  '最近三个月': '最近三个月',
  'Iphone': 'Iphone',
  'Ipad': 'Ipad',
  'WEB已用': 'WEB已用',
  '移动已用': '移动已用',
  '调整限额': '调整限额',
  '收银': '收银',
  '物流': '物流',
  '公告': '公告',
  '储位': '储位',
  '其他': '其他',
  '授权模块': '授权模块',
  '清理闲置设备': '清理闲置设备',
  '最近登录日期': '最近登录日期',
  '未登录天数': '未登录天数',
  '机器编码': '机器编码',
  '未登录天数大于': '未登录天数大于',
  '请输入店铺简称': '请输入店铺简称',
  '解除全部': '解除全部',
  '请输入或选择': '请输入或选择',
  '解绑全部': '解绑全部',
  '将批量解绑所有设备，是否确认操作': '将批量解绑所有设备，是否确认操作',
  // 4.2
  '设备变更记录': '设备变更记录',
  '操作时间': '操作时间',
  '收营员编号': '收营员编号',
  '操作状态': '操作状态',
  '请输入收银员账号': '请输入收银员账号',
  '设备解绑记录': '设备解绑记录',
  '收银员帐号': '收银员帐号',
  '合同变更记录': '合同变更记录',
  '不限': '不限',
  '设备归属列表': '设备归属列表',
  '创建合同': '创建合同',
  '合同初始化': '合同初始化',
  '更新设备授权': '更新设备授权',
  '更新店铺数量': '更新店铺数量',
  '续约': '续约',
  '模块配置': '模块配置',
  '更新Webpos数量': '更新Webpos数量',
  '移动POS数量': '移动POS数量',
  '授权店铺数量': '授权店铺数量',
  '更新合同服务日期': '更新合同服务日期',
  '店铺': '店铺',
  'Webpos最高限额': 'Webpos最高限额',
  '请输入限额': '请输入限额',
  '移动POS限额': '移动POS限额',
  '请输入本期授权的店铺总量': '请输入本期授权的店铺总量',
  '请输入本期授权的数量': '请输入本期授权的数量',
  '授权的数量必须为正整数': '授权的数量必须为正整数',
  'Webpos最高限额不能低于': 'Webpos最高限额不能低于',
  '不能低于': '不能低于',
  '归属店铺': '归属店铺',
  '全部': '全部',
  '取消归属': '取消归属',
  'Webpos限额': 'Webpos限额',
  '合同类型': '合同类型',
  '租用': '租用',
  '购买': '购买',
  '导出': '导出',
  '文件大小不能超过1M！': '文件大小不能超过1M！',
  '设备在线监管': '设备在线监管',
  '设备状态': '设备状态',
  '强制下线': '强制下线',
  '在线': '在线',
  '离线': '离线',
  '收银员编号': '收银员编号',
  '收银员名称': '收银员名称',
  '上线时间': '上线时间',
  '下线时间': '下线时间',
  '上/下线时间': '上/下线时间',
  '操作成功': '操作成功',
  '机器号': '机器号',
  '查询': '查询',
  'Android': 'Android'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/note.js
/* harmony default export */ var note = ({
  '短信设置': '短信设置',
  '返回': '返回',
  '短信模版': '短信模版',
  '查看流水': '查看流水',
  '短信供应商平台': '短信供应商平台',
  '供应商': '供应商',
  '账号': '账号',
  '密码': '密码',
  '取消': '取消',
  '确定': '确定',
  '编辑模板': '编辑模板',
  '保存': '保存',
  '短信模板预览': '短信模板预览',
  '短信模板编辑区': '短信模板编辑区',
  '不同短信供应商对短信字数限制不一，可能存在字数溢出的情况，请酌情规划模板字数': '不同短信供应商对短信字数限制不一，可能存在字数溢出的情况，请酌情规划模板字数',
  '基本信息取值区': '基本信息取值区',
  '点击将标签插入模板，短信会根据标签写入实际数值': '点击将标签插入模板，短信会根据标签写入实际数值',
  '验证码': '验证码',
  '提示': '提示',
  '若模板没有保存，直接返回会丢失已修改的模板哦。确定吗？': '若模板没有保存，直接返回会丢失已修改的模板哦。确定吗？',
  '功能类型': '功能类型',
  '短信类型': '短信类型',
  '短信属性': '短信属性',
  '操作': '操作',
  '全局': '全局',
  '渠道': '渠道',
  '开卡': '开卡',
  '储值卡': '储值卡',
  '消费': '消费',
  '其他': '其他',
  '开卡手机验证码': '开卡手机验证码',
  '开卡成功提醒': '开卡成功提醒',
  '会员储值卡使用验证码': '会员储值卡使用验证码',
  '会员储值卡充值成功提醒': '会员储值卡充值成功提醒',
  '会员储值卡消费成功提醒': '会员储值卡消费成功提醒',
  '会员积分使用验证码': '会员积分使用验证码',
  '会员积分充值成功提醒': '会员积分充值成功提醒',
  '会员积分消费成功提醒': '会员积分消费成功提醒',
  '特殊会员VIP折扣使用': '特殊会员VIP折扣使用',
  '高级折扣权限短信验证码': '高级折扣权限短信验证码',
  '消费成功提醒': '消费成功提醒',
  '定金单下单成功提醒': '定金单下单成功提醒',
  '修改会员手机号成功提醒': '修改会员手机号成功提醒',
  '会员等级变动提醒': '会员等级变动提醒',
  '停用': '停用',
  '启用': '启用',
  '未开通短信服务': '未开通短信服务',
  '请联系信息部门': '请联系信息部门',
  '店铺': '店铺',
  '搜索': '搜索',
  '店铺编号': '店铺编号',
  '店铺名称': '店铺名称',
  '知道了': '知道了',
  '快捷设置': '快捷设置',
  '刷新促销': '刷新促销',
  'Web端使用ERP物流模块': 'Web端使用ERP物流模块',
  '模板内容': '模板内容',
  '模板方案': '模板方案',
  '同步ERP渠道资料': '同步ERP渠道资料',
  '未审核': '未审核',
  '审核中': '审核中',
  '审核通过': '审核通过',
  '审核失败': '审核失败',
  '添加账号': '添加账号',
  '确认删除该短信模板吗？': '确认删除该短信模板吗？',
  '删除': '删除',
  '重命名': '重命名',
  '默认': '默认',
  '国际': '国际',
  '中文': '中文',
  '未配置模板的渠道将按默认模板发送短信': '未配置模板的渠道将按默认模板发送短信',
  '确认切换默认模板吗？': '确认切换默认模板吗？',
  '添加模板': '添加模板',
  '审核状态': '审核状态',
  '添加中文模板': '添加中文模板',
  '添加国际模板': '添加国际模板',
  '申请说明': '申请说明',
  '确认删除该短信签名吗？': '确认删除该短信签名吗？',
  '默认签名': '默认签名',
  '审核备注': '审核备注',
  '签名来源': '签名来源',
  '签名名称': '签名名称',
  '添加短信签名': '添加短信签名',
  '短信签名': '短信签名',
  '请在申请说明中 详细描述您的业务使⽤场景，申请⼯信部备案⽹站的全称或简称请在此处填写域名，长度不超过200个字符': '请在申请说明中 详细描述您的业务使⽤场景，申请⼯信部备案⽹站的全称或简称请在此处填写域名，长度不超过200个字符',
  '请输入签名名称': '请输入签名名称',
  '当前⽀持jpg、png、gif或 jpeg格式的图⽚。': '当前⽀持jpg、png、gif或 jpeg格式的图⽚。',
  '签名的证明⽂件格式，⽀持上传多张图⽚。': '签名的证明⽂件格式，⽀持上传多张图⽚。',
  '图片不超过2M': '图片不超过2M',
  '提交审核': '提交审核',
  '证明文件': '证明文件',
  '短信供应商设置': '短信供应商设置',
  '短信签名未设置': '短信签名未设置',
  '短信将无法发送': '短信将无法发送',
  '同步阿里云短信签名': '同步阿里云短信签名',
  '渠道(批量)选择': '渠道(批量)选择',
  '查询': '查询',
  '渠道编号': '渠道编号',
  '请输入渠道编号': '请输入渠道编号',
  '支持配置小票样式&打印张数、短信模板': '支持配置小票样式&打印张数、短信模板',
  '渠道简称': '渠道简称',
  '请输入渠道简称': '请输入渠道简称',
  '经营模式': '经营模式',
  '经营方式': '经营方式',
  '输入或选择': '输入或选择',
  '公司': '公司',
  '组': '组',
  '国家': '国家',
  '销售类别': '销售类别',
  '渠道配置（已选择': '渠道配置（已选择',
  '复制渠道配置（已选择': '复制渠道配置（已选择',
  '个渠道': '个渠道',
  '单据打印样式': '单据打印样式',
  '单据': '单据',
  '销售单': '销售单',
  '定金单': '定金单',
  '会员充值单': '会员充值单',
  '日结': '日结',
  '交接班': '交接班',
  '本机日收银': '本机日收银',
  '发货单': '发货单',
  '单据打印张数': '单据打印张数',
  '已选择': '已选择',
  '状态': '状态',
  '短信模板': '短信模板',
  '会员等级变动升级提醒': '会员等级变动升级提醒',
  '选择短信模板': '选择短信模板',
  '模版方案': '模版方案',
  '模版内容': '模版内容',
  '阿里云短信签名': '阿里云短信签名',
  '选择短信签名': '选择短信签名',
  '保存成功': '保存成功',
  '打印张数': '打印张数',
  '输入张数': '输入张数',
  '做单打印': '做单打印',
  '店铺联': '店铺联',
  '客户联': '客户联',
  '张数': '张数',
  '不能全部为零': '不能全部为零',
  '请填写完整的张数': '请填写完整的张数',
  '选择样式': '选择样式',
  '简易版': '简易版',
  '简易版支持全部终端': '简易版支持全部终端',
  '类型': '类型',
  '自定义版': '自定义版',
  '样式名称': '样式名称',
  '预览': '预览',
  '自定义版仅支持Webpos优先使用': '自定义版仅支持Webpos优先使用',
  '变更记录': '变更记录',
  '销售单小票': '销售单小票',
  '定金单小票': '定金单小票',
  '充值单': '充值单',
  '请先选择模版': '请先选择模版',
  '再保存': '再保存',
  '充值单据': '充值单据',
  '500条/页': '500条/页',
  '第': '第',
  '页': '页',
  '共': '共',
  '没有可选的数据': '没有可选的数据',
  '渠道配置中心': '渠道配置中心',
  '支持配置小票样式&打印张支持配置小票样式数、短信模板': '',
  '配置说明': '配置说明',
  '配置后，POS需重新登录后生效': '配置后，POS需重新登录后生效',
  '渠道(批量)': '渠道(批量)',
  '请输入内容': '请输入内容',
  '选项': '选项',
  '清空': '清空',
  '列表': '列表',
  '编辑': '编辑',
  '户口': '户口',
  '批量配置单据打印样式': '批量配置单据打印样式',
  '批量配置单据打印张数': '批量配置单据打印张数',
  '批量配置短信模板': '批量配置短信模板',
  '复制其他渠道模板': '复制其他渠道模板',
  '会员充值小票': '会员充值小票',
  '日结小票': '日结小票',
  '交接班小票': '交接班小票',
  '本机日收银小票': '本机日收银小票',
  '发货单小票': '发货单小票',
  '做单打印张数 店铺联/客户联': '做单打印张数 店铺联/客户联',
  '重打印张数 店铺联/客户联': '重打印张数 店铺联/客户联',
  '未选择业务属性': '未选择业务属性',
  '请选择渠道': '请选择渠道',
  '同步ERP渠道资料成功！': '同步ERP渠道资料成功！',
  '系统默认模版': '系统默认模版',
  '做单': '做单',
  '企事业单位的全称或简称': '企事业单位的全称或简称',
  '工信部备案网站的全称或简称': '工信部备案网站的全称或简称',
  'APP应用的全称或简称': 'APP应用的全称或简称',
  '公众号或小程序的全称或简称': '公众号或小程序的全称或简称',
  '电商平台店铺名的全称或简称': '电商平台店铺名的全称或简称',
  '商标名的全称或简称': '商标名的全称或简称',
  '请输入签名来源': '请输入签名来源',
  '请输入签名说明': '请输入签名说明',
  '重新上传成功': '重新上传成功',
  '添加成功': '添加成功',
  '上传图片不能大于2M': '上传图片不能大于2M',
  '短信模板数量不能超过10个': '短信模板数量不能超过10个',
  '请输入名称': '请输入名称',
  '保存后': '保存后',
  '模版将提交审核，': '模版将提交审核，',
  '审核通过前短信模版无法使用，确认吗？': '审核通过前短信模版无法使用，确认吗？',
  '已经存在该字段，不可重复添加': '已经存在该字段，不可重复添加',
  '请选择要编辑的模版': '请选择要编辑的模版',
  '保存置灰且点击提示“审核中”“审核通过”模板不可修改': '保存置灰且点击提示“审核中”“审核通过”模板不可修改',
  '删除成功': '删除成功',
  '超过最大字数': '超过最大字数',
  '模版中含有非法取值字段，请先删除再保存': '模版中含有非法取值字段，请先删除再保存',
  '短信模板不能为空！': '短信模板不能为空！',
  '短信模板缺少验证码！': '短信模板缺少验证码！',
  '短信模板保存成功': '短信模板保存成功',
  '重命名成功': '重命名成功',
  '同步阿里云签名': '同步阿里云签名',
  '输入在阿里云后台注册的签名名称，同步至企业管理后台': '输入在阿里云后台注册的签名名称，同步至企业管理后台',
  '签名名称不能为空': '签名名称不能为空',
  '同步签名成功': '同步签名成功',
  '更新默认签名成功': '更新默认签名成功',
  '删除签名成功': '删除签名成功',
  '序': '序',
  '配置': '配置',
  '请勿轻易切换供应商，审核状态将会被重置！': '请勿轻易切换供应商，审核状态将会被重置！',
  '区域': '区域',
  '省份': '省份',
  '渠道性质': '渠道性质',
  '店铺联/顾客联打印张数不能全部为0': '店铺联/顾客联打印张数不能全部为0',
  '销售退款（储值积分返还）提醒': '销售退款（储值积分返还）提醒',
  '渠道调出': '渠道调出',
  '重打印': '重打印',
  '渠道退货': '渠道退货',
  '采购退货': '采购退货',
  '退货通知': '退货通知',
  '是否保存模板？': '是否保存模板？',
  '积分': '积分',
  '线上订单发货': '线上订单发货',
  '渠道调入': '渠道调入',
  '渠道收货': '渠道收货',
  '退货': '退货',
  '紧急发货': '紧急发货',
  '发货': '发货',
  '配单': '配单',
  '验货': '验货',
  '全部': '全部',
  '配置教学': '配置教学',
  '已配置短信渠道': '已配置短信渠道',
  '已开启ERP权限': '已开启ERP权限',
  '未开启ERP权限': '未开启ERP权限',
  '配置了该短信模板且已开通ERP权限的渠道，可正常使用短信功能': '配置了该短信模板且已开通ERP权限的渠道，可正常使用短信功能',
  '配置了该模板但未开通ERP权限的渠道,请前往ERP渠道资料开通权限': '配置了该模板但未开通ERP权限的渠道,请前往ERP渠道资料开通权限',
  '短信配置主要为以下流程': '短信配置主要为以下流程',
  '设置好短信签名，提交供应商审核（部分供应商无需配置签名）': '设置好短信签名，提交供应商审核（部分供应商无需配置签名）',
  '点击短信类型右侧的编辑模板，保存后提交供应商审核': '点击短信类型右侧的编辑模板，保存后提交供应商审核',
  '到': '到',
  '开通渠道': '开通渠道',
  '重新上传': '重新上传',
  '给不同渠道配置对应模板': '给不同渠道配置对应模板',
  '前往ERP渠道资料，开启所有渠道的短信发送权限': '前往ERP渠道资料，开启所有渠道的短信发送权限',
  '请先选择模版再保存': '请先选择模版再保存',
  '全部数据导入成功': '全部数据导入成功',
  '零售方式': '零售方式',
  '积分清零提醒': '积分清零提醒',
  '生日代用券': '生日代用券',
  '短信签名一般为品牌名称，顾客短信可见，必填': '短信签名一般为品牌名称，顾客短信可见，必填',
  '请填写短信签名': '请填写短信签名',
  '若清空供应商，可能会丢失原有短信供应商的模板审核状态，请谨慎操作': '若清空供应商，可能会丢失原有短信供应商的模板审核状态，请谨慎操作。',
  '查询结果': '查询结果',
  '搜索渠道': '搜索渠道',
  '重置': '重置',
  '条': '条',
  '100条/页': '100/行',
  '200条/页': '200/行',
  '300条/页': '300/行',
  '400条/页': '400/行',
  '请输入账号': '请输入账号',
  '输入账号': '输入账号',
  '请输入密码': '请输入密码',
  '输入密码': '输入密码',
  '账号不能为空': '账号不能为空',
  '同步ERP收银员': '同步ERP收银员',
  '使用教程': '使用教程',
  '不记名储值卡余额变动提醒': '不记名储值卡余额变动提醒',
  '不记名储值卡开卡成功提醒': '不记名储值卡开卡成功提醒',
  '不记名卡使用验证': '不记名卡使用验证',
  '打印单据张数': '打印单据张数',
  '打印快递单张数': '打印快递单张数',
  '打印快递单': '打印快递单',
  '打印单据': '打印单据',
  '更新版本': '更新版本',
  '更新版本成功': '更新版本成功',
  '大版本号': '大版本号',
  '忘记密码发送随机密码提醒': '忘记密码发送随机密码提醒',
  '修改密码成功提醒': '修改密码成功提醒',
  'VIP积分兑换货品短信验证': 'VIP积分兑换货品短信验证'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/collaboraivePlatform.js
/*
 * @Author: yangchong
 * @Description: 协同办公多语言配置包
 * @Date: 2019-11-30 15:15:06
 */
/* harmony default export */ var collaboraivePlatform = ({
  '序号': '序号',
  '其他平台': '其他平台',
  '自动获取': '自动获取',
  '丽晶360终端物流': '丽晶360终端物流',
  'POS自动填充收银员账号&密码': 'POS自动填充收银员账号&密码',
  '协同平台设置': '协同平台设置',
  '平台名称': '平台名称',
  '网址': '网址',
  '输入平台名称': '输入平台名称',
  '输入网址': '输入网址',
  '需填写http': '需填写http',
  '确定删除该记录吗？': '确定删除该记录吗？',
  '新增成功': '新增成功',
  '保存成功': '保存成功',
  '请输入平台名称': '请输入平台名称',
  '请输入网址': '请输入网址',
  '请输入正确的网址': '请输入正确的网址',
  '删除成功': '删除成功',
  '新增': '新增',
  '储位系统': '储位系统',
  '店铺储位管理系统': '店铺储位管理系统',
  '自定义排序': '自定义排序',
  '是否取消自定义排序？': '是否取消自定义排序？',
  '已经是第一条，不可上': '已经是第一条，不可上',
  '已经是最后一条，不可下移': '已经是最后一条，不可下移',
  '修改成功': '修改成功',
  '取消': '取消',
  '保存': '保存',
  '平台类型': '平台类型',
  '外挂': '外挂',
  'RP': 'RP'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/report.js
/* harmony default export */ var report = ({
  '报表类型': '报表类型',
  '方案配置': '方案配置',
  '添加方案': '添加方案',
  '将报表方案配置至相应设备类型': '将报表方案配置至相应设备类型',
  '手机/平板': '手机/平板',
  '电脑': '电脑',
  '剩余可用字段': '剩余可用字段',
  '当前使用字段': '当前使用字段',
  '可长按拖动排序': '可长按拖动排序',
  '基础': '基础',
  '提示': '提示',
  '取消': '取消',
  '确定': '确定',
  '重命名': '重命名',
  '请输入方案名': '请输入方案名',
  '当前方案正在使用中，无法删除！': '当前方案正在使用中，无法删除！',
  '确认删除该方案吗？': '确认删除该方案吗？',
  '确认将该方案应用于电脑端吗？': '确认将该方案应用于电脑端吗？',
  '确认将该方案应用于手机/平板端吗？': '确认将该方案应用于手机/平板端吗？',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗?': '未保存方案的情况下退出会丢失已操作的记录。确认退出吗?',
  '执行该操作会刷新页面,请确认右侧方案字段配置操作已保存': '执行该操作会刷新页面,请确认右侧方案字段配置操作已保存',
  '确定删除后会刷新页面，请确认右侧字段已保存': '确定删除后会刷新页面，请确认右侧字段已保存',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗？': '未保存方案的情况下退出会丢失已操作的记录。确认退出吗？',
  '确定命名后会刷新页面，请确认右侧字段已保存': '确定命名后会刷新页面，请确认右侧字段已保存',
  '确定应用后会刷新页面，请确认右侧字段已保存': '确定应用后会刷新页面，请确认右侧字段已保存',
  '报表方案配置': '报表方案配置',
  '方案保存成功': '方案保存成功',
  '方案重命名成功': '方案重命名成功',
  '设备类型激活成功': '设备类型激活成功',
  '删除方案成功': '删除方案成功',
  '添加成功': '添加成功',
  '保存': '保存'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/receipt.js
/* harmony default export */ var receipt = ({
  '渠道调拨': '渠道调拨',
  '单据编号': '单据编号',
  '手工单号': '手工单号',
  '发货单位': '发货单位',
  '收货单位': '收货单位',
  '单据日期': '单据日期',
  '打印人': '打印人',
  '打印时间': '打印时间',
  '备注': '备注',
  '货号': '货号',
  '品名': '品名',
  '颜色编号': '颜色编号',
  '颜色': '颜色',
  '内长': '内长',
  '数量': '数量',
  '吊牌价': '吊牌价',
  '吊牌额': '吊牌额',
  '发出方签': '发出方签',
  '日期': '日期',
  '接收方签': '接收方签',
  '店长复核': '店长复核',
  '竖排': '竖排',
  '横排': '横排',
  '店铺编码': '店铺编码',
  '店铺名称': '店铺名称',
  '日结日期': '日结日期',
  '销售单情况': '销售单情况',
  '销售金额': '销售金额',
  '计收入': '计收入',
  '销售数量': '销售数量',
  '销售单数': '销售单数',
  '销售单退货情况': '销售单退货情况',
  '退货金额': '退货金额',
  '退货数量': '退货数量',
  '退货单数': '退货单数',
  '销售单付款情况': '销售单付款情况',
  '储值卡充值情况': '储值卡充值情况',
  '实收金额': '实收金额',
  '赠送金额': '赠送金额',
  '充值笔数': '充值笔数',
  '所有付款方式汇总': '所有付款方式汇总',
  '班次': '班次',
  '生意额': '生意额',
  '期初': '期初',
  '销售现金': '销售现金',
  '银行存款': '银行存款',
  '现金调整': '现金调整',
  '期末': '期末',
  '销售金额（计收入）': '销售金额（计收入）',
  '服务费付款情况': '服务费付款情况',
  '服务费金额': '服务费金额',
  '服务费数量': '服务费数量',
  '服务费单数': '服务费单数',
  '服务费退款情况': '服务费退款情况',
  '服务费退款': '服务费退款',
  '退款金额': '退款金额',
  '退款数量': '退款数量',
  '退款单数': '退款单数',
  '充值金额': '充值金额',
  '笔': '笔',
  '合计': '合计',
  '渠道': '渠道',
  '收银': '收银',
  '销售日期': '销售日期',
  '付款方式': '付款方式',
  '金额': '金额',
  '充值单据': '充值单据',
  '颜色/内长': '颜色/内长',
  '尺码': '尺码',
  '货品': '货品',
  '会员价': '会员价',
  '折扣': '折扣',
  '会员': '会员',
  '折后价': '折后价',
  '税额': '税额',
  '折扣/折后价': '折扣/折后价',
  '税额/金额': '税额/金额',
  '获得积分': '获得积分',
  '储值余额': '储值余额',
  '积分余额': '积分余额',
  '充值时间': '充值时间',
  '服务费': '服务费'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/home.js
/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-26 16:58:06
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-08 11:51:58
 */
/* harmony default export */ var home = ({
  '云POS模块价格说明': '云POS模块价格说明',
  '功能模块': '功能模块',
  '配置化模块': '配置化模块',
  'SAAS租用': 'SAAS租用',
  '购买': '购买',
  '云POS硬件支持情况': '云POS硬件支持情况',
  '物流模块': '物流模块',
  '基础物流模块': '基础物流模块',
  'O2O物流模块': 'O2O物流模块',
  '365/年': '365/年',
  '199/年': '199/年',
  '600元+100元综合维护费/年': '600元+100元综合维护费/年',
  '200元+100元综合维护费/年': '200元+100元综合维护费/年',
  '收银模块': '收银模块',
  '云POS（物流+收银）': '云POS（物流+收银）',
  '730/年': '730/年',
  '1200元+200元综合维护费/年': '1200元+200元综合维护费/年',
  '900/年': '900/年',
  '1400元+200元综合维护费/年': '1400元+200元综合维护费/年',
  '联系我们': '联系我们',
  '总部:': '总部',
  '地址': '地址',
  '电话': '电话',
  '邮箱': '邮箱',
  '客服中心:': '客服中心',
  '犀牛EPOS · PC版': '犀牛EPOS · PC版',
  '全新上线，给你最美、最流畅的店铺Pos体验': '全新上线，给你最美、最流畅的店铺Pos体验',
  '下载最新版': '下载最新版',
  '运行环境：Win7或更高版本': '运行环境：Win7或更高版本',
  '品牌Webpos下载': '品牌Webpos下载',
  '下载最新定制版': '下载最新定制版',
  '更多': '更多',
  '历史版本': '历史版本',
  '下载该版本': '下载该版本',
  '收银': '收银',
  '物流': '物流',
  '报表': '报表',
  '查会员': '查会员',
  '犀牛EPOS': '犀牛EPOS',
  '产品': '产品',
  '客户': '客户',
  'PC版下载': 'PC版下载',
  '移动版下载': '移动版下载',
  '智慧零售 赋能门店': '智慧零售 赋能门店',
  '为您提供新零售所需要的一切': '为您提供新零售所需要的一切',
  '销售退换货': '销售退换货',
  '预售/赠送': '预售/赠送',
  '流行促销': '流行促销',
  '会员/积分': '会员/积分',
  '储值/券': '储值/券',
  '收发货': '收发货',
  '盘点': '盘点',
  '电商发货/退货': '电商发货/退货',
  '真正的移动收银神器': '真正的移动收银神器',
  '商米/PDA/平板/手机': '商米/PDA/平板/手机',
  '专为服饰零售行业客户而生': '专为服饰零售行业客户而生',
  '广州丽晶软件科技股份有限公司致力做最杰出的服饰管理专家，着意创建先进、精简、实用高效的电脑信息管理系统，用专注、创新见证着中国服装产业信息化发展进程。丽晶不仅仅要让企业在标准化的行业体系之中占有一席之地，达到灵活调度企业资源，快速感知市场变化，准确规划运营策略，实现销售增长的目的，更要竭尽全力增强服饰企业本身的独特竞争力，指引应用者凭添果敢的能力，激发决策者闪现睿智的灵感，在现在和未来发展与竞争中不断超越！': '广州丽晶软件科技股份有限公司致力做最杰出的服饰管理专家，着意创建先进、精简、实用高效的电脑信息管理系统，用专注、创新见证着中国服装产业信息化发展进程。丽晶不仅仅要让企业在标准化的行业体系之中占有一席之地，达到灵活调度企业资源，快速感知市场变化，准确规划运营策略，实现销售增长的目的，更要竭尽全力增强服饰企业本身的独特竞争力，指引应用者凭添果敢的能力，激发决策者闪现睿智的灵感，在现在和未来发展与竞争中不断超越！',
  '下载': '下载',
  '全国热线': '全国热线',
  '周一至周五 9:00-18:00': '周一至周五 9:00-18:00',
  '公司邮箱': '公司邮箱',
  '粤ICP备12071402号-7': '粤ICP备12071402号-7',
  '粤ICP备12071402号': '粤ICP备12071402号',
  '关于我们': '关于我们',
  '扫码下载，货品管理尽在掌中': '扫码下载，货品管理尽在掌中',
  '安卓平板下载': '安卓平板下载',
  '安卓手机下载': '安卓手机下载',
  'iPhone下载': 'iPhone下载',
  'iPad下载': 'iPad下载',
  '品牌订制下载': '品牌订制下载',
  '总部': '',
  '传真': '传真',
  '点击下载': '点击下载',
  '犀牛EPOS · 定制版': '犀牛EPOS · 定制版',
  '移动端': '移动端',
  '安卓手机': '安卓手机',
  '安卓平板': '安卓平板',
  '企业后台登录': '企业后台登录',
  '运营管理后台': '运营管理后台',
  '定制版下载': '定制版下载',
  '南京市中山东路18号国际贸易中心12层C3座': '南京市中山东路18号国际贸易中心12层C3座',
  '广州番禺区番禺大道北555号天安节能科技园15号楼102': '广州番禺区番禺大道北555号天安节能科技园15号楼102'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/notice.js
/* harmony default export */ var notice = ({
  moduleName: '公告管理'
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/index.js
/*
 * @Author: JamesWong
 * @Description: 简体中文包主入口
 * @Date: 2018-11-29 10:28:01
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-07 01:40:21
 */



















/* harmony default export */ var zh_cn = ({
  main: main,
  home: home,
  receipt: receipt,
  appversion: appversion,
  channel: channel,
  warehouse: warehouse,
  activeCode: activeCode,
  account: account,
  payment: payment,
  screen: screen,
  slip: slip,
  self: zh_cn_self,
  note: note,
  inout: inout,
  newSlip: newSlip,
  contract: contract,
  collaboraivePlatform: collaboraivePlatform,
  report: report,
  notice: notice
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/main.js
/*
 * @Author: JamesWong
 * @Description: 首页繁体
 * @Date: 2018-11-29 10:34:46
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-13 13:13:03
 */

/* harmony default export */ var zh_hant_main = ({
  productName: '犀牛EPOS企業管理後臺',
  companyNo: '企業編號',
  companyEnterTips: '請輸入企業編號',
  account: '登錄帳號',
  accountEnterTips: '請輸入登錄帳號',
  password: '輸入密碼',
  '剩余天数': '，剩余天數',
  passwordEnterTips: '請輸入密碼',
  login: '登錄',
  Logout: '退出',
  backHome: '返回首頁',
  openedService: '已開通的服務',
  sellModel: '收銀模組',
  foundational: '基礎物流',
  appVersion: '應用版本',
  authChannel: '授權店鋪',
  allAuthChannel: '總授權店鋪數',
  authWarehouse: '授權倉庫',
  authMumber: '已授權數',
  remainAuthNum: '剩餘可授權數',
  whalesaleSelected: '批發零售版選用',
  deviceActivateManagement: '設備啟動管理',
  subScreen: '副屏交互設置',
  displayMode: '顯示模式',
  rollingDisplay: '輪播圖片',
  advertisementVideo: '廣告視頻',
  ticketDisposition: '小票配置',
  selfcashierDisposition: '自收銀配置',
  onlinePayDisposition: '線上支付配置',
  accountModule: '帳戶',
  foundationalSet: '物流模組配置',
  depositReceipt: '定金單配置',
  loginNumTips: '企業編號不能為空！',
  loginAccountTips: '登錄帳號不能為空！',
  alipayCall: '完成授權，請回到犀牛EPOS管理後臺查看授權結果',
  noSet: '未配置, 物流功能不能正常使用',
  storeAuthorizaedManage: '店鋪授權管理',
  manageAllFacility: '設備歸屬管理',
  record: '門店登錄記錄',
  authorizedMessage: '授權信息',
  '收银模块': '收銀模塊',
  '物流模块': '物流模塊',
  '其他': '其他',
  changeLog: '設備變更記錄',
  'deviceChangeLog': '設備變更記錄',
  'deviceUntiedLog': '設備解綁記錄',
  'Web端使用ERP物流模块': 'Web端使用ERP物流模塊',
  collaboraivePlatformSet: '協同平臺設置',
  styleTicketManager: '單據打印樣式管理',
  '查看合同': '查看合同'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/appversion.js
/*
 * @Author: JamesWong
 * @Description: 应用版本繁体包
 * @Date: 2018-11-29 15:14:04
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-29 20:20:05
 */
/* harmony default export */ var zh_hant_appversion = ({
  appVersion: '應用版本',
  backstageVersion: '後臺版本',
  enabledIOSVersion: '可使用的IOS版本',
  enabledAndroidVersion: '可使用的安卓版本',
  enabledPadVersion: '可使用的安卓平板版本',
  versionUpdateDesc: '版本更新說明',
  downloadQRcode: '下載二維碼',
  downloadAddress: '下載地址',
  downloadArticle: '詳細反覆運算推文',
  '版本详情': '版本詳情',
  '下载': '下載',
  Close: '关闭',
  '点击详情': '点击详情',
  '未启用': '未启用',
  '可联系商务开通': '可联系商务开通',
  '下载链接': '下载链接'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/channel.js
/*
 * @Author: JamesWong
 * @Description: 授权店铺繁体包
 * @Date: 2018-11-29 17:15:51
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-07-30 10:02:21
 */
/* harmony default export */ var zh_hant_channel = ({
  authorizedChannel: '已授權店鋪',
  deletedStore: '刪除店鋪',
  hint: '提示',
  deletedStoreTips: '刪除後該店鋪將不能使用POS登陸,確定刪除該店鋪嗎?',
  cancel: '取消',
  confirmDelete: '確定刪除',
  addChannel: '新增店鋪',
  addAuthorizedChannel: '新增授權店鋪',
  order: '序號',
  storeNumber: '店鋪編號',
  storeAbbreviation: '店鋪簡稱',
  storeFullname: '店鋪全稱',
  confirm: '確定',
  searchAuthorizedChannel: '搜索已授權店鋪',
  searchChannel: '搜索未授權店鋪',
  authorizedChannelDeleted: '授權店鋪刪除成功！',
  authorizedChannelAdded: '授權店鋪新增成功！',
  '渠道配置中心': '渠道配置中心',
  '下载模版': '下載模版',
  '导入': '導入',
  '导入教程': '導入教程',
  '支持通过本地excel表快速导入渠道,点击': '支持通過本地excel表快速導入渠道,點擊',
  '下载模板': '下載模板',
  '模板第二行开始填写需导入的渠道编号，依次往下录入': '模板第二行開始填寫需導入的渠道編號，依次往下錄入',
  '选择全部': '選擇全部',
  '取消': '取消',
  '确定': '確定',
  '提示': '提示',
  '行导入成功，以下': '行導入成功，以下',
  '行数据导入失败': '行數據導入失敗',
  '渠道编号': '渠道編號',
  '知道了': '知道了'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/warehouse.js
/*
 * @Author: JamesWong
 * @Description: 仓库模块繁体包
 * @Date: 2018-11-29 18:56:25
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-17 11:23:22
 */
/* harmony default export */ var zh_hant_warehouse = ({
  authorizedWarehouse: '已授權倉庫',
  deleteWarehouse: '刪除倉庫',
  hint: '提示',
  deleteWarehouseTips: '刪除後該倉庫將不能使用POS登錄,確定刪除該倉庫嗎?',
  cancel: '取消',
  confirmDelete: '確定刪除',
  addWarehouse: '新增倉庫',
  addAuthorizedWarehouse: '新增授權倉庫',
  searchAuthorizedWarehouse: '搜索已授權店鋪',
  Order: '序號',
  warehouseNumber: '倉庫編號',
  warehouseAbbreviation: '倉庫簡稱',
  warehouseFullname: '倉庫全稱',
  confirm: '確定',
  searchWarehouse: '搜索倉庫',
  authorizedWarehouseAdded: '授權倉庫新增成功！',
  authorizedWarehouseDeleted: '授權倉庫刪除成功！'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/activeCode.js
/*
 * @Author: JamesWong
 * @Description: 激活码模块繁体包
 * @Date: 2018-11-29 19:12:37
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-02 11:36:56
 */
/* harmony default export */ var zh_hant_activeCode = ({
  activated: '已啟動',
  unactivated: '未啟動',
  order: '序號',
  activeCode: '啟動碼',
  machineNumber: '機器編碼',
  machineCode: '設備機器碼',
  activeTime: '啟動時間',
  operation: '操作',
  delete: '刪除',
  dataNotAvailable: '暫無數據',
  cancelActived: '取消啟動',
  cancel: '取消',
  comfirm: '確定',
  subactiveCodeCanceled: '取消激活',
  subactiveCodeCanceledTips: '確定取消該設備的啟動碼？',
  subactiveCodeDeleted: '刪除子啟動碼',
  subactiveCodeDeletedTips: '確定刪除該條啟動碼嗎？',
  close: '關閉',
  '点击详情': '點擊詳情',
  '未启用': '未啟用',
  '可联系商务开通': '可聯系商務開通',
  '下载链接': '下載鏈接'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/account.js
/*
 * @Author: JamesWong
 * @Description: 账户配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 15:02:12
 */
/* harmony default export */ var zh_hant_account = ({
  basicInformation: '基本資料',
  enterpriseNumber: '企業編號',
  enterpriseName: '企業名稱'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/payment.js
/*
 * @Author: JamesWong
 * @Description: 支付配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-08 14:15:38
 */
/* harmony default export */ var zh_hant_payment = ({
  channelPaymentMethods: '渠道支付方式',
  set: '設置',
  setPaymentMethods: '設置支付方式',
  confirm: '確定',
  cancel: '取消',
  channel: '渠道',
  order: '序號',
  channelNumber: '渠道編號',
  account: '戶口',
  accountFilter: '戶口篩選',
  weChatScanPayment: '微信掃碼付',
  paymentSetTips: '提示：同時編輯多個渠道時，支付方式需要重新選擇，不選擇將被置為空',
  pleaseSelectAgain: '請重新選擇',
  selectPaymentMethod: '選擇支付方式',
  paymentNumber: '支付編號',
  merchantID: '商戶ID',
  submerchantID: '子商戶ID',
  Note: '備註',
  appId: '商戶ID',
  token: '授權Token',
  tokenTime: '授權時間',
  wechatFaceIDPay: '微信刷臉支付',
  wechatClientSelfpay: '微信客戶自付',
  alipayScancodePay: '支付寶掃碼付',
  alipayNumber: '支付寶編號',
  systemBusinessNumber: '系統商編號',
  enterChannelTips: '請輸入渠道編號、名稱搜索',
  channelName: '渠道名稱',
  wechatPaymentDisposition: '微信支付配置',
  wechatPaymentTips: '微信支付支援三種支付類型：',
  wechatPaymentTips1: '1.掃碼支付：收銀員掃客戶的付款碼，適用於POS收銀；',
  wechatPaymentTips2: '2.客戶在特定自助機器上，自主完成刷臉支付，適用于自主購物機；',
  wechatPaymentTips3: '3.客戶自支付：客戶在個人手機中點擊付款，調用微信支付，適用于微商城、掃碼購程式；',
  wechatPaymentTipsPlus: '注意：三種類型只能各自默認一個支付，渠道沒有單獨配置支付方式時，將自動使用預設的支付方式。',
  Mode: '模式',
  type: '類型',
  defaultTips: '是否默認',
  default: '默認',
  operate: '備註',
  detail: '詳情',
  paymentMethodDetail: '支付方式詳情',
  paymentType: '支付類型',
  APPKEY: 'APPKEY',
  certification: '證書',
  certificationDocument: '證書文件',
  certificationPassword: '證書密碼',
  alipayPaymentDisposition: '支付寶支付配置',
  status: '狀態',
  authorizedMerchantID: '授權商戶ID',
  authorized: '已授權',
  authorize: '授權',
  unAuthorized: '未授權',
  privateKey: '私密金鑰',
  publicKey: '公開金鑰',
  signatureType: '簽名類型',
  selectedTips: '請先選擇渠道再設置支付方式',
  success: '成功',
  configuredChannel: '已配置渠道',
  reauthorize: '重新授權'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/screen.js
/*
 * @Author: JamesWong
 * @Description: 副屏幕中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 17:02:20
 */
/* harmony default export */ var zh_hant_screen = ({
  interactMode: '交互模式',
  rollingPhotos: '輪播圖片',
  advertisementVideo: '廣告視頻',
  interactModeTips1: '1.收銀機沒有進行收銀操作時，副屏全屏顯示圖片輪播/視頻輪播',
  interactModeTips2: '2.收銀過程中，副螢幕左側顯示圖片/視頻，右側顯示銷售明細及交易金額',
  interactModeTips3: '3.結算完成後，副螢幕再次恢復全屏模式',
  fullscreenPhoto: '全屏圖片',
  fullscreenVideo: '全屏視頻',
  photoSalesDetail: '圖片 + 銷售明細',
  videoSalesDetail: '視頻 + 銷售明細',
  upload: '上傳',
  preview: '預覽',
  previewPhotos: '預覽圖片',
  delete: '刪除',
  photoDeleted: '圖片刪除成功',
  previewVideo: '預覽視頻',
  videoUploaded: '上傳視頻成功！',
  videoSizeTips: '檔大小不能超過200M！',
  photoUploaded: '上傳圖片成功！',
  phoneSizeTips: '檔大小不能超過10M！',
  longNameTips: '檔案名不能過長！',
  moreFileTips: '最多只能上傳一個視頻，請先刪除原有的視頻再嘗試上傳！',
  uploadingTips: '文件正在上傳中...   請稍等',
  notSupportTips: '您的流覽器不支持 video 標籤。',
  uploadProgress: '上傳進度',
  noVideoTips: '你還沒有上傳視頻，趕快上傳吧',
  noPhotoTips: '你還沒有上傳圖片，趕快上傳吧',
  Unnamed: '未命名'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/slip.js
/*
 * @Author: JamesWong
 * @Description: 小票配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2021-03-18 20:05:44
 */
/* harmony default export */ var zh_hant_slip = ({
  styleDisposition: '樣式配置',
  ticketPreview: '小票預覽',
  createDeposit: '定金單',
  detail: '詳情',
  edit: '編輯',
  save: '保存',
  cancel: '取消',
  printLabel: '打印標示',
  reprintLabel: '重打印標示（僅在重打印的小票上顯示）',
  headPhotos: '頭部圖片',
  headPart: '頭部',
  ticketInfo: '單據資訊',
  ticketNo: '小票號',
  operateTime: '操作時間',
  cashier: '收銀員',
  assistant: '營業員',
  assistantCode: '營業員編號',
  assistantName: '營業員名稱',
  storeNo: '店鋪編號',
  storeAddr: '店鋪地址',
  storePhone: '店鋪電話',
  storeMobile: '店鋪手機',
  VIPNo: '會員編號',
  remarks: '銷售備註',
  Goods: '貨品',
  Quty: '數量',
  Amt: '金額',
  TagPrice: '吊牌價',
  Total: '合計',
  PriceTotal: '總額',
  Benefit: '優惠',
  VIPPrice: '會員價',
  DCT: '折扣',
  DiscountedPrice: '折後價',
  ValueBalance: '儲值余額',
  goodsInfo: '貨品信息',
  promotionInfo: '促銷資訊',
  allPromotionsTicket: '該單所有的促銷',
  promotionDesc: '促銷描述',
  promotionNotes: '促銷備註',
  paymentMethod: '支付方式',
  defaultPayment: '預設樣式：應付+所有應用到的支付方式',
  tailPhotos: '尾部圖片',
  salesExplanation: '銷售說明',
  tailpart: '尾部',
  quantitySet: '張數配置',
  salesCreateReciept: '銷售做單',
  numberChannelVersion: '店鋪聯列印張數',
  complete: '完成',
  numberCustomerVersion: '顧客聯列印張數',
  reprintSalesReciept: '重列印銷售單',
  tips: '提示',
  updatedTips: '更新小票配置成功',
  precept: '方案',
  cashierAndName: '收銀員：張三',
  assistantAndName: '營業員：1001-王曉',
  storeNoAndName: '店鋪編號：1009-店鋪',
  storeAddrAndName: '店鋪地址：廣州市番禺區天安節能科技園15號樓',
  payable: '應付',
  cash: '現金',
  integralBalance: '積分余額',
  printThirtpartOrder: '支付流水號',
  thridSeralNumber: '第三方支付的商戶支付流水號',
  TicketNumberEdited: '小票數修改成功！',
  TicketNumberEditedError1: '請輸入0-3之間的數字',
  TicketNumberEditedError2: '數量不能超過 3',
  photoUploadTips: '註：請先選擇圖片，可用鼠標滑動調整圖片的大小、位置，已達到理想打印效果。如超過邊框，圖片會按照300:130進行裁切。',
  selectPhotos: '選擇圖片',
  leftTurn: '向左旋轉',
  rightTurn: '向右旋轉',
  upload: '上傳',
  confirm: '確定',
  markSet: '標示設置',
  markSetMsg: '隱藏店鋪聯/顧客連"標示',
  markSetCustomer: '顧客聯',
  invoiceScanUrlText: '發票二維碼',
  invoiceScanUrl: '顯示發票二維碼(ERP配置後生效)',
  invoiceDesc: '发票發票',
  '添加二维码': '添加二維碼',
  '请输入二维码内容': '請輸入二維碼内容',
  '自定义二维码': '自定義二維碼',
  '二维码描述': '二維碼描述',
  '销售单号': '銷售單號',
  '手工单号': '手工單號',
  '会员卡号': '會員卡號',
  '会员手机': '會員手機',
  etc: '等',
  Coupon: '代用券',
  Date: '日期',
  printCoupons: '打印代用券',
  promoteCounpon: '促銷贈券',
  rechargeCounpon: '充值贈券',
  primeCostInfo: '原價總額',
  primeCostInfoDetail: '(貨品總吊牌價)',
  DiscountTotal: '優惠總額',
  alreadyDiscountInfo: '已優惠',
  alreadyDiscountInfoDetail: '(已優惠=吊牌價-應付)',
  实付: '實付',
  生意额: '生意額',
  getIntegrateInfo: '獲得積分',
  remainingIntegrateInfo: '積分餘額',
  uploadPhoto: '上傳圖片',
  autoSavePhoto: '自動生成條碼圖片',
  autoSelectNum: '選擇自動生成條形碼的單號',
  Saleno: '銷售單號',
  manualSaleNo: '手工單號',
  barCode: '條形碼',
  qrCode: '二維碼',
  takeCareMsg: '注意: 手工單號相對較長，轉成條形碼可能過長，導致掃描不出來，建議使用二維碼',
  cancelMsg: '取 消',
  saveMsg: '保 存',
  addParagraph: '+新增段落',
  addEmptyParagraph: '+新增空行',
  paragraphMsg: '段落',
  leftAlign: '左對齊',
  centerAlign: '居中',
  deleteMsg: '刪除',
  blankLine: '空行',
  // 3.4添加需求
  goodsSpace: '貨品顯示',
  goodsSpaceMsg: '货品之间空行隔开貨品之間空行隔開',
  showGoodsTotal: '貨品合計',
  showGoodsTotalMsg: '顯示合計',
  middlePic: '自定義圖片',
  tailImageDesc: '圖片描述',
  barCodeStyle: '條碼樣式',
  smallTicketNum: '小票號',
  goodsType10: '條形碼',
  goodsType10Unique: '唯壹碼',
  goodsType17: '條形碼/唯壹碼',
  goodsType2: '條形碼/品名',
  goodsType2Unique: '唯壹碼/品名',
  goodsType22: '條形碼/品類',
  goodsType22Unique: '唯壹碼/品類',
  goodsType4: '条形码/品名/吊牌价',
  goodsType4Unique: '唯壹碼/品名/吊牌价',
  goodsType44: '條形碼/品類/吊牌價',
  goodsType44Unique: '唯壹碼/品類/吊牌價',
  goodsType5: '条形码/品名/会员价/折后价',
  goodsType5Unique: '唯壹碼/品名/会员价/折后价',
  goodsType55: '條形碼/品類/會員價/折後價',
  goodsType55Unique: '唯壹碼/品類/會員價/折後價',
  goodsType7: '条形码/品名/会员价/折扣/折后价',
  goodsType7Unique: '唯壹碼/品名/会员价/折扣/折后价',
  goodsType77: '條形碼/品類/會員價/折扣/折後價',
  goodsType77Unique: '唯壹碼/品類/會員價/折扣/折後價',
  goodsType1: '货号-品名/颜色/内长/尺码',
  goodsType6: '货号-品名/颜色/内长/尺码/会员价/折后价',
  goodsType8: '货号-品名/颜色/内长/尺码/会员价/折扣/折后价',
  goodsType3: '货号-品名/颜色/内长/尺码/吊牌价',
  goodsType9: '货号-品名/颜色/内长/尺码/吊牌价/折扣/折后价',
  goodsType11: '貨號-品類/顏色/內長/尺碼',
  goodsType66: '貨號-品類/顏色/內長/尺碼/會員價/折後價',
  goodsType88: '貨號-品類/顏色/內長/尺碼/會員價/折扣/折後價',
  goodsType33: '貨號-品類/顏色/內長/尺碼/吊牌價',
  goodsType99: '貨號-品類/顏色/內長/尺碼/吊牌價/折扣/折後價',
  goodsType100: '货号-品类/颜色/内长/尺码/零售价/零售折扣/折后价',
  categoryReplaceName: '使用品類替換品名',
  uniqueReplaceBarcode: '使用唯壹碼替換條形碼',
  Amt_mang: '滿',
  Available: '可用',
  '渠道配置中心': '渠道配置中心',
  '单据打印样式管理': '單據打印樣式管理',
  '配置样式请至渠道配置中心操作': '配置樣式請至"渠道配置中心"操作',
  '单据': '單據',
  '新增简易版样式': '新增簡易版樣式',
  '新增定义版样式': '新增自定義版樣式',
  '简易版编辑器': '簡易版編輯器',
  '自定义编辑器': '自定義編輯器',
  '自定义版': '自定義版',
  '简易版': '簡易版',
  '空样式': '樣式',
  '样式名称': '樣式名稱',
  '样式文档名称': '樣式文檔名稱',
  '输入样式文档名称': '輸入樣式文檔名稱',
  '建议备注宽度以便区分': '建議備註寬度以便區分',
  '图片大小不超过': '圖片大小不超過',
  '选择单据': '選擇單據',
  '选择模版': '選擇模版',
  '空白模版': '空白模版',
  '请检查样式是否缺漏': '請檢查樣式是否缺漏',
  '您正在进行模版编辑操作, 是否放弃编辑?': '您正在進行模版編輯操作, 是否放棄編輯?',
  '销售单': '銷售單',
  '定金单': '定金單',
  '日结': '日結',
  '交接班': '交接班',
  '本机日收银': '本機日收銀',
  '充值单': '充值單',
  '调拨收货': '調撥收貨',
  '采购收货': '采購收貨',
  '渠道收货': '渠道收貨',
  '渠道调拨': '渠道調撥',
  '渠道退货': '渠道退貨',
  '仓库出货': '倉庫出貨',
  '渠道采购到货通知': '渠道采購到貨通知',
  '渠道调出通知': '渠道調出通知',
  '退货通知': '退貨通知',
  '渠道采购退货通知': '渠道采購退貨通知',
  '线上订单发货': '線上訂單發貨',
  '收货单': '收貨單',
  '成品采购入库单(基础)': '成品采購入庫單(基礎)',
  '发货单': '發貨單',
  '采购退货': '采購退貨',
  '紧急发货(基础)': '緊急發貨(基礎)',
  '配货单(基础)': '配貨單(基礎)',
  '发货退货(基础)': '發貨退貨(基礎)',
  '到货通知单(基础)': '到貨通知單(基礎)',
  '采购退货(基础)': '采購退貨(基礎)',
  '采购退货通知(基础)': '采購退貨通知(基礎)',
  '验货(基础)': '驗貨(基礎)',
  '自定义文本': '自定義文本',
  '模版名称': '模版名稱',
  '模板已保存': '模板已保存',
  '可通过渠道配置中心配置渠道使用': '可通過"渠道配置中心"配置渠道使用',
  '选择样式': '選擇樣式',
  '税额': '稅額',
  '显示税额': '顯示稅額',
  '买满立减(按单)': '買滿立減(按單)',
  '买满打折(按货品)': '買滿打折(按貨品)',
  '买满送优惠券': '買滿送優惠券',
  '顾客签名栏': '顧客簽名欄',
  '打印太阳码': '打印太陽碼',
  '显示顾客签名栏': '顯示顧客簽名欄',
  '显示已用代用券券号': '顯示已用代用券券號',
  '已用代用券': '已用代用券',
  '折扣取反(适用于非中国大陆地区)': '折扣取反(適用於非中國大陸地區)',
  '会员姓名': '會員姓名',
  '会员等级': '會員等級',
  '营业员(货品)': '營業員(貨品)',
  '代用券': '代用券',
  'A4显示货品营业员': 'A4显示货品营业员',
  '营业员': '營業員',
  '顾客签名': '顾客签名',
  '渠道调入': '渠道調入',
  '发货': '發貨',
  '配单': '配單',
  '退货': '退貨',
  '定金单号': '定金單號',
  '核销单号': '核銷單號',
  'printCounterChannelAbb': '专柜(商场打印)',
  'printCounterChannelAbbs': '专柜',
  '活动说明': '活動說明',
  '显示赠送代用券活动说明': '顯示贈送代用券活動說明',
  '批量打印': '批量打印',
  '顺丰面单打印': '顺丰面单打印',
  '零售配单验货': '零售配单验货',
  '销补发货': '销补发货',
  '收货工作台': '收货工作台',
  '线上订单工作台': '线上订单工作台',
  维修单: '维修单',
  补货: '补货',
  '发快递（影儿）': '发快递（影儿）',
  '价签打印': '價籤列印'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/self.js
/*
 * @Author: JamesWong
 * @Description: 自助收银中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-03 16:06:53
 */
/* harmony default export */ var zh_hant_self = ({
  authorizedDevice: '授權設備',
  remainDevices: '剩餘可用授權設備數',
  order: '序號',
  authorizationTime: '授權時間',
  machineNumber: '機器編碼',
  machineCode: '設備機器碼',
  operate: '操作',
  cancelAuthorization: '取消授權',
  cancelAuthorizeDevice: '取消授權設備',
  cancelAuthorizationTips: '確定取消授權設備？',
  cancel: '取消',
  confirm: '確定',
  rollingPhotos: '輪播圖片',
  uploadPhotosTips: '圖片比例16：9，大小不超過5M',
  upload: '上傳',
  previewPhotos: '預覽圖片',
  delete: '刪除',
  deleted: '刪除成功',
  createQRcode: '開卡二維碼',
  uploadQRcodeTips: '圖片比例1：1，大小不超過1M',
  uploadingTips: '文件正在上傳中...請稍等',
  uploadProgress: '上傳進度',
  Unnamed: '未命名',
  photoUploaded: '上傳視頻成功！',
  phoneSizeTips: '檔案大小不能超過1M！',
  phoneSizeTips5: '檔案大小不能超過5M！',
  longNameTips: '檔案名不能過長！',
  noPhotoTips: '你還沒有上傳圖片，趕快上傳吧',
  deletedError: '刪除失敗！',
  cancelAuthorized: '取消授權成功！'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/inout.js
/*
 * @Author: JamesWong
 * @Description: 物流配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-19 17:45:39
 */
/* harmony default export */ var zh_hant_inout = ({
  receive: '收貨',
  deliver: '發貨',
  inventory: '盤點',
  createInvoice: '自建單據',
  dispose: '配置',
  modelDisposition: '模組配置',
  modelName: '模組名稱',
  enterModelnameTips: '請填寫模組名稱',
  modelId: '模組ID',
  enterModelIdTips: '請填寫模組ID',
  noticeName: '通知單名稱',
  noticeName1: '盤點單名稱',
  enterNoticenameTips: '請填寫通知單名稱',
  enterNoticenameTips1: '請填寫盤點單名稱',
  noticeId: '通知單ID',
  noticeId1: '盤點單ID',
  enterNoticeIdTips: '請填寫通知單ID',
  enterNoticeIdTips1: '請填寫盤點單ID',
  confirm: '確定',
  cancel: '取消',
  noticeModelName: '通知單模組名稱',
  noticeModelId: '通知單模組ID',
  operate: '操作',
  edit: '編輯',
  delete: '刪除',
  stockCheckPlan: '盤點計畫',
  stockCheckAnalysis: '盤點分析',
  stockChecklist: '盤點單',
  modelAddSuccess: '模組新增成功！',
  modelUpdateSuccess: '模組更新成功！',
  deliveryNotice: '通知單',
  replenishment: '補貨'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/newSlip.js
/*
 * @Author: JamesWong
 * @Description: 3.2小票配置
 * @Date: 2019-01-04 14:59:12
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-07 11:41:16
 */
/* harmony default export */ var zh_hant_newSlip = ({
  confirm: '確定',
  cancel: '取消',
  channel: '渠道',
  added: '新增',
  order: '序號',
  Operation: '操作',
  edit: '編輯',
  templateName: '模板名稱',
  enterTemplateName: '請輸入模板名稱',
  defaults: '默認',
  filters: '渠道性質篩選',
  review: '預覽',
  delete: '刪除',
  createDeposit: '定金單',
  salesCreateReciept: '銷售做單',
  channelNumber: '渠道編號',
  account: '戶口',
  pleaseSelectAgain: '請重新選擇',
  channelRecipetConfiguration: '渠道小票配置',
  recipetTemplate: '小票範本',
  depositTemplate: '定金單範本',
  numberTemplate: '張數範本',
  channelType: '渠道性質',
  recipetStyle: '小票樣式',
  saleVersion: '做單店鋪/顧客聯',
  reprintVersion: '重列印店鋪/顧客聯',
  selectChannelSettings: '選擇管道設置',
  setChannelType: '按渠道性質設置',
  setbyAccount: '按戶口設置',
  channelSelected: '已選管道',
  SaleNum: '銷售做單-店鋪/顧客聯張數',
  ReprintNum: '重列印-店鋪/顧客聯張數',
  selectChannel: '請選擇管道',
  saleRecipetNumberTemplate: '銷售做單張數範本',
  depositRecipetNumberTemplate: '定金單張數模板',
  reprintNumberTemplate: '重列印張數範本',
  businessType: '業務類型',
  number: '張數',
  selectTips: '請先選擇渠道在進行設置小票樣式',
  setTips: '設置成功！',
  styleWarn: '請選擇 "小票樣式" 模板',
  sellWarn: '請選擇 "銷售做單-店鋪/顧客聯張數" 模板',
  sellWarn2: '請選擇 "定金單-店鋪/顧客聯張數" 模板',
  reprintWarn: '請選擇 "重打印-店鋪/顧客聯張數" 模板',
  noset: '暫無配置渠道性質',
  select: '已選擇',
  numTypeSale: '小票-店鋪聯/顧客聯',
  numTypeReprint: '重打印-店鋪聯/顧客聯',
  deleteReceiptModel: '刪除小票模板',
  deleteTips: '確定刪除該小票模板？',
  addtips: '添加成功',
  edittips: '修改成功'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/contract.js
/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-29 16:08:12
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-11-02 13:05:09
 */
/* harmony default export */ var zh_hant_contract = ({
  '序号': '序號',
  '含扩容：': '含扩容：',
  'EPOS授权信息': 'EPOS授權信息',
  '汇总：': '匯總：',
  '剩余': '剩余',
  '店务': '店务',
  '绑定类型：': '綁定類型：',
  '剩余天数': '剩余天數',
  '操作': '操作',
  '查看': '查看',
  '店铺授权容量': '店鋪授權數量',
  'WEB授权容量': 'WEB授權數量',
  '移动授权容量': '移動授權數量',
  '合同编号': '合同編號',
  '开始/结束时间': '開始/結束時間',
  'Android平板': 'Android平板',
  'Android手机': 'Android手機',
  'IPhone': 'IPhone',
  'IPAD': 'IPAD',
  'WEB': 'WEB',
  '授权信息': '授權信息',
  '查看变更记录': '查看變更記錄',
  '店铺授权清单': '店鋪授權清單',
  '设备归属清单': '設備歸屬清單',
  '新增授权店铺': '新增授權店鋪',
  '管理所有店铺授权': '管理所有店鋪授權',
  '管理所有归属设备': '管理所有歸屬設備',
  '管理': '管理',
  '数量': '數量',
  '关闭': '關閉',
  '授权全部渠道': '授權全部渠道',
  '确认授权所有店铺？': '確認授權所有店鋪？',
  '操作日期': '操作日期',
  '类型': '類型',
  '操作内容': '操作內容',
  '操作人': '操作人',
  '店铺编号': '店鋪編號',
  '店铺简称': '店鋪簡稱',
  '店铺全称': '店鋪全稱',
  'WEB设备': 'WEB設備',
  '移动': '移動',
  '机器编号': '機器編號',
  '机器码': '機器碼',
  '设备类型': '設備類型',
  '绑定类型': '綁定類型',
  '绑定日期': '綁定日期',
  '状态': '狀態',
  '余量：': '余量：',
  '（含扩容：': '（含擴容：',
  '该店铺不存在或已授权': '該店鋪不存在或已授權',
  '请输入': '請輸入',
  '授权设备类型': '授權設備類型',
  '绑定状态': '綁定狀態',
  '请选择': '請選擇',
  '筛选': '篩選',
  '清空': '清空',
  '返回': '返回',
  '设备绑定列表': '設備綁定列表',
  '解除绑定': '解除綁定',
  '移出黑名单': '移出黑名單',
  '加入黑名单': '加入黑名單',
  '全选': '全選',
  '提示': '提示',
  '取消': '取消',
  '确定': '確定',
  '正常': '正常',
  '白名单': '白名單',
  '黑名单': '黑名單',
  '激活码': '激活碼',
  '安卓手机': '安卓手機',
  '安卓平板': '安卓平板',
  '禁用': '禁用',
  '启用': '啟用',
  'EPOS版本': 'EPOS版本',
  '企业': '企業',
  '企业编号': '企業編號',
  '设备机型': '設備機型',
  '调整限额': '調整限額',
  '系统版本号': '系統版本號',
  'EPOS版本号': 'EPOS版本號',
  '解除往期的激活码/店铺容量绑定，避免影响店铺pos数量超出限额，确认提示框提醒是否继续操作': '解除往期的激活碼/店鋪容量綁定，避免影響店鋪pos數量超出限額，確認提示框提醒是否繼續操作',
  '允许登陆pos': '允許登陸pos',
  '释放往期的激活码/店铺容量': '釋放往期的激活碼/店鋪容量',
  '限制登陆pos，需解除绑定激活码、解除店铺归属，是否继续操作': '限制登陸pos，需解除綁定激活碼、解除店鋪歸屬，是否繼續操作',
  '是否解除绑定': '是否解除綁定',
  '是否': '是否',
  '解绑成功': '解綁成功',
  '店铺授权': '店鋪授權',
  '新增店铺授权': '新增店鋪授權',
  '总量': '總量',
  '授权日期': '授權日期',
  '合同编号：': '合同編號：',
  '请输入合同编号': '請輸入合同編號',
  '店铺编号：': '店鋪編號：',
  '请输入店铺编号': '請輸入店鋪編號',
  '店铺授权列表': '店鋪授權列表',
  'WEB限额': 'WEB限額',
  'WEB限额余量': 'WEB限額余量',
  '移动限额': '移動限額',
  '移动限额余量': '移動限額余量',
  '解除授权': '解除授權',
  '扩容': '擴容',
  '移动扩容:': '移動擴容',
  'WEB扩容:': 'WEB擴容',
  '扩容成功': '擴容成功',
  '将影响已授权的店铺登录，是否确定调整': '將影響已授權的店鋪登錄，是否確定調整',
  '登录记录查看': '登錄記錄查看',
  '请输入收银员名称': '請輸入收銀員名稱',
  '请输入机器编号': '請輸入機器編號',
  '请输入版本号': '請輸入版本號',
  '至': '至',
  '开始日期': '開始日期',
  '已过期': '已過期',
  '未生效': '未生效',
  '不足一天': '不足壹天',
  '结束日期': '結束日期',
  '搜索': '搜索',
  '登录时间': '登錄時間',
  '收银员': '收銀員',
  '门店': '門店',
  '设备型号': '設備型號',
  '系统版本': '系統版本',
  '经纬度': '經緯度',
  '定位地址': '定位地址',
  '最近一周': '最近壹周',
  '最近一个月': '最近壹個月',
  '最近三个月': '最近三個月',
  'Iphone': 'Iphone',
  'Ipad': 'Ipad',
  'WEB已用': 'WEB已用',
  '移动已用': '移動已用',
  '收银': '收銀',
  '物流': '物流',
  '公告': '公告',
  '储位': '儲位',
  '其他': '其他',
  '授权模块': '授權模塊',
  '清理闲置设备': '清理閑置設備',
  '最近登录日期': '最近登錄日期',
  '未登录天数': '未登錄天數',
  '机器编码': '機器編碼',
  '未登录天数大于': '未登錄天數大於',
  '请输入店铺简称': '請輸入店鋪簡稱',
  '解除全部': '解除全部',
  '请输入或选择': '請輸入或選擇',
  '解绑全部': '解绑全部',
  '将批量解绑所有设备，是否确认操作': '將批量解綁所有設備，是否確認操作',
  // 4.2
  '设备变更记录': '設備變更記錄',
  '操作时间': '操作時間',
  '收营员编号': '收營員編號',
  '操作状态': '操作狀態',
  '请输入收银员帐号': '請輸入收銀員帐號',
  '设备解绑记录': '設備解綁記錄',
  '收银员帐号': '收銀員編號',
  '合同变更记录': '合同變更記錄',
  '不限': '不限',
  '设备归属列表': '設備歸屬列表',
  '创建合同': '創建合同',
  '合同初始化': '合同初始化',
  '更新设备授权': '更新設備授權',
  '更新店铺数量': '更新店鋪數量',
  '续约': '續約',
  '模块配置': '模塊配置',
  '更新Webpos数量': '更新Webpos數量',
  '移动POS数量': '移動POS數量',
  '授权店铺数量': '授權店鋪數量',
  '更新合同服务日期': '更新合同服務日期',
  '店铺': '店鋪',
  'Webpos最高限额': 'Webpos最高限額',
  '请输入限额': '請輸入限額',
  '移动POS限额': '移動POS限額',
  '请输入本期授权的店铺总量': '請輸入本期授權的店鋪總量',
  '请输入本期授权的数量': '請輸入本期授權的數量',
  '授权的数量必须为正整数': '授權的數量必須為正整數',
  'Webpos最高限额不能低于': 'Webpos最高限額不能低於',
  '不能低于': '不能低於',
  '归属店铺': '歸屬店鋪',
  '全部': '全部',
  '取消归属': '取消歸屬',
  'Webpos限额': 'Webpos限額',
  '合同类型': '合同類型',
  '租用': '租用',
  '购买': '购买',
  '导出': '導出',
  '文件大小不能超过1M！': '文件大小不能超過1M！'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/note.js
/* harmony default export */ var zh_hant_note = ({
  '短信设置': '短信設置',
  '返回': '返回',
  '短信模版': '短信模版',
  '查看流水': '查看流水',
  '短信供应商平台': '短信供應商平臺',
  '供应商': '供應商',
  '账号': '賬號',
  '密码': '密碼',
  '取消': '取消',
  '确定': '確定',
  '编辑模板': '編輯模板',
  '保存': '保存',
  '短信模板预览': '短信模板預覽',
  '短信模板编辑区': '短信模板編輯區',
  '不同短信供应商对短信字数限制不一，可能存在字数溢出的情况，请酌情规划模板字数': '不同短信供應商對短信字數限制不壹，可能存在字數溢出的情況，請酌情規劃模板字數',
  '基本信息取值区': '基本信息取值區',
  '点击将标签插入模板，短信会根据标签写入实际数值': '點擊將標簽插入模板，短信會根據標簽寫入實際數值',
  '验证码': '驗證碼',
  '提示': '提示',
  '若模板没有保存，直接返回会丢失已修改的模板哦。确定吗？': '若模板沒有保存，直接返回會丟失已修改的模板哦。確定嗎？',
  '功能类型': '功能類型',
  '短信类型': '短信類型',
  '短信属性': '短信屬性',
  '操作': '操作',
  '全局': '全局',
  '渠道': '渠道',
  '开卡': '開卡',
  '储值卡': '儲值卡',
  '消费': '消費',
  '其他': '其他',
  '开卡手机验证码': '開卡手機驗證碼',
  '开卡成功提醒': '開卡成功提醒',
  '会员储值卡使用验证码': '會員儲值卡使用驗證碼',
  '会员储值卡充值成功提醒': '會員儲值卡充值成功提醒',
  '会员储值卡消费成功提醒': '會員儲值卡消費成功提醒',
  '会员积分使用验证码': '會員積分使用驗證碼',
  '会员积分充值成功提醒': '會員積分充值成功提醒',
  '会员积分消费成功提醒': '會員積分消費成功提醒',
  '特殊会员VIP折扣使用': '特殊會員VIP折扣使用',
  '高级折扣权限短信验证码': '高級折扣權限短信驗證碼',
  '消费成功提醒': '消費成功提醒',
  '定金单下单成功提醒': '定金單下單成功提醒',
  '修改会员手机号成功提醒': '修改會員手機號成功提醒',
  '会员等级变动提醒': '會員等級變動提醒',
  '停用': '停用',
  '启用': '啟用',
  '未开通短信服务': '未開通短信服務',
  '配置': '配置',
  '请联系信息部门': '請聯系信息部門',
  '店铺': '店鋪',
  '序': '序',
  '搜索': '搜索',
  '店铺编号': '店鋪編號',
  '店铺名称': '店鋪名稱',
  '知道了': '知道了',
  '快捷设置': '快捷設置',
  '刷新促销': '刷新促銷',
  'Web端使用ERP物流模块': 'Web端使用ERP物流模塊',
  '模板内容': '模板內容',
  '模板方案': '模板方案',
  '同步ERP渠道资料': '同步ERP渠道資料',
  '未审核': '未審核',
  '审核中': '審核中',
  '审核通过': '審核通過',
  '审核失败': '審核失敗',
  '添加账号': '添加賬號',
  '确认删除该短信模板吗？': '確認刪除該短信模板嗎？',
  '删除': '刪除',
  '重命名': '重命名',
  '默认': '默認',
  '国际': '國際',
  '中文': '中文',
  '未配置模板的渠道将按默认模板发送短信': '未配置模板的渠道將按默認模板發送短信',
  '确认切换默认模板吗？': '確認切換默認模板嗎？',
  '添加模板': '添加模板',
  '审核状态': '審核狀態',
  '添加中文模板': '添加中文模板',
  '添加国际模板': '添加國際模板',
  '申请说明': '申請說明',
  '确认删除该短信签名吗？': '確認刪除該短信簽名嗎？',
  '默认签名': '默認簽名',
  '审核备注': '審核備註',
  '签名来源': '簽名來源',
  '签名名称': '簽名名稱',
  '添加短信签名': '添加短信簽名',
  '短信签名': '短信簽名',
  '请在申请说明中 详细描述您的业务使⽤场景，申请⼯信部备案⽹站的全称或简称请在此处填写域名，长度不超过200个字符': '請在申請說明中 詳細描述您的業務使⽤場景，申請⼯信部備案⽹站的全稱或簡稱請在此處填寫域名，長度不超過200個字符',
  '请输入签名名称': '請輸入簽名名稱',
  '当前⽀持jpg、png、gif或 jpeg格式的图⽚。': '當前⽀持jpg、png、gif或 jpeg格式的圖⽚。',
  '签名的证明⽂件格式，⽀持上传多张图⽚。': '簽名的證明⽂件格式，⽀持上傳多張圖⽚。',
  '图片不超过2M': '圖片不超過2M',
  '提交审核': '提交審核',
  '证明文件': '證明文件',
  '短信供应商设置': '短信供應商設置',
  '短信签名未设置': '短信簽名未設置',
  '短信将无法发送': '短信將無法發送',
  '同步阿里云短信签名': '同步阿裏雲短信簽名',
  '渠道(批量)选择': '渠道(批量)選擇',
  '查询': '查詢',
  '渠道编号': '渠道編號',
  '请输入渠道编号': '請輸入渠道編號',
  '渠道简称': '渠道簡稱',
  '请输入渠道简称': '請輸入渠道簡稱',
  '经营模式': '經營模式',
  '经营方式': '經營方式',
  '输入或选择': '輸入或選擇',
  '公司': '公司',
  '组': '組',
  '国家': '國家',
  '销售类别': '銷售類別',
  '渠道配置（已选择': '渠道配置（已選擇',
  '复制渠道配置（已选择': '復製渠道配置（已選擇',
  '个渠道': '個渠道',
  '单据打印样式': '單據打印樣式',
  '单据': '單據',
  '销售单': '銷售單',
  '定金单': '定金單',
  '会员充值单': '會員充值單',
  '日结': '日結',
  '交接班': '交接班',
  '本机日收银': '本機日收銀',
  '发货单': '發貨單',
  '单据打印张数': '單據打印張數',
  '短信模板': '短信模板',
  '会员等级变动升级提醒': '會員等級變動升級提醒',
  '选择短信模板': '選擇短信模板',
  '模版方案': '模版方案',
  '模版内容': '模版內容',
  '阿里云短信签名': '阿裏雲短信簽名',
  '选择短信签名': '選擇短信簽名',
  '保存成功': '保存成功',
  '打印张数': '打印張數',
  '输入张数': '輸入張數',
  '做单打印': '做單打印',
  '店铺联': '店鋪聯',
  '客户联': '客戶聯',
  '张数': '張數',
  '不能全部为零': '不能全部為零',
  '请填写完整的张数': '請填寫完整的張數',
  '选择样式': '選擇樣式',
  '简易版': '簡易版',
  '简易版支持全部终端': '簡易版支持全部終端',
  '类型': '類型',
  '自定义版': '自定義版',
  '样式名称': '樣式名稱',
  '预览': '預覽',
  '自定义版仅支持Webpos优先使用': '自定義版僅支持Webpos優先使用',
  '变更记录': '變更記錄',
  '销售单小票': '銷售單小票',
  '定金单小票': '定金單小票',
  '充值单': '充值單',
  '请先选择模版': '請先選擇模版',
  '再保存': '再保存',
  '充值单据': '充值單據',
  '500条/页': '500條/頁',
  '第': '第',
  '页': '頁',
  '共': '共',
  '没有可选的数据': '沒有可選的數據',
  '渠道配置中心': '渠道配置中心',
  '支持配置小票样式&打印张数、短信模板': '支持配置小票樣式&打印張數、短信模板',
  '配置说明': '配置說明',
  '配置后，POS需重新登录后生效': '配置後，POS需重新登錄後生效',
  '渠道(批量)': '渠道(批量)',
  '请输入内容': '請輸入內容',
  '选项': '選項',
  '清空': '清空',
  '已选择': '已选择',
  '状态': '状态',
  '列表': '列表',
  '编辑': '編輯',
  '户口': '戶口',
  '批量配置单据打印样式': '批量配置單據打印樣式',
  '批量配置单据打印张数': '批量配置單據打印張數',
  '批量配置短信模板': '批量配置短信模板',
  '复制其他渠道模板': '復製其他渠道模板',
  '会员充值小票': '會員充值小票',
  '日结小票': '日結小票',
  '交接班小票': '交接班小票',
  '本机日收银小票': '本機日收銀小票',
  '发货单小票': '發貨單小票',
  '做单打印张数 店铺联/客户联': '做單打印張數 店鋪聯/客戶聯',
  '重打印张数 店铺联/客户联': '重打印張數 店鋪聯/客戶聯',
  '未选择业务属性': '未選擇業務屬性',
  '请选择渠道': '請選擇渠道',
  '同步ERP渠道资料成功！': '同步ERP渠道資料成功！',
  '系统默认模版': '系統默認模版',
  '做单': '做單',
  '企事业单位的全称或简称': '企事業單位的全稱或簡稱',
  '工信部备案网站的全称或简称': '工信部備案網站的全稱或簡稱',
  'APP应用的全称或简称': 'APP應用的全稱或簡稱',
  '公众号或小程序的全称或简称': '公眾號或小程序的全稱或簡稱',
  '电商平台店铺名的全称或简称': '電商平臺店鋪名的全稱或簡稱',
  '商标名的全称或简称': '商標名的全稱或簡稱',
  '请输入签名来源': '請輸入簽名來源',
  '请输入签名说明': '請輸入簽名說明',
  '重新上传成功': '重新上傳成功',
  '重新上传': '重新上傳',
  '添加成功': '添加成功',
  '上传图片不能大于2M': '上傳圖片不能大於2M',
  '短信模板数量不能超过10个': '短信模板數量不能超過10個',
  '请输入名称': '請輸入名稱',
  '保存后': '保存後',
  '模版将提交审核，': '模版將提交審核，',
  '审核通过前短信模版无法使用，确认吗？': '審核通過前短信模版無法使用，確認嗎？',
  '已经存在该字段，不可重复添加': '已經存在該字段，不可重復添加',
  '请选择要编辑的模版': '請選擇要編輯的模版',
  '保存置灰且点击提示“审核中”“审核通过”模板不可修改': '保存置灰且點擊提示“審核中”“審核通過”模板不可修改',
  '删除成功': '刪除成功',
  '超过最大字数': '超過最大字數',
  '模版中含有非法取值字段，请先删除再保存': '模版中含有非法取值字段，請先刪除再保存',
  '短信模板不能为空！': '短信模板不能為空！',
  '短信模板缺少验证码！': '短信模板缺少驗證碼！',
  '短信模板保存成功': '短信模板保存成功',
  '重命名成功': '重命名成功',
  '同步阿里云签名': '同步阿裏雲簽名',
  '输入在阿里云后台注册的签名名称，同步至企业管理后台': '輸入在阿裏雲後臺註冊的簽名名稱，同步至企業管理後臺',
  '签名名称不能为空': '簽名名稱不能為空',
  '同步签名成功': '同步簽名成功',
  '更新默认签名成功': '更新默認簽名成功',
  '删除签名成功': '刪除簽名成功',
  '请勿轻易切换供应商，审核状态将会被重置！': '請勿輕易切換供應商，審核狀態將會被重置！',
  '区域': '區域',
  '省份': '省份',
  '渠道性质': '渠道性質',
  '店铺联/顾客联打印张数不能全部为0': '店鋪聯/顧客聯打印張數不能全部為0',
  '销售退款（储值积分返还）提醒': '銷售退款（儲值積分返還）提醒',
  '渠道调出': '渠道調出',
  '渠道退货': '渠道退貨',
  '采购退货': '采購退貨',
  '退货通知': '退貨通知',
  '线上订单发货': '線上訂單發貨',
  '渠道调入': '渠道調入',
  '渠道收货': '渠道收貨',
  '退货': '退貨',
  '积分': '積分',
  '紧急发货': '緊急發貨',
  '发货': '發貨',
  '配单': '配單',
  '验货': '驗貨',
  '全部': '全部',
  '配置教学': '配置教學',
  '已配置短信渠道': '已配置短信渠道',
  '已开启ERP权限': '已開啟ERP權限',
  '未开启ERP权限': '未開啟ERP權限',
  '配置了该短信模板且已开通ERP权限的渠道，可正常使用短信功能': '配置了該短信模板且已開通ERP權限的渠道，可正常使用短信功能',
  '配置了该模板但未开通ERP权限的渠道,请前往ERP渠道资料开通权限': '配置了該模板但未開通ERP權限的渠道,請前往ERP渠道資料開通權限',
  '短信配置主要为以下流程': '短信配置主要為以下流程',
  '设置好短信签名，提交供应商审核（部分供应商无需配置签名）': '設置好短信簽名，提交供應商審核（部分供應商無需配置簽名）',
  '点击短信类型右侧的编辑模板，保存后提交供应商审核': '點擊短信類型右側的編輯模板，保存後提交供應商審核',
  '到': '到',
  '开通渠道': '开通渠道',
  '重打印': '重打印',
  '是否保存模板？': '是否保存模板？',
  '给不同渠道配置对应模板': '給不同渠道配置對應模板',
  '请先选择模版再保存': '请先选择模版再保存',
  '前往ERP渠道资料，开启所有渠道的短信发送权限': '前往ERP渠道資料，開啟所有渠道的短信發送權限',
  '全部数据导入成功': '全部數據導入成功',
  '零售方式': '零售方式',
  '积分清零提醒': '積分清零提醒',
  '生日代用券': '生日代用券',
  '短信签名一般为品牌名称，顾客短信可见，必填': '短信簽名壹般為品牌名稱，顧客短信可見，必填',
  '请填写短信签名': '請填寫短信簽名',
  '若清空供应商，可能会丢失原有短信供应商的模板审核状态，请谨慎操作': '若清空供應商，可能會丟失原有短信供應商的模板審核狀態，請謹慎操作。',
  '查询结果': '查詢結果',
  '搜索渠道': '搜索渠道',
  '重置': '重置',
  '条': '條',
  '100条/页': '100/行',
  '200条/页': '200/行',
  '300条/页': '300/行',
  '400条/页': '400/行',
  '请输入账号': '請輸入賬號',
  '输入账号': '輸入賬號',
  '请输入密码': '請輸入密碼',
  '输入密码': '輸入密碼',
  '同步ERP收银员': '同步ERP收銀員',
  '账号不能为空': '賬號不能為空',
  '使用教程': '使用教程',
  '不记名储值卡余额变动提醒': '不記名儲值卡余額變動提醒',
  '不记名储值卡开卡成功提醒': '不記名儲值卡開卡提醒',
  '不记名卡使用验证': '不记名卡使用验证',
  '打印单据张数': '打印單據張數',
  '打印快递单张数': '打印快遞單張數',
  '打印单据': '打印单据',
  '打印快递单': '打印快递单',
  '更新版本': '更新版本',
  '更新版本成功': '更新版本成功',
  '大版本号': '大版本號',
  '忘记密码发送随机密码提醒': '忘記密碼發送隨機密碼提醒',
  '修改密码成功提醒': '修改密碼成功提醒',
  'VIP积分兑换货品短信验证': 'VIP積分兌換貨品簡訊驗證'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/collaboraivePlatform.js
/*
 * @Author: yangchong
 * @Description: 协同办公多语言配置包
 * @Date: 2019-11-30 15:15:06
 */
/* harmony default export */ var zh_hant_collaboraivePlatform = ({
  '序号': '序號',
  '其他平台': '其他平臺',
  '自动获取': '自動獲取',
  '丽晶360终端物流': '麗晶360終端物流',
  'POS自动填充收银员账号&密码': 'POS自動填充收銀員賬號&密碼',
  '协同平台设置': '協同平臺設置',
  '平台名称': '平臺名稱',
  '网址': '網址',
  '输入平台名称': '輸入平臺名稱',
  '输入网址': '輸入網址',
  '需填写http': '需填寫http',
  '确定删除该记录吗？': '確定刪除該記錄嗎？',
  '新增成功': '新增成功',
  '保存成功': '保存成功',
  '请输入平台名称': '請輸入平臺名稱',
  '请输入网址': '請輸入網址',
  '请输入正确的网址': '請輸入正確的網址',
  '删除成功': '刪除成功',
  '新增': '新增',
  '储位系统': '儲位系統',
  '店铺储位管理系统': '店鋪儲位管理系統',
  '自定义排序': '自定義排序',
  '是否取消自定义排序？': '是否取消自定義排序？',
  '已经是第一条，不可上': '已經是第壹條，不可上',
  '已经是最后一条，不可下移': '已經是最後壹條，不可下移',
  '修改成功': '修改成功',
  '取消': '取消',
  '保存': '保存',
  '平台类型': '平臺類型',
  '外挂': '外掛',
  'RP': 'RP'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/report.js
/* harmony default export */ var zh_hant_report = ({
  '报表类型': '報表類型',
  '方案配置': '方案配置',
  '添加方案': '添加方案',
  '将报表方案配置至相应设备类型': '將報表方案配置至相應設備類型',
  '手机/平板': '手機/平板',
  '电脑': '電腦',
  '剩余可用字段': '剩余可用字段',
  '当前使用字段': '當前使用字段',
  '可长按拖动排序': '可長按拖動排序',
  '基础': '基礎',
  '提示': '提示',
  '取消': '取消',
  '确定': '確定',
  '重命名': '重命名',
  '请输入方案名': '請輸入方案名',
  '当前方案正在使用中，无法删除！': '當前方案正在使用中，無法刪除！',
  '确认删除该方案吗？': '確認刪除該方案嗎？',
  '确认将该方案应用于电脑端吗？': '確認將該方案應用於電腦端嗎？',
  '确认将该方案应用于手机/平板端吗？': '確認將該方案應用於手機/平板端嗎？',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗?': '未保存方案的情況下退出會丟失已操作的記錄。確認退出嗎?',
  '执行该操作会刷新页面,请确认右侧方案字段配置操作已保存': '执行该操作会刷新页面,请确认右侧方案字段配置操作已保存',
  '确定删除后会刷新页面，请确认右侧字段已保存': '確定刪除後會刷新頁面，請確認右側字段已保存',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗？': '未保存方案的情況下退出會丟失已操作的記錄。確認退出嗎？',
  '确定命名后会刷新页面，请确认右侧字段已保存': '確定命名後會刷新頁面，請確認右側字段已保存',
  '确定应用后会刷新页面，请确认右侧字段已保存': '確定應用後會刷新頁面，請確認右側字段已保存',
  '报表方案配置': '報表方案配置',
  '方案保存成功': '方案保存成功',
  '方案重命名成功': '方案重命名成功',
  '设备类型激活成功': '設備類型激活成功',
  '删除方案成功': '刪除方案成功',
  '添加成功': '添加成功',
  '保存': '保存'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/receipt.js
/* harmony default export */ var zh_hant_receipt = ({
  '渠道调拨': '渠道調撥',
  '单据编号': '單據編號',
  '手工单号': '手工單號',
  '发货单位': '發貨單位',
  '收货单位': '收貨單位',
  '单据日期': '單據日期',
  '打印人': '打印人',
  '打印时间': '打印時間',
  '备注': '備註',
  '货号': '貨號',
  '品名': '品名',
  '颜色编号': '顏色編號',
  '颜色': '顏色',
  '内长': '內長',
  '数量': '數量',
  '吊牌价': '吊牌價',
  '吊牌额': '吊牌額',
  '发出方签': '發出方簽',
  '日期': '日期',
  '接收方签': '接收方簽',
  '店长复核': '店長復核',
  '竖排': '竖排',
  '横排': '横排',
  '店铺编码': '店鋪編碼',
  '店铺名称': '店鋪名稱',
  '日结日期': '日結日期',
  '销售单情况': '銷售單情況',
  '销售金额': '銷售金額',
  '计收入': '計收入',
  '销售数量': '銷售數量',
  '销售单数': '銷售單數',
  '销售单退货情况': '銷售單退貨情況',
  '退货金额': '退貨金額',
  '退货数量': '退貨數量',
  '退货单数': '退貨單數',
  '销售单付款情况': '銷售單付款情況',
  '储值卡充值情况': '儲值卡充值情況',
  '实收金额': '實收金額',
  '赠送金额': '贈送金額',
  '充值笔数': '充值筆數',
  '所有付款方式汇总': '所有付款方式匯總',
  '班次': '班次',
  '生意额': '生意額',
  '期初': '期初',
  '销售现金': '銷售現金',
  '银行存款': '銀行存款',
  '现金调整': '現金調整',
  '期末': '期末',
  '销售金额（计收入）': '銷售金額（計收入）',
  '服务费付款情况': '服務費付款情況',
  '服务费金额': '服務費金額',
  '服务费数量': '服務費數量',
  '服务费单数': '服務費單數',
  '服务费退款情况': '服務費退款情況',
  '服务费退款': '服務費退款',
  '退款金额': '退款金額',
  '退款数量': '退款數量',
  '退款单数': '退款單數',
  '充值金额': '充值金額',
  '笔': '筆',
  '合计': '合計',
  '渠道': '渠道',
  '收银': '收銀',
  '销售日期': '銷售日期',
  '付款方式': '付款方式',
  '金额': '金額',
  '充值单据': '充值單據',
  '颜色/内长': '顏色/內長',
  '尺码': '尺碼',
  '货品': '貨品',
  '会员价': '會員價',
  '折扣': '折扣',
  '折后价': '折後價',
  '税额': '稅額',
  '会员': '會員',
  '折扣/折后价': '折扣/折後價折后价',
  '税额/金额': '稅額/金額金额',
  '获得积分': '获得积分',
  '储值余额': '储值余额',
  '积分余额': '积分余额',
  '充值时间': '充值时间',
  '服务费': '服務費'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/home.js
/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-26 16:58:06
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-10 18:32:59
 */
/* harmony default export */ var zh_hant_home = ({
  '云POS模块价格说明': '云POS模块价格说明',
  '功能模块': '功能模块',
  '配置化模块': '配置化模块',
  'SAAS租用': 'SAAS租用',
  '购买': '购买',
  '云POS硬件支持情况': '云POS硬件支持情况',
  '物流模块': '物流模块',
  '基础物流模块': '基础物流模块',
  'O2O物流模块': 'O2O物流模块',
  '365/年': '365/年',
  '199/年': '199/年',
  '600元+100元综合维护费/年': '600元+100元综合维护费/年',
  '200元+100元综合维护费/年': '200元+100元综合维护费/年',
  '收银模块': '收银模块',
  '云POS（物流+收银）': '云POS（物流+收银）',
  '730/年': '730/年',
  '1200元+200元综合维护费/年': '1200元+200元综合维护费/年',
  '900/年': '900/年',
  '1400元+200元综合维护费/年': '1400元+200元综合维护费/年',
  '联系我们': '聯系我們',
  '总部:': '總部',
  '地址': '地址',
  '电话': '電話',
  '邮箱': '郵箱',
  '客服中心:': '客服中心',
  '犀牛EPOS · PC版': '犀牛EPOS · PC版',
  '全新上线，给你最美、最流畅的店铺Pos体验': '全新上線，給妳最美、最流暢的店鋪Pos體驗',
  '下载最新版': '下載最新版',
  '运行环境：Win7或更高版本': '運行環境：Win7或更高版本',
  '品牌Webpos下载': '品牌Webpos下載',
  '下载最新定制版': '下載最新定制版',
  '更多': '更多',
  '历史版本': '歷史版本',
  '下载该版本': '下載該版本',
  '收银': '收銀',
  '物流': '物流',
  '报表': '報表',
  '查会员': '查會員',
  '犀牛EPOS': '犀牛EPOS',
  '产品': '產品',
  '客户': '客戶',
  'PC版下载': 'PC版下載',
  '移动版下载': '移動版下載',
  '智慧零售 赋能门店': '智慧零售 賦能門店',
  '为您提供新零售所需要的一切': '為您提供新零售所需要的壹切',
  '销售退换货': '銷售退換貨',
  '预售/赠送': '預售/贈送',
  '流行促销': '流行促銷',
  '会员/积分': '會員/積分',
  '储值/券': '儲值/券',
  '收发货': '收發貨',
  '盘点': '盤點',
  '电商发货/退货': '電商發貨/退貨',
  '真正的移动收银神器': '真正的移動收銀神器',
  '商米/PDA/平板/手机': '商米/PDA/平板/手機',
  '专为服饰零售行业客户而生': '專為服飾零售行業客戶而生',
  '广州丽晶软件科技股份有限公司致力做最杰出的服饰管理专家，着意创建先进、精简、实用高效的电脑信息管理系统，用专注、创新见证着中国服装产业信息化发展进程。丽晶不仅仅要让企业在标准化的行业体系之中占有一席之地，达到灵活调度企业资源，快速感知市场变化，准确规划运营策略，实现销售增长的目的，更要竭尽全力增强服饰企业本身的独特竞争力，指引应用者凭添果敢的能力，激发决策者闪现睿智的灵感，在现在和未来发展与竞争中不断超越！': '廣州麗晶軟件科技股份有限公司致力做最傑出的服飾管理專家，著意創建先進、精簡、實用高效的電腦信息管理系統，用專註、創新見證著中國服裝產業信息化發展進程。麗晶不僅僅要讓企業在標準化的行業體系之中占有壹席之地，達到靈活調度企業資源，快速感知市場變化，準確規劃運營策略，實現銷售增長的目的，更要竭盡全力增強服飾企業本身的獨特競爭力，指引應用者憑添果敢的能力，激發決策者閃現睿智的靈感，在現在和未來發展與競爭中不斷超越！',
  '下载': '下載',
  '全国热线': '全國熱線',
  '周一至周五 9:00-18:00': '周壹至周五 9:00-18:00',
  '公司邮箱': '公司郵箱',
  '粤ICP备12071402号-7': '粵ICP備12071402號-7',
  '粤ICP备12071402号': '粵ICP備12071402號',
  '关于我们': '關於我們',
  '扫码下载，货品管理尽在掌中': '掃碼下載，貨品管理盡在掌中',
  '安卓平板下载': '安卓平板下載',
  '安卓手机下载': '安卓手機下載',
  'iPhone下载': 'iPhone下載',
  'iPad下载': 'iPad下載',
  '品牌订制下载': '品牌訂制下載',
  '总部': '總部',
  '传真': '傳真',
  '点击下载': '點擊下載',
  '犀牛EPOS · 定制版': '犀牛EPOS · 定制版',
  '移动端': '移動端',
  '安卓手机': '安卓手機',
  '安卓平板': '安卓平板',
  '企业后台登录': '企業後臺登錄',
  '运营管理后台': '運營管理後臺',
  '定制版下载': '定制版下載',
  '南京市中山东路18号国际贸易中心12层C3座': '南京市中山東路18號國際貿易中心12層C3座',
  '广州番禺区番禺大道北555号天安节能科技园15号楼102': '廣州番禺區番禺大道北555號天安節能科技園15號樓102'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/index.js
/*
 * @Author: JamesWong
 * @Description: 繁体中文包主入口
 * @Date: 2018-11-29 10:28:01
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-07 01:40:36
 */



















/* harmony default export */ var zh_hant = ({
  main: zh_hant_main,
  home: zh_hant_home,
  appversion: zh_hant_appversion,
  channel: zh_hant_channel,
  warehouse: zh_hant_warehouse,
  activeCode: zh_hant_activeCode,
  account: zh_hant_account,
  payment: zh_hant_payment,
  screen: zh_hant_screen,
  slip: zh_hant_slip,
  self: zh_hant_self,
  inout: zh_hant_inout,
  newSlip: zh_hant_newSlip,
  contract: zh_hant_contract,
  collaboraivePlatform: zh_hant_collaboraivePlatform,
  note: zh_hant_note,
  receipt: zh_hant_receipt,
  report: zh_hant_report
});
// CONCATENATED MODULE: ./src/i18n/en/main.js
/*
 * @Author: JamesWong
 * @Description: 首页英文
 * @Date: 2018-11-29 10:34:46
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-13 13:13:48
 */

/* harmony default export */ var en_main = ({
  productName: 'Xiniu EPOS Company Management System',
  companyNo: 'Company No.',
  companyEnterTips: 'Please enter company No.',
  account: 'Account',
  accountEnterTips: 'Enter account',
  password: 'Password',
  passwordEnterTips: 'Enter password',
  login: 'Login',
  '剩余天数': '，Days left',
  Logout: 'Logout',
  backHome: 'Back to Home',
  openedService: 'Opened service',
  sellModel: 'sell model',
  foundational: 'Foundational In&Out',
  appVersion: 'Application Version',
  authChannel: 'Authorized Channel',
  allAuthChannel: 'Total Authorized Channel Number',
  authWarehouse: 'Warehouse Permit',
  authMumber: 'Authorized Number',
  remainAuthNum: 'Remain Available Authorization Number',
  whalesaleSelected: 'WholesaleRetail Selection',
  deviceActivateManagement: 'Device Activate',
  subScreen: 'Sub-screen Set',
  displayMode: 'Display Mode',
  rollingDisplay: 'Rolling display Photos',
  advertisementVideo: 'Advertisement Video',
  ticketDisposition: 'Ticket Disposition',
  selfcashierDisposition: 'Self-cashier Set',
  onlinePayDisposition: 'Online-Pay set',
  accountModule: 'Account',
  foundationalSet: 'In&Out Model Disposition',
  depositReceipt: 'Deposit Receipt Set',
  loginNumTips: 'Company No. cannot be empty!',
  loginAccountTips: 'Login Account cannot be empty!',
  alipayCall: 'Authorized, pls check on Xiniu EPOS Management System',
  noSet: 'Not set, logistic function cannot normally use',
  storeAuthorizaedManage: 'Channel Permit',
  manageAllFacility: 'Device Binding',
  authorizedMessage: 'Authory-Info',
  '收银模块': 'Sale',
  '物流模块': 'In&Out',
  '其他': 'other',
  record: 'Login Record',
  changeLog: '',
  'deviceChangeLog': 'Change Record',
  'deviceUntiedLog': 'Unbundling Record',
  'Web端使用ERP物流模块': 'WebPOS Using ERP Logistics Module',
  collaboraivePlatformSet: 'Collaborative Platform Setting',
  styleTicketManager: 'Document Printing Style Manager',
  '查看合同': 'Check Contract'
});
// CONCATENATED MODULE: ./src/i18n/en/appversion.js
/*
 * @Author: JamesWong
 * @Description: 应用版本英文包
 * @Date: 2018-11-29 15:14:04
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-29 16:01:48
 */
/* harmony default export */ var en_appversion = ({
  appVersion: 'Application Version',
  backstageVersion: 'Backstage Version',
  enabledIOSVersion: 'Enabled IOS',
  enabledAndroidVersion: 'Enabled Android',
  enabledPadVersion: 'Enabled Android Pad',
  versionUpdateDesc: 'Version Update Description',
  downloadQRcode: 'Download QR code',
  downloadAddress: 'Download Address',
  downloadArticle: 'Download Iteration Advertisement',
  '版本详情': 'Version Detail',
  Close: 'close',
  '点击详情': 'Click Details',
  '未启用': 'Not Enabled',
  '可联系商务开通': 'Can Contact Business to Open',
  '下载链接': 'Download link',
  '下载': 'download'
});
// CONCATENATED MODULE: ./src/i18n/en/channel.js
/*
 * @Author: JamesWong
 * @Description: 授权店铺英文包
 * @Date: 2018-11-29 17:15:51
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-07-30 09:56:04
 */
/* harmony default export */ var en_channel = ({
  authorizedChannel: 'Authorized Channel',
  deletedStore: 'Deleted Store',
  hint: 'Hint',
  deletedStoreTips: 'This Channel cannot login with POS after deleted，Sure to delete this Channel?',
  cancel: 'Cancel',
  confirmDelete: 'Confirm Delete',
  addChannel: 'Add Channel',
  addAuthorizedChannel: 'Add Authorized Channel',
  order: 'Order',
  storeNumber: 'Store Number',
  storeAbbreviation: 'Store Abbreviation',
  storeFullname: 'Store Full-name',
  confirm: 'Confirm',
  searchAuthorizedChannel: 'Search Authorized Channel',
  searchChannel: 'Search  Unauthorized Channel',
  authorizedChannelDeleted: 'Authorized Channel Deleted!',
  authorizedChannelAdded: 'Authorized Channel Added!',
  '渠道配置中心': 'Configuration Center',
  '下载模版': 'Download Template',
  '导入': 'Import',
  '导入教程': 'Import Tutorial',
  '支持通过本地excel表快速导入渠道,点击': 'Support Import Channels Through Excel File',
  '下载模板': 'Download Template',
  '模板第二行开始填写需导入的渠道编号，依次往下录入': 'Import Data Takes Calues from the Second Row of the First Table',
  '选择全部': 'Select All',
  '共': 'total',
  '条': 'page',
  '取消': 'Cancel',
  '确定': 'Confirm',
  '提示': 'Hint',
  '行导入成功，以下': 'row was imported successfully',
  '行数据导入失败': 'and the following xx row data failed',
  '渠道编号': 'Channel No.',
  '知道了': 'I get it'
});
// CONCATENATED MODULE: ./src/i18n/en/warehouse.js
/*
 * @Author: JamesWong
 * @Description: 仓库模块中文包
 * @Date: 2018-11-29 18:56:25
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-17 11:22:34
 */
/* harmony default export */ var en_warehouse = ({
  authorizedWarehouse: 'Authorized Warehouse',
  deleteWarehouse: 'Delete Warehouse',
  hint: 'Hint',
  deleteWarehouseTips: 'This Warehouse cannot login with POS after deleted，Sure to delete this Warehouse?',
  cancel: 'Cancel',
  confirmDelete: 'Confirm Delete',
  addWarehouse: 'Add Warehouse',
  addAuthorizedWarehouse: 'Add Authorized Warehouse',
  searchAuthorizedWarehouse: 'Search Authorized Warehouse',
  Order: 'Order',
  warehouseNumber: 'Warehouse Number',
  warehouseAbbreviation: 'Warehouse Abbreviation',
  warehouseFullname: 'Warehouse Full-name',
  confirm: 'Confirm',
  searchWarehouse: 'Search Warehouse',
  authorizedWarehouseAdded: 'Authorized Warehouse Added!',
  authorizedWarehouseDeleted: 'Authorized Warehouse Deleted!'
});
// CONCATENATED MODULE: ./src/i18n/en/activeCode.js
/*
 * @Author: JamesWong
 * @Description: 激活码模块中文包
 * @Date: 2018-11-29 19:12:37
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-02 11:36:13
 */
/* harmony default export */ var en_activeCode = ({
  activated: 'Activated',
  unactivated: 'Unactivated',
  order: 'Order',
  activeCode: 'Active Code',
  machineNumber: 'Machine Number',
  machineCode: 'Machine Code',
  activeTime: 'Active Time',
  operation: 'Operation',
  delete: 'Delete',
  dataNotAvailable: '暂无数据',
  cancelActived: 'Cancel Actived',
  cancel: 'Cancel',
  comfirm: 'Confirm',
  subactiveCodeCanceled: 'Sub-active Code Canceled！',
  subactiveCodeCanceledTips: 'Sure to cancel the active code for this device?',
  subactiveCodeDeleted: 'Sub-active Code Deleted！',
  subactiveCodeDeletedTips: 'Sure to cancel this active code？'
});
// CONCATENATED MODULE: ./src/i18n/en/account.js
/*
 * @Author: JamesWong
 * @Description: 账户配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 14:59:12
 */
/* harmony default export */ var en_account = ({
  basicInformation: 'Basic Information',
  enterpriseNumber: 'Enterprise Number',
  enterpriseName: 'Enterprise Name'
});
// CONCATENATED MODULE: ./src/i18n/en/payment.js
/*
 * @Author: JamesWong
 * @Description: 支付配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-08 14:13:13
 */
/* harmony default export */ var en_payment = ({
  channelPaymentMethods: 'Channel Payment Methods',
  set: 'Set',
  setPaymentMethods: 'Set Payment Methods',
  confirm: 'Confirm',
  cancel: 'Cancel',
  channel: 'Channel',
  order: 'Order',
  channelNumber: 'Channel No.',
  account: 'Account',
  accountFilter: 'Account Filters',
  weChatScanPayment: 'WeChat Scan',
  paymentSetTips: 'Hint: When editing multiple channels at the same time, you have to select payment method again, or the method will be set as empty',
  pleaseSelectAgain: 'Please select again',
  selectPaymentMethod: 'Select payment method',
  paymentNumber: 'Payment No.',
  merchantID: 'Merchant ID',
  submerchantID: 'Sub-merchant ID',
  Note: 'Note',
  appId: '商户ID',
  token: '授权Token',
  tokenTime: '授权时间',
  wechatFaceIDPay: 'Wechat Face',
  wechatClientSelfpay: 'Wechat Self-buy',
  alipayScancodePay: 'Ali Scan',
  alipayNumber: 'Alipay Number',
  systemBusinessNumber: 'System Business Number',
  enterChannelTips: 'Please enter channel Number/name to search',
  channelName: 'Channel Name',
  wechatPaymentDisposition: 'Wechat Payment',
  wechatPaymentTips: 'Wechat pay support three types of payment:',
  wechatPaymentTips1: '1.Scan pay: Cashier scans client’s payment code, applicable for POS;',
  wechatPaymentTips2: '2.cashier FaceID pay: Client finish Face-scanning payment on certain machine, applicable for self-shopping machine Client;',
  wechatPaymentTips3: '3.self-pay: Client click payment button on personal mobile to open Wechat pay, applicable for Wechat shopping center and scan-pay program.',
  wechatPaymentTipsPlus: 'Note: The three types can only default with one payment each. When channel has not disposed payment methods independently, it will automatically use default payment method. ',
  Mode: 'Mode',
  type: 'Type',
  default: 'default',
  defaultTips: 'Default',
  operate: 'Operate',
  detail: 'Detail',
  paymentMethodDetail: 'Payment Method Detail',
  paymentType: 'Payment Type',
  APPKEY: 'APPKEY',
  certification: 'Certification',
  certificationDocument: 'Certification Document',
  certificationPassword: 'Certification Password',
  alipayPaymentDisposition: 'Alipay Payment',
  status: 'Status',
  authorizedMerchantID: 'Authorized MID',
  unAuthorized: 'Unauthorized',
  authorize: 'Authorize',
  authorized: 'Authorized',
  privateKey: 'Private Key',
  publicKey: 'Public Key',
  signatureType: 'Signature Type',
  selectedTips: 'Pls select channel befor set paymend method',
  success: 'Success',
  configuredChannel: 'Configured Channel',
  reauthorize: 'Reauthorize'
});
// CONCATENATED MODULE: ./src/i18n/en/screen.js
/*
 * @Author: JamesWong
 * @Description: 副屏幕中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 16:53:31
 */
/* harmony default export */ var en_screen = ({
  interactMode: 'Interact Mode',
  rollingPhotos: 'Rolling Display Photos',
  advertisementVideo: 'Advertisement Video',
  interactModeTips1: '1. When cashier machine is not collecting money, sub-screen rolling display Photo/Video in full-screen',
  interactModeTips2: '2. During cashier, sub-screen displays Photo/Video on the left side, and Sales Detail and trade amount on the right side',
  interactModeTips3: '3. After closing counting, sub-screen return to full-screen mode',
  fullscreenPhoto: 'Full-screen Photo',
  fullscreenVideo: 'Full-screen Video',
  photoSalesDetail: 'Photo + Sales Detail',
  videoSalesDetail: 'Video + Sales Detail',
  upload: 'Upload',
  preview: 'Preview',
  previewPhotos: 'Preview Photos',
  delete: 'Delete',
  photoDeleted: 'Photo Deleted!',
  previewVideo: 'Preview Video',
  videoUploaded: 'Video Uploaded!',
  videoSizeTips: 'File size can not exceed 200M!',
  photoUploaded: 'Photo Uploaded!',
  phoneSizeTips: 'File size can not exceed 10M!',
  longNameTips: 'File name cannot too long!',
  moreFileTips: 'Can only upload a video, please delete the original one to try again!',
  uploadingTips: 'The file is uploaded...   Pls wait',
  notSupportTips: 'Your browser does not support video tag',
  uploadProgress: 'Upload progress',
  noVideoTips: 'You have not uploaded video, please upload.',
  noPhotoTips: 'You have not uploaded photo, please upload.',
  Unnamed: 'Unnamed'
});
// CONCATENATED MODULE: ./src/i18n/en/slip.js
/*
 * @Author: JamesWong
 * @Description: 小票配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2021-03-18 20:06:15
 */
/* harmony default export */ var en_slip = ({
  styleDisposition: 'Style Disposition',
  ticketPreview: ' Ticket Preview',
  detail: 'Detail',
  edit: 'Edit',
  save: 'Save',
  cancel: 'Cancel',
  printLabel: 'Print Label',
  reprintLabel: 'Reprint Label(Display only on reprinted receipts)',
  headPhotos: 'Head Photos',
  headPart: 'Head Part',
  ticketInfo: 'Ticket Info',
  ticketNo: 'Ticket No.',
  operateTime: 'Operate Time',
  cashier: 'Cashier',
  assistant: 'Staff',
  assistantCode: 'Staff No.',
  assistantName: 'Staff Name',
  storeNo: 'Store No.',
  storeAddr: 'Store Addr',
  storePhone: 'Store Phone',
  storeMobile: 'Store Mobile',
  VIPNo: 'VIP No.',
  remarks: 'Sales Remark',
  Goods: 'Goods',
  Quty: 'Quty',
  Amt: 'Amt',
  Total: 'Total',
  PriceTotal: 'Price Total',
  Benefit: 'Benefit',
  Change: 'Change',
  ValueBalance: 'Value Balance',
  VIPPrice: 'VIP Price',
  DCT: 'DCT',
  DiscountedPrice: 'Discounted Price',
  TagPrice: 'Tag Price',
  goodsInfo: 'Goods Info',
  promotionInfo: 'Promotion Info',
  allPromotionsTicket: 'All Promotions on this Ticket',
  promotionDesc: 'Promotion Description',
  promotionNotes: 'Promotion Notes',
  paymentMethod: 'Payment Method',
  defaultPayment: 'Default style: due+all applied payment methods',
  tailPhotos: 'Tail Photos',
  salesExplanation: 'Sales Explanation',
  tailpart: 'Tail part',
  quantitySet: 'Quantity Set',
  salesCreateReciept: 'Sales Create Reciept',
  createDeposit: 'Create Deposit',
  numberChannelVersion: 'Number of Printing Channel Version',
  complete: 'Complete',
  numberCustomerVersion: 'Number of Printing Customer Version',
  reprintSalesReciept: 'Reprint Sales Reciept',
  tips: 'Hant',
  updatedTips: 'Ticket Setting Updated！',
  precept: 'Precept',
  cashierAndName: 'Cashier：Sam',
  assistantAndName: 'Assistant：1001-Wang Xiao',
  storeNoAndName: 'Store No.：1009-channel',
  storeAddrAndName: 'Store Addr：Tian\'an Energy-saving Science and Technology Park, Panyu District, Guangzhou',
  payable: 'Payable',
  cash: 'Cash',
  integralBalance: 'Integral Balance',
  printThirtpartOrder: 'Payment Serial No.',
  thridSeralNumber: '3-rd  Party Payment Merchant Payment Serial No.',
  TicketNumberEdited: 'Ticket number edited!',
  TicketNumberEditedError1: 'Enter a number between 0-3',
  TicketNumberEditedError2: 'Quty cannot exceed 3',
  photoUploadTips: 'Note: Select photos first, can use mouse to adjust size and position to ideal printing effect. Such as over the border, the picture will follow 300: 130 to crop.',
  selectPhotos: 'Select Photos',
  leftTurn: 'Left-Turn',
  rightTurn: 'Right-Turn',
  upload: 'Upload',
  confirm: 'Confirm',
  markSet: 'Mark Settings',
  markSetMsg: 'Hide "Channel Version/Customer Version" Mark',
  markSetCustomer: 'Customer Version',
  invoiceScanUrlText: 'Invoice OR Code',
  invoiceScanUrl: 'Show Invoice OR Code（ERP Related Controls Have been Set）',
  invoiceDesc: 'Invoice Des',
  '添加二维码': '添加二维码',
  '请输入二维码内容': '请输入二维码内容',
  '自定义二维码': '自定义二维码',
  '二维码描述': '二维码描述',
  '销售单号': '销售单号',
  '手工单号': '手工单号',
  '会员卡号': '会员卡号',
  '会员手机': '会员手机',
  etc: ' etc',
  Coupon: ' Coupon',
  Date: 'Date',
  printCoupons: 'Print Coupon',
  promoteCounpon: 'Promotional Coupons',
  rechargeCounpon: 'Top-Up Coupons',
  primeCostInfo: 'Original Price Total',
  primeCostInfoDetail: '(The total price tag of goods)',
  DiscountTotal: 'Discounted Price',
  alreadyDiscountInfo: 'Discounted',
  alreadyDiscountInfoDetail: '(Discounted=The price tag-Total amount payable)',
  实付: 'actual payment',
  生意额: 'Business volume',
  getIntegrateInfo: 'Get Integral',
  remainingIntegrateInfo: 'Integral balance',
  uploadPhoto: 'Upload Photos',
  autoSavePhoto: 'Auto Generate Barcode Pic',
  autoSelectNum: 'Select Auto Generate Barcode Ticket No.',
  Saleno: 'Sale Ticket No.',
  manualSaleNo: 'Manual Receipt No.',
  barCode: 'barCode',
  qrCode: 'QRcode',
  takeCareMsg: 'Notice: Manual Receipt No. is longer, and will be over-length if exchange to Barcode that cannot be scanned, suggest to use QR Code',
  cancelMsg: 'Cancel',
  saveMsg: 'Save',
  addParagraph: '+Add Paragraph',
  addEmptyParagraph: '+Add Blank Line',
  paragraphMsg: 'Paragraph',
  leftAlign: 'Left alignment',
  centerAlign: 'Centered',
  deleteMsg: 'Delete',
  blankLine: 'Blank Line',
  goodsSpace: 'Goods Display',
  goodsSpaceMsg: 'Separated by blank lines between goods',
  showGoodsTotal: 'Goods Total',
  showGoodsTotalMsg: 'Display Total',
  middlePic: 'Custom Image',
  tailImageDesc: 'Image Caption',
  barCodeStyle: 'SKU Style',
  smallTicketNum: 'Ticet No.',
  goodsType10: 'SKU',
  goodsType10Unique: 'Unique Code',
  goodsType17: 'SKU/Unique Code',
  goodsType2: 'SKU/Name',
  goodsType2Unique: 'Unique Code/Name',
  goodsType22: 'SKU/Category',
  goodsType22Unique: 'Unique Code/Category',
  goodsType4: 'SKU/Name/Tag Price',
  goodsType4Unique: 'Unique Code/Name/Tag Price',
  goodsType44: 'SKU/Category/Tag Price',
  goodsType44Unique: 'Unique Code/Category/Tag Price',
  goodsType5: 'SKU/Name/VIP Price/Discounted Price',
  goodsType5Unique: 'Unique Code/Name/VIP Price/Discounted Price',
  goodsType55: 'SKU/Category/VIP Price/Discounted Price',
  goodsType55Unique: 'Unique Code/Category/VIP Price/Discounted Price',
  goodsType7: 'SKU/Name/VIP Price/DCT/Discounted Price',
  goodsType7Unique: 'Unique Code/Name/VIP Price/DCT/Discounted Price',
  goodsType77: 'SKU/Category/VIP Price/DCT/Discounted Price',
  goodsType77Unique: 'Unique Code/Category/VIP Price/DCT/Discounted Price',
  goodsType1: 'Goods NO.-Name/Color/Length/Size',
  goodsType6: 'Goods NO.-Name/Color/Length/Size/VIP Price/Discounted Price',
  goodsType8: 'Goods NO.-Name/Color/Length/Size/VIP Price/DCT/Discounted Price',
  goodsType3: 'Goods NO.-Name/Color/Length/Size/Tag Price',
  goodsType9: 'Goods NO.-Name/Color/Length/Size/Tag Price/DCT/Discounted Price',
  goodsType11: 'Goods NO.-Category/Color/Length/Size',
  goodsType66: 'Goods NO.-Category/Color/Length/Size/VIP Price/Discounted Price',
  goodsType88: 'Goods NO.-Category/Color/Length/Size/VIP Price/DCT/Discounted Price',
  goodsType33: 'Goods NO.-Category/Color/Length/Size/Tag Price',
  goodsType99: 'Goods NO.-Category/Color/Length/Size/Tag Price/DCT/Discounted Price',
  goodsType100: 'Goods NO.-Category/Color/Length/Size/RetailPrice/DCT/Discounted Price',
  categoryReplaceName: 'Use Goods Class instead of Goods Name',
  uniqueReplaceBarcode: 'Use Unique Code instead of Barcode',
  Amt_mang: 'Amt ',
  Available: ' Available',
  '渠道配置中心': 'Configuration Center',
  '单据打印样式管理': 'Document Printing Style Manager',
  '配置样式请至渠道配置中心操作': 'Set Style in "Configuration Center"',
  '单据': 'Invoice',
  '新增简易版样式': 'New Simple Version',
  '新增定义版样式': 'New Custom Version',
  '自定义版': 'Custom',
  '简易版': 'Simple',
  '简易版编辑器': 'Simple Editor',
  '自定义编辑器': 'Custom Editor',
  '空样式': ' Style',
  '样式名称': 'Style Name',
  '样式文档名称': 'Style Name',
  '输入样式文档名称': 'Enter Style Name',
  '建议备注宽度以便区分': 'Recommended note width for easy differentiation',
  '图片大小不超过': 'Picture Size is Less than ',
  '选择单据': 'Select Receipt',
  '选择模版': 'Select Template',
  '空白模版': 'Blank Template',
  '请检查样式是否缺漏': 'Please check for missing styles',
  '您正在进行模版编辑操作, 是否放弃编辑?': 'You are editing a template. Do you want to abandon editing?',
  '销售单': 'Sales',
  '定金单': 'Deposit',
  '日结': 'Day-End',
  '交接班': 'Shift Change',
  '本机日收银': 'Day\'s Cashier of Machine',
  '充值单': 'Top-Up',
  '调拨收货': 'Allocates Receive Goods',
  '采购收货': 'Purchases Receive Goods',
  '渠道收货': 'Channel Receive Goods',
  '渠道调拨': 'Channel Allocate Goods',
  '渠道退货': 'Channel Return Goods',
  '仓库出货': 'Warehouse Shipping',
  '渠道采购到货通知': 'Channel Arrive Notice',
  '渠道调出通知': 'Channel Callout Notice',
  '退货通知': 'Return Notice',
  '渠道采购退货通知': 'Channel Purchase Return Notice',
  '线上订单发货': 'Online Order Delivery',
  '收货单': 'Receiving Invoice',
  '成品采购入库单(基础)': 'End Product Purchase Storage Invoice(Basic)',
  '发货单': 'Delivery Invoice',
  '采购退货': 'Purchases Return Goods',
  '紧急发货(基础)': 'Urgent Deliver(Basic)',
  '配货单(基础)': 'Distribution  Invoice(Basic)',
  '发货退货(基础)': 'Delivery Return(Basic)',
  '到货通知单(基础)': 'Arrive Notice(Basic)',
  '采购退货(基础)': 'Purchase Return(Basic)',
  '采购退货通知(基础)': 'Purchase Return Notice(Basic)',
  '验货(基础)': 'OMS Inspection(Basic)',
  '自定义文本': 'Custom Text',
  '模版名称': 'Template Name',
  '模板已保存': 'Template saved',
  '可通过渠道配置中心配置渠道使用': 'Can be used by "Configuration Center"',
  '选择样式': 'Select Style',
  '税额': 'GST Amt',
  '显示税额': 'Show GST Amt',
  '买满立减(按单)': 'Deduct at certain Amt (by Bill)',
  '买满打折(按货品)': 'Deduct at certain Amt (by Goods)',
  '买满送优惠券': 'Coupon back at certain amt',
  '顾客签名栏': 'SIGNATURE',
  '打印太阳码': 'Print Sun Code',
  '显示顾客签名栏': 'Print Customer Signature Bar',
  '显示已用代用券券号': 'Print Used Coupon No.',
  '已用代用券': 'Coupon No.',
  '折扣取反(适用于非中国大陆地区)': 'Reverse Discount (For Non-Mainland China)',
  '会员姓名': 'VIP Name',
  '会员等级': 'VIP Level',
  '营业员(货品)': 'STAFF NAME(GOODS)',
  'A4显示货品营业员': 'Print Staff Name of Goods（ONLY A4）',
  '代用券': 'Coupon No.',
  '营业员': 'STAFF NAME',
  '顾客签名': 'SIGNATURE',
  '渠道调入': 'Channel Call-in',
  '发货': 'Deliver',
  '配单': '',
  '退货': 'Return',
  '定金单号': 'Deposit Receipt No.',
  '核销单号': 'Sales-Order No.',
  'printCounterChannelAbb': 'shoppe',
  'printCounterChannelAbbs': 'shoppe',
  '活动说明': '',
  '显示赠送代用券活动说明': '',
  '批量打印': '',
  '顺丰面单打印': '',
  '零售配单验货': '',
  '销补发货': '',
  '收货工作台': '',
  '线上订单工作台': '',
  维修单: '维修单',
  补货: '补货',
  '发快递（影儿）': '发快递（影儿）',
  '价签打印': 'Price Label Printing'
});
// CONCATENATED MODULE: ./src/i18n/en/self.js
/*
 * @Author: JamesWong
 * @Description: 自助收银中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-26 19:47:57
 */
/* harmony default export */ var en_self = ({
  authorizedDevice: 'Authorized Device',
  remainDevices: 'Remain Available Authorization Number of Devices',
  order: 'Order',
  authorizationTime: 'Authorization Time',
  machineNumber: 'Machine Number',
  machineCode: 'Machine Code',
  operate: 'Operate',
  cancelAuthorization: 'Cancel Authorize',
  cancelAuthorizeDevice: 'Cancel Authorize device',
  cancelAuthorizationTips: 'Sure to cancel authorize device?',
  cancel: 'Cancel',
  confirm: 'Confirm',
  rollingPhotos: 'Display Photos',
  uploadPhotosTips: 'Photo ratio 16:9, size not exceed 5M',
  upload: 'Upload',
  previewPhotos: 'Preview',
  delete: 'Delete',
  deleted: 'Deleted!',
  createQRcode: 'VIP Created QRcode',
  uploadQRcodeTips: 'Photo ratio 1:1, size not exceed 1M',
  uploadingTips: 'The file is uploaded... Pls wait',
  uploadProgress: 'Upload progress',
  Unnamed: 'Unnamed',
  photoUploaded: 'Photo Uploaded!',
  phoneSizeTips: 'The file can not exceed 1M',
  phoneSizeTips5: 'File size can not exceed 5M!',
  longNameTips: 'File name cannot too long!',
  noPhotoTips: 'You have not uploaded photo, please upload.',
  deletedError: 'deleted Error!',
  cancelAuthorized: 'Cancel authorized success!'
});
// CONCATENATED MODULE: ./src/i18n/en/inout.js
/*
 * @Author: JamesWong
 * @Description: 物流配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-19 17:44:15
 */
/* harmony default export */ var en_inout = ({
  receive: 'Receive',
  deliver: 'Deliver',
  inventory: 'Check/Inventory',
  createInvoice: 'Create Invoice',
  dispose: 'Dispose',
  modelDisposition: 'Model Disposition',
  modelName: 'Model Name',
  enterModelnameTips: 'Please enter Model name',
  modelId: 'Model ID',
  enterModelIdTips: 'Please enter Model ID',
  noticeName: 'Notice Name',
  noticeName1: 'StockCheck Name',
  enterNoticenameTips: 'Please enter Notice name',
  enterNoticenameTips1: 'Please enter StockCheck Name',
  noticeId: 'Notice ID',
  noticeId1: 'StockCheck ID',
  enterNoticeIdTips: 'Please enter Notice ID',
  enterNoticeIdTips1: 'Please enter StockCheck ID',
  confirm: 'Confirm',
  cancel: 'Cancel',
  noticeModelName: 'Notice Model Name',
  noticeModelId: 'Notice Model ID',
  operate: 'Operate',
  edit: 'Edit',
  delete: 'Delete',
  stockCheckPlan: 'Stock Check Analysis',
  stockCheckAnalysis: 'Stock Check Plan',
  stockChecklist: 'Stock Checklist',
  modelAddSuccess: 'Model Added',
  modelUpdateSuccess: 'Model Updated',
  deliveryNotice: 'Delivery Notice',
  replenishment: 'Replenishment'
});
// CONCATENATED MODULE: ./src/i18n/en/note.js
/* harmony default export */ var en_note = ({
  '短信设置': 'SMS Manage',
  '短信模版': '',
  '返回': 'Back',
  '查看流水': '',
  '短信供应商平台': 'SMS Provider Platform',
  '供应商': 'Supplier',
  '账号': 'Account',
  '密码': 'Password',
  '取消': 'Cancel',
  '确定': 'Confirm',
  '编辑模板': 'Editing Template',
  '保存': 'Save',
  '短信模板预览': 'SMS Template Preview',
  '短信模板编辑区': 'Editing Area',
  '不同短信供应商对短信字数限制不一，可能存在字数溢出的情况，请酌情规划模板字数': 'Different SMS platform limit on the number of words differ, there may be instances of words overflow, as appropriate, please plan template word.',
  '基本信息取值区': 'Basic Information Value Area',
  '点击将标签插入模板，短信会根据标签写入实际数值': 'Click to insert the label into the template, the SMS will write the actual value according to the label.',
  '验证码': 'Verify Code',
  '提示': 'Hint',
  '若模板没有保存，直接返回会丢失已修改的模板哦。确定吗？': 'If the template is not saved, returning directly will lose the modified template. Sure?',
  '功能类型': 'Function Type',
  '短信类型': 'SMS Type',
  '短信属性': 'SMS Template',
  '操作': 'Operation',
  '全局': 'Overall',
  '渠道': 'Channel',
  '开卡': 'Create New VIP',
  '储值卡': 'VIP Value',
  '消费': 'Consumption',
  '其他': 'Other',
  '开卡手机验证码': 'VIP Created Mobile Verification',
  '开卡成功提醒': 'VIP Created Success Reminder',
  '会员储值卡使用验证码': 'VIP Cards Use A Verification Code',
  '会员储值卡充值成功提醒': 'VIP Top-up Successful Reminder',
  '会员储值卡消费成功提醒': 'VIP Top-up Used Successful Reminder',
  '会员积分使用验证码': 'VIP Points Use A Verification Code',
  '会员积分充值成功提醒': 'VIP Points Successful Reminder',
  '会员积分消费成功提醒': 'VIP Points Used Successful Reminder',
  '特殊会员VIP折扣使用': 'Premium VIP Verification',
  '高级折扣权限短信验证码': 'Senior DCT Limited SMS Verification Code',
  '消费成功提醒': 'Consumption Success Reminder',
  '定金单下单成功提醒': 'Deposit  Recipet Success Reminder',
  '修改会员手机号成功提醒': 'Modify VIP Mobile Successful Reminder',
  '会员等级变动提醒': 'VIP Level Change Reminder',
  '停用': 'Stop',
  '启用': 'Enabled',
  '未开通短信服务': 'Not opened SMS notification service',
  '请联系信息部门': ' pls contact IT Dept',
  '店铺': 'Channel ',
  '搜索': 'Search',
  '店铺编号': 'Channel Code',
  '店铺名称': 'Channel Name',
  '知道了': 'I get it',
  '快捷设置': 'Quick Setup',
  '刷新促销': 'Update Promotion',
  'Web端使用ERP物流模块': 'WebPOS Using ERP Logistics Module',
  '渠道(批量)选择': '',
  '查询': 'Search',
  '渠道编号': 'Channel No.',
  '请输入渠道编号': 'Enter Channel No.',
  '渠道简称': 'Channel Name',
  '请输入渠道简称': 'Enter Channel Abbr Name',
  '经营模式': 'Business Module',
  '经营方式': 'Business Methods',
  '输入或选择': 'Enter/Choose',
  '公司': 'Company',
  '组': 'Group',
  '国家': 'Country',
  '销售类别': 'Sales Type',
  '渠道配置（已选择': 'Channel configuration (selected',
  '复制渠道配置（已选择': 'Copy Channel configuration (selected',
  '个渠道': 'channel',
  '单据打印样式': 'Document Print Style',
  '单据': 'Invoice',
  '销售单': 'Sales-Order',
  '定金单': 'Deposit Receipt',
  '会员充值单': 'Top-Up Receipt',
  '日结': 'Day-End',
  '交接班': 'Shift-turning',
  '本机日收银': 'Day\'s Cashier of Machine',
  '发货单': 'Delivery Invoice',
  '单据打印张数': 'Document Print No.',
  '短信模板': 'SMS Template',
  '选择短信模板': '',
  '模版方案': 'Template Scheme',
  '模版内容': 'Template Content',
  '阿里云短信签名': 'Ali Cloud SMS Signature',
  '选择短信签名': '',
  '保存成功': 'Saved',
  '打印张数': 'Document Print No.',
  '输入张数': 'Enter No.',
  '做单打印': 'Sales Print',
  '店铺联': 'Store Version',
  '客户联': 'Custome Version',
  '张数': 'Number',
  '不能全部为零': 'Not All Zero',
  '请填写完整的张数': 'Enter Fill No. of  Pages',
  '选择样式': 'Select Style',
  '简易版': 'Light Version',
  '简易版支持全部终端': 'Simple Version Supports All Machine Type',
  '类型': 'Type',
  '自定义版': 'Custom Version',
  '样式名称': 'Template Name',
  '预览': 'Preview',
  '自定义版仅支持Webpos优先使用': 'Custom Version Only Spports WEBPOS to USE',
  '变更记录': 'Change Log',
  '销售单小票': 'Sales',
  '定金单小票': 'Deposit',
  '充值单': 'Top-up Receipt  ',
  '请先选择模版': 'Select Template First',
  '再保存': 'Then save',
  '充值单据': 'Top-up Receipt',
  '500条/页': '500Page/Tage',
  '第': 'Page',
  '页': '',
  '序': 'Order',
  '共': 'Toal',
  '配置': 'Manage',
  '没有可选的数据': '',
  '渠道配置中心': 'Configuration Center',
  '支持配置小票样式&打印张数、短信模板': 'Support to configure receipt style & number of prints, SMS template',
  '已选择': 'Has chosen ',
  '状态': 'status',
  '配置说明': 'Configuration Instructions',
  '配置后，POS需重新登录后生效': 'Once Configured, POS must Re-Login',
  '渠道(批量)': 'Channel(Batch)',
  '请输入内容': 'Enter Content',
  '选项': 'Option',
  '清空': 'Clear',
  '列表': 'List',
  '编辑': 'Edit',
  '户口': 'Account',
  '批量配置单据打印样式': 'Set Print Style',
  '批量配置单据打印张数': 'Set Print No.',
  '批量配置短信模板': 'Set SMS Template',
  '复制其他渠道模板': 'Copy values to other channel templates',
  '会员充值小票': 'Top-Up Receipt',
  '日结小票': 'Day-End',
  '交接班小票': 'Shift Change',
  '本机日收银小票': 'Day\'s Cashier of Machine',
  '发货单小票': 'Shipping',
  '做单打印张数 店铺联/客户联': 'Document Print No. Store Version/Custome Version',
  '重打印张数 店铺联/客户联': 'Reprint No. Store Version/Custome Version',
  '未选择业务属性': 'No Business Type Selected',
  '请选择渠道': 'Select Channel',
  '同步ERP渠道资料成功！': 'ERP Channel Data Synchronization Success!',
  '系统默认模版': 'System Default Template',
  '做单': 'Sale',
  '企事业单位的全称或简称': 'Enterprises and Institutions Full or Abbreviated',
  '工信部备案网站的全称或简称': 'Full or Abbreviated Website of the Ministry of Industry for the Record',
  'APP应用的全称或简称': 'Full or Abbreviated Name of APP',
  '公众号或小程序的全称或简称': 'Full or Abbreviated Name of Wechat Public Account and Mini Program',
  '电商平台店铺名的全称或简称': 'Full or Abbreviated Name of E-commerce Platform Stores',
  '商标名的全称或简称': 'Full or Abbreviated Name of Trademark',
  '请输入签名来源': 'Enter Signature Source',
  '请输入签名说明': 'Enter Signature Description',
  '重新上传成功': 'Re-upload succeeded',
  '添加成功': 'Added',
  '上传图片不能大于2M': 'Picture Size is Less than 2M',
  '短信模板数量不能超过10个': 'SMS Termplast cannot Exceed 10',
  '请输入名称': 'Enter Name',
  '保存后': '',
  '模版将提交审核，': ' will be submitted for review after saving，',
  '审核通过前短信模版无法使用，确认吗？': 'It is unavailable before passing the audit. Confirm？',
  '已经存在该字段，不可重复添加': 'This Field Already Exists, Add Unrepeatable',
  '请选择要编辑的模版': 'Please Select a Template to Edit',
  '保存置灰且点击提示“审核中”“审核通过”模板不可修改': '',
  '删除成功': 'Deleted',
  '超过最大字数': 'Exceed the Maximum Number of Words',
  '模版中含有非法取值字段，请先删除再保存': 'Template contains an illegal value field, delete and then save',
  '短信模板不能为空！': 'SMS Template cannot be Empty',
  '短信模板缺少验证码！': 'SMS Template Missing Verification Code!',
  '短信模板保存成功': 'SMS Tmplate Saved Successfully',
  '重命名成功': 'Scheme Re-name Successed',
  '同步阿里云签名': 'Synchronization Signature of Ali Cloud',
  '输入在阿里云后台注册的签名名称，同步至企业管理后台': 'Enter the signature name in the register of Ali cloud background, synchronized to business management background',
  '签名名称不能为空': 'Signature Name Cannot be Empty',
  '同步签名成功': 'Synchronization Signature Successfully',
  '更新默认签名成功': 'Update Default Signature Succeeded',
  '删除签名成功': 'Deleted Signature Successfully',
  '请勿轻易切换供应商，审核状态将会被重置！': 'Do not switch suppliers easily, the audit status will be reset!',
  '添加账号': 'ADD ACCOUNT',
  '审核状态': 'Exam-status',
  '默认': 'Default',
  '重命名': 'Rename',
  '删除': 'Del.',
  '添加国际模板': 'International Template',
  '添加中文模板': 'Chinese Template',
  '国际': 'International',
  '中文': 'Chinese',
  '审核通过': 'Exam-Passed',
  '未审核': 'Un-Examined',
  '审核中': 'Examing',
  '审核失败': 'Examined Failed',
  '短信供应商设置': 'SMS Provider Platform',
  '短信签名': 'SMS Signature',
  '模板内容': 'Template Content',
  '模板方案': 'Template Scheme',
  '申请说明': 'Application Des',
  '签名名称': 'Signature Name',
  '同步阿里云短信签名': 'Sync Aliyun SMS signature',
  '默认签名': 'Default Signature ',
  '审核备注': 'Examine Note',
  '签名来源': 'Signature Source',
  '添加短信签名': 'Add SMS Signature',
  '同步ERP渠道资料': 'Upgrating ERP Channel Info',
  '重新上传': 'Re-upload',
  '确认删除该短信模板吗？': 'Are you sure to delete the SMS template?',
  '未配置模板的渠道将按默认模板发送短信': 'Channels without a configured template will send SMS according to the default template',
  '确认切换默认模板吗？': 'Confirm Switch the Default Template?',
  '添加模板': 'Add the template',
  '确认删除该短信签名吗？': 'Confirm to delete this message signature?',
  '请在申请说明中 详细描述您的业务使⽤场景，申请⼯信部备案⽹站的全称或简称请在此处填写域名，长度不超过200个字符': 'Please describe your business use scenario in detail in the application description, apply for the full name or abbreviation of the website registered by the Ministry of Information, please fill in the domain name here, no more than 200 characters',
  '请输入签名名称': 'Enter Signature Name',
  '当前⽀持jpg、png、gif或 jpeg格式的图⽚。': 'Currently supports images in jpg, png, gif or jpeg format.',
  '签名的证明⽂件格式，⽀持上传多张图⽚。': 'The signed certificate file format supports uploading multiple pictures.',
  '图片不超过2M': 'The picture is no more than 2M',
  '提交审核': 'Submit & Examined',
  '证明文件': 'Supporting documents',
  '短信签名未设置': 'SMS Signature Not Manage',
  '短信将无法发送': 'SMS Cannot Send',
  '区域': 'Area',
  '省份': 'Provinces',
  '渠道性质': 'Channel Type',
  '店铺联/顾客联打印张数不能全部为0': '店铺联/顾客联打印张数不能全部为0',
  '销售退款（储值积分返还）提醒': 'Sales Refund (Return of Stored Value & Points) Reminder',
  '渠道调出': 'Channel Call-out',
  '渠道退货': 'Channel Returns',
  '采购退货': 'Purchase Return',
  '退货通知': 'Returns Notice',
  '线上订单发货': 'Online Order Delivery',
  '渠道调入': 'Channel Call-in',
  '渠道收货': 'Channel-in',
  '退货': 'Return',
  '紧急发货': '',
  '发货': '',
  '配单': '',
  '全部': 'All',
  '重打印': 'Reprint',
  '积分': 'Points',
  '是否保存模板？': '',
  '配置教学': 'Configure Teaching',
  '已配置短信渠道': 'SMS Channel Configured',
  '已开启ERP权限': 'Turned ERP Eights',
  '未开启ERP权限': 'ERP is not Turned on Rights',
  '配置了该短信模板且已开通ERP权限的渠道，可正常使用短信功能': 'Configuring the SMS templates and permission has opened ERP Channel, can use SMS function normally',
  '配置了该模板但未开通ERP权限的渠道,请前往ERP渠道资料开通权限': 'The template is configured channels but did not open ERP rights Please go to the opening of ERP channel permissions',
  '短信配置主要为以下流程': 'SMS Configuration is Mainly the Following Process',
  '设置好短信签名，提交供应商审核（部分供应商无需配置签名）': 'Set up SMS signature, submit Supplier Audit (some vendors do not need to configure signature)',
  '点击短信类型右侧的编辑模板，保存后提交供应商审核': 'Click On the Right Type of SMS Template Editing, Save Submission Supplier Audit',
  '到': 'Reach',
  '开通渠道': 'Open Channel',
  '给不同渠道配置对应模板': 'In channel configuration center, channel configuration corresponds to a different template',
  '前往ERP渠道资料，开启所有渠道的短信发送权限': 'Go ERP channel information, open the SMS permissions for all channels',
  '请先选择模版再保存': 'Select Template First',
  '全部数据导入成功': 'All data imported successfully',
  '零售方式': 'Retail Methods',
  '积分清零提醒': '',
  '生日代用券': '',
  '短信签名一般为品牌名称，顾客短信可见，必填': '',
  '请填写短信签名': '',
  '若清空供应商，可能会丢失原有短信供应商的模板审核状态，请谨慎操作': '',
  '查询结果': 'Search Result',
  '搜索渠道': 'Search Channel',
  '重置': 'Reset',
  '条': 'Article',
  '100条/页': '100/Line',
  '200条/页': '200/Line',
  '300条/页': '300/Line',
  '400条/页': '400/Line',
  '800条/页': '800/Line',
  '1000条/页': '1000/Line',
  '请输入账号': 'Pls Enter Account(Acc)',
  '输入账号': 'Enter Account(Acc)',
  '请输入密码': 'Pls Enter Code',
  '输入密码': 'Enter Password',
  '账号不能为空': 'Must have Acc',
  '同步ERP收银员': 'Upgrating ERP Salesman Info',
  '使用教程': 'help documents',
  '不记名储值卡余额变动提醒': 'Balance Change Of The Stored-Value Card Reminder',
  '不记名储值卡开卡成功提醒': 'Opening Stored-Value Card Successful Reminder',
  '打印单据张数': '',
  '打印快递单张数': '',
  '打印快递单': '',
  '打印单据': '',
  '不记名卡使用验证': '',
  '更新版本': 'Updated version',
  '更新版本成功': 'Version updated successfully',
  '大版本号': 'Large version number',
  '忘记密码发送随机密码提醒': 'Forgot password send a random password reminder',
  '修改密码成功提醒': 'The password is changed successfully',
  'VIP积分兑换货品短信验证': ''
});
// CONCATENATED MODULE: ./src/i18n/en/newSlip.js
/*
 * @Author: JamesWong
 * @Description: 3.2小票配置
 * @Date: 2019-01-04 14:59:12
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-07 11:40:50
 */
/* harmony default export */ var en_newSlip = ({
  confirm: 'Confirm',
  cancel: 'Cancel',
  channel: 'Channel',
  order: 'Order',
  templateName: 'Template Name',
  added: 'Added',
  enterTemplateName: 'Please enter template name',
  Operation: 'Operation',
  edit: 'Edit',
  filters: 'Channel Type Filters',
  defaults: 'Defaults',
  review: 'Review',
  delete: 'Delete',
  channelNumber: 'Channel No.',
  salesCreateReciept: 'Sales',
  createDeposit: 'Deposit',
  account: 'Account',
  pleaseSelectAgain: 'Please select again',
  channelRecipetConfiguration: 'Channel Recipet Configuration',
  recipetTemplate: 'Recipet Template',
  depositTemplate: 'Deposit Template',
  numberTemplate: 'Number Template',
  channelType: 'Channel Type',
  recipetStyle: 'Recipet Style',
  saleVersion: 'Sale Channel/Customer Version',
  reprintVersion: 'Reprint Channel/Customer Version',
  selectChannelSettings: 'Select Channel Settings',
  setChannelType: 'Set by Channel Type',
  setbyAccount: 'Set by Account',
  channelSelected: 'Channel Selected',
  SaleNum: 'Channel/Customer Version No.',
  ReprintNum: 'Reprint-Channel/Customer Version No.',
  selectChannel: 'Select Channel',
  saleRecipetNumberTemplate: 'Sale Recipet Number Template',
  depositRecipetNumberTemplate: 'Deposit Recipet Number Template',
  reprintNumberTemplate: 'Reprint Number Template',
  businessType: 'Business Type',
  number: 'Number',
  selectTips: 'Please select the channel first to set the recipet style',
  setTips: 'Setted!',
  styleWarn: "Please select 'Recipet Style' template",
  sellWarn: "Please select 'Sales-Channel/Customer Version No.' template",
  sellWarn2: "Please select 'Deposit-Channel/Customer Version No.' template",
  reprintWarn: "Please select 'Reprint-Channel/Customer Version No.' template",
  noset: 'No Set Channel Type',
  select: 'selected',
  numTypeSale: 'Sale-Channel/Customer Version',
  numTypeReprint: 'Reprint-Channel/Customer Version',
  deleteReceiptModel: 'Delete Recipet Template',
  deleteTips: 'Delete the recipet template?',
  addtips: 'Added',
  edittips: 'Edited'
});
// CONCATENATED MODULE: ./src/i18n/en/contract.js
/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-26 16:58:06
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-11-02 13:04:46
 */
/* harmony default export */ var en_contract = ({
  '序号': 'No.',
  'EPOS授权信息': 'EPOS Authorization Info',
  '汇总：': 'Sum',
  '剩余': 'Balance',
  '绑定类型：': 'Binding Type:',
  '剩余天数': 'Days Left ',
  '操作': 'Operation',
  '查看': 'Search',
  '店铺授权容量': 'Channel Authorization Quty',
  'WEB授权容量': 'WEB Authorization Quty',
  '移动授权容量': 'Mobile Authorization Quty',
  '合同编号': 'Contract No.',
  '开始/结束时间': 'Begin/End Time',
  'Android平板': 'Android Pad',
  'Android手机': 'Android Mobile',
  'IPhone': 'IPhone',
  'IPAD': 'IPAD',
  'WEB': 'WEB',
  '授权信息': 'Authorization Info',
  '查看变更记录': 'Search Changing Records',
  '店铺授权清单': 'Channel Authorization List',
  '设备归属清单': 'Device Belonging List',
  '新增授权店铺': 'Add Authorized Channel',
  '管理所有店铺授权': 'Manage All Channel Authorization',
  '管理所有归属设备': 'Manage All Belonged Devices',
  '关闭': 'Close',
  '授权全部渠道': 'Authorize All Channels',
  '确认授权所有店铺？': 'Confirm authorize to all channels?',
  '操作日期': 'Operation Date',
  '类型': 'Type',
  '操作内容': 'Details',
  '操作人': 'Operator',
  '店铺编号': 'Channel No.',
  '店铺简称': 'Channel Abbr Name',
  '店铺全称': 'Channel Full Name',
  'WEB设备': 'WEB Devices',
  '移动': 'Mobile',
  '机器编号': 'Machine No.',
  '机器码': 'Machine Code',
  '设备类型': 'Device Type',
  '绑定类型': 'Binding Type',
  '绑定日期': 'Binding Date',
  '状态': 'Status',
  '余量：': 'Quty Balance',
  '（含扩容：': '(Include Expanding:',
  '该店铺不存在或已授权': 'This Channel does not Exsist or Authorized',
  '请输入': 'Enter',
  '授权设备类型': 'Authorizing Device Type',
  '绑定状态': 'Binding Status',
  '请选择': 'Select',
  '筛选': 'Filter',
  '清空': 'Clear',
  '返回': 'Return',
  '设备绑定列表': 'Device Binding List',
  '解除绑定': 'Unbind',
  '移出黑名单': 'Move from Black List',
  '加入黑名单': 'Add to Black List',
  '全选': 'Select All',
  '提示': 'Hint',
  '取消': 'Cancel',
  '确定': 'Confirm',
  '正常': 'Normal',
  '白名单': 'White List',
  '黑名单': 'Black List',
  '激活码': 'Activate Code',
  '安卓手机': 'Android Mobile',
  '安卓平板': 'Android Pad',
  '禁用': 'Forbbiden',
  '启用': 'Enabled',
  'EPOS版本': 'EPOS Version',
  '企业': 'Company',
  '企业编号': 'Company No.',
  '设备机型': 'Device Type',
  '系统版本号': 'System Version',
  'EPOS版本号': 'EPOS Version',
  '数量': 'Quantity',
  '解除往期的激活码/店铺容量绑定，避免影响店铺pos数量超出限额，确认提示框提醒是否继续操作': '',
  '允许登陆pos': 'Unbind with Activate code/Channel capacity in the past, to avoid channel pos quty exceed limitation, confirm the hint whether continue this operation?',
  '释放往期的激活码/店铺容量': 'Release Activate code/Channel Quty',
  '限制登陆pos，需解除绑定激活码、解除店铺归属，是否继续操作': 'Limit logging in EPos, need to unbound Activate code and channel belonging, confirm the hint whether continue this operation?',
  '是否解除绑定': 'Whether Unbind',
  '是否': 'Whether',
  '解绑成功': 'Unbounded',
  '店铺授权': 'Channel Authorization',
  '新增店铺授权': 'Add Channel Authorization',
  '总量': 'Total ',
  '授权日期': 'Authorization Date',
  '合同编号：': 'Contract No.:',
  '请输入合同编号': 'Enter Contract No.',
  '店铺编号：': 'Channel No.:',
  '请输入店铺编号': 'Enter Channel No.',
  '店铺授权列表': 'Channel Authorization List',
  'WEB限额': 'WEB Limitation',
  'WEB限额余量': 'WEB Limitation Balance',
  '移动限额': 'Mobile POS Limitation',
  '移动限额余量': 'Mobile POSLimitation Balance',
  '解除授权': 'Disauthorization',
  '扩容': 'Expand Quty',
  '移动扩容:': 'Mobile POS Expand Quty',
  'WEB扩容:': 'WEB Expand Quty',
  '扩容成功': 'Quty Expanded',
  '将影响已授权的店铺登录，是否确定调整': 'Will influence the login of authorized channel, whether confirm to adjust?',
  '登录记录查看': 'Loging Records Search',
  '请输入店铺简称': 'Enter Channel',
  '请输入收银员名称': 'Enter Salesman\'s Name',
  '请输入机器编号': 'Enter Machine No. ',
  '请输入版本号': 'Enter Version No.',
  '至': 'to',
  '开始日期': 'Begin Date',
  '结束日期': 'End Date',
  '搜索': 'Search',
  '登录时间': 'Login Time',
  '收银员': 'Salesman',
  '门店': 'Channel',
  '设备型号': 'Device Type',
  '系统版本': 'System Version',
  '经纬度': 'Longitude&Latitude',
  '定位地址': 'Locate Address',
  '最近一周': 'Last Week',
  '最近一个月': 'Last Month',
  '最近三个月': 'Last 3 Month',
  '含扩容：': 'Include Expanding：',
  '管理': 'Management',
  '已过期': 'Expired',
  '未生效': 'Not Active',
  '不足一天': 'Less than 1 day',
  'Iphone': 'Iphone',
  'Ipad': 'Ipad',
  'WEB已用': 'WEB Used',
  '移动已用': 'Mobile Used',
  '调整限额': 'Adjust Limit',
  '收银': 'Sell',
  '物流': 'In&Out',
  '公告': 'Announcement',
  '储位': 'Storage',
  '其他': 'Other',
  '授权模块': 'Authory Module',
  '清理闲置设备': 'Clean Up Idle Device',
  '最近登录日期': 'Last Login Date',
  '未登录天数': 'Not Logged Days',
  '机器编码': 'Machine Code',
  '未登录天数大于': 'Not Logged Days More than',
  '请输入或选择': 'Enter/Select',
  '解绑全部': 'Unbind ALL',
  '将批量解绑所有设备，是否确认操作': 'To unbind all devices in batches, sure to do this?',
  // 4.2
  '设备变更记录': 'Change Record',
  '收银员帐号': 'Cashier Acct',
  '请输入收银员账号': 'Enter Cashier Acct',
  '设备解绑记录': 'Unbundling Record',
  '合同变更记录': 'Contract Change Record',
  '不限': 'Un-Limit',
  '设备归属列表': 'Device Belonging List',
  '创建合同': 'Create Contract',
  '合同初始化': 'Contract Initialize',
  '更新设备授权': 'Update Device Authory',
  '更新店铺数量': 'Update Channel No.',
  '续约': 'Renew',
  '模块配置': 'Module Manage',
  '更新Webpos数量': 'Update WEBPOS No.',
  '移动POS数量': 'Mobile POS No.',
  '授权店铺数量': 'Authory Channel NO.',
  '更新合同服务日期': 'Update Contract Date',
  '店铺': 'Channel',
  'Webpos限额': 'Webpos Limitation',
  '请输入限额': 'Input Limit',
  '移动POS限额': 'Mobile POS Limitation',
  '必须为正整数': 'Must be A Positive Integer',
  '不能低于': 'Not Lower Than',
  '归属店铺': 'Channel Belonging',
  '取消归属': 'Cancel Belonging',
  '全部': 'all',
  '合同类型': 'Contract Type',
  '租用': 'Rent',
  '购买': 'Buy-out',
  '导出': 'Export',
  '文件大小不能超过1M！': 'The file can not exceed 1M',
  '店务': 'shop'
});
// CONCATENATED MODULE: ./src/i18n/en/collaboraivePlatform.js
/*
 * @Author: yangchong
 * @Description: 协同办公多语言配置包
 * @Date: 2019-11-30 15:15:06
 */
/* harmony default export */ var en_collaboraivePlatform = ({
  '序号': 'No.',
  '其他平台': 'Other Platform',
  '自动获取': 'Auto-Get',
  '丽晶360终端物流': 'REGENTSOFT 360 Store Logistics',
  'POS自动填充收银员账号&密码': 'POS Autofill Cashier Account & Password',
  '协同平台设置': 'Collaborative Platform Setting',
  '平台名称': 'Platform Name',
  '网址': 'Website',
  '输入平台名称': 'Enter Platform Name',
  '输入网址': 'Enter Website',
  '需填写http': 'Need to Fill in http',
  '确定删除该记录吗？': 'Sure to delete this record?',
  '新增成功': 'Added',
  '保存成功': 'Saved',
  '请输入平台名称': 'Enter Platform Name',
  '请输入网址': 'Enter Website',
  '请输入正确的网址': 'Enter Right Website',
  '删除成功': 'Deleted',
  '新增': 'Add',
  '储位系统': 'Storage System',
  '店铺储位管理系统': 'Channel Storage Management System',
  '自定义排序': '',
  '是否取消自定义排序？': '',
  '已经是第一条，不可上': '',
  '已经是最后一条，不可下移': '',
  '修改成功': '',
  '取消': '',
  '保存': '',
  '平台类型': '',
  '外挂': '',
  'RP': 'RP'
});
// CONCATENATED MODULE: ./src/i18n/en/report.js
/* harmony default export */ var en_report = ({
  '报表类型': 'Report Type',
  '方案配置': 'Scheme Configuration',
  '添加方案': 'Add Scheme',
  '将报表方案配置至相应设备类型': 'Configure the Report Scheme to the Corresponding Device Type',
  '手机/平板': 'Mobile/PAD',
  '电脑': 'PC',
  '剩余可用字段': 'Remaining Available Fields',
  '当前使用字段': 'Currently Used Field',
  '可长按拖动排序': '',
  '基础': 'Basic',
  '提示': 'Hint',
  '取消': 'Cancel',
  '确定': 'Confirm',
  '重命名': 'Rename',
  '请输入方案名': 'Enter Scheme Name',
  '当前方案正在使用中，无法删除！': 'The current scheme is in use and cannot be deleted!',
  '确认删除该方案吗？': 'Sure to cancle the scheme?',
  '确认将该方案应用于手机/平板端吗？': 'Are you sure you want to switch the device type to mobile / PAD?',
  '确认将该方案应用于电脑端吗？': 'Are you sure you want to switch the device type to PC?',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗?': 'Quit lost record has operated without saving program. Confirm exit?',
  '执行该操作会刷新页面,请确认右侧方案字段配置操作已保存': 'Do this will refresh the page, make sure that the right side of the field sheme configuration has been saved',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗？': 'Quit lost record has operated without saving program. Confirm exit?',
  '确定命名后会刷新页面，请确认右侧字段已保存': 'After determining the name will refresh the page, make sure the right side of the field has been saved',
  '确定应用后会刷新页面，请确认右侧字段已保存': 'After determining the application  will refresh the page, make sure the right side of the field has been saved',
  '报表方案配置': 'Report Scheme Configuration',
  '方案保存成功': 'Scheme Save Successed',
  '方案重命名成功': 'Scheme Re-name Successed',
  '设备类型激活成功': 'Device Type Active Successed',
  '删除方案成功': 'Delete Successed',
  '添加成功': 'Added',
  '保存': 'Sava',
  '确定删除后会刷新页面，请确认右侧字段已保存': 'After deleting  will refresh the page, make sure the right side of the field has been saved'
});
// CONCATENATED MODULE: ./src/i18n/en/receipt.js
/* harmony default export */ var en_receipt = ({
  '渠道调拨': '',
  '单据编号': 'Invoice No.',
  '手工单号': 'Manual Ticket',
  '发货单位': 'Deliver Channel',
  '收货单位': 'Receiving Channel',
  '单据日期': 'Date',
  '打印人': 'Who Printed',
  '打印时间': 'Print Time',
  '备注': 'Notes',
  '货号': 'No.',
  '品名': 'Name',
  '颜色编号': 'Color No.',
  '颜色': 'Color',
  '内长': 'Length',
  '数量': 'Quty',
  '吊牌价': 'UNIT Price',
  '吊牌额': 'Tag-Price Amt',
  '发出方签': 'Shipper',
  '日期': 'Date',
  '接收方签': 'Receiver',
  '店长复核': 'Manager Review',
  '店铺编码': 'Channel Code',
  '店铺名称': 'Channel Name',
  '日结日期': 'Day-end Date',
  '销售单情况': 'Sale Receipt Condition',
  '销售金额': 'Sale Amt',
  '计收入': 'count received',
  '销售数量': 'Sale Quty',
  '销售单数': 'Sale Receipt Quty',
  '销售单退货情况': 'Sale Receipt Return Condition',
  '退货金额': 'Return Amt',
  '退货数量': 'Return Quty',
  '退货单数': 'Return Receipt Quty',
  '销售单付款情况': 'Sale Receipt Payment Condition',
  '储值卡充值情况': 'Value Card Pop-up Condition',
  '实收金额': 'Total',
  '赠送金额': 'Gift Amt',
  '充值笔数': 'Pop-up Sum',
  '所有付款方式汇总': 'All Payment Methods Summary',
  '班次': 'Shift',
  '生意额': 'Sales Amt',
  '期初': 'Opening',
  '销售现金': 'Sales Cash',
  '银行存款': 'Bank Deposit',
  '现金调整': 'Cash Adjust',
  '期末': 'End',
  '销售金额（计收入）': 'Sale Amt (count received)',
  '服务费付款情况': 'Service Fee Payments',
  '服务费金额': 'Service Fee Amt',
  '服务费数量': 'Service Fee Quty',
  '服务费单数': 'Service Fee Order Quty',
  '服务费退款情况': 'Service Fee Return',
  '服务费退款': 'Service Fee Return',
  '退款金额': 'Return Amt',
  '退款数量': 'Return Quty',
  '退款单数': 'Return Order Quty',
  '充值金额': 'Top-up Amt',
  '笔': 'No.',
  '合计': 'Total',
  '渠道': 'Channel',
  '收银': 'Sell',
  '销售日期': 'Sale Date',
  '付款方式': 'Payment method',
  '金额': 'Amt',
  '充值单据': 'Top-up Receipt',
  '竖排': 'Vertical',
  '横排': 'Horizontal',
  '颜色/内长': 'Color/Inner Length',
  '尺码': 'size',
  '会员': 'VIP',
  '货品': 'Goods',
  '会员价': 'VIP Price',
  '折扣': 'DCT',
  '折后价': 'NET Price',
  '税额': 'GST Amt',
  '折扣/折后价': 'DCT/NET Price',
  '税额/金额': 'GST Amt/Amt',
  '获得积分': 'Points',
  '储值余额': 'Value Card Balance',
  '积分余额': 'Points balance',
  '充值时间': 'Top-up Time',
  '服务费': 'Service Fee'
});
// CONCATENATED MODULE: ./src/i18n/en/home.js
/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-26 16:58:06
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-15 14:49:08
 */
/* harmony default export */ var en_home = ({
  '云POS模块价格说明': '',
  '功能模块': '',
  '配置化模块': '',
  'SAAS租用': '',
  '购买': '',
  '云POS硬件支持情况': '',
  '物流模块': '',
  '基础物流模块': '',
  'O2O物流模块': '',
  '365/年': '',
  '199/年': '',
  '600元+100元综合维护费/年': '',
  '200元+100元综合维护费/年': '',
  '收银模块': '',
  '云POS（物流+收银）': '',
  '730/年': '',
  '1200元+200元综合维护费/年': '',
  '900/年': '',
  '1400元+200元综合维护费/年': '',
  '联系我们': 'About Us',
  '总部:': '',
  '地址': 'Address',
  '电话': 'Mobile',
  '邮箱': 'Email',
  '客服中心:': '',
  '犀牛EPOS · PC版': 'Xiniu EPOS·PC Download',
  '全新上线，给你最美、最流畅的店铺Pos体验': 'Brand new, giving you the most beautiful and smooth shop Pos experience',
  '下载最新版': 'Download Newest Version',
  '运行环境：Win7或更高版本': 'Operating Environment：Win7 or Higher',
  '品牌Webpos下载': '',
  '下载最新定制版': 'Download Newest',
  '更多': 'More',
  '历史版本': ' Version History',
  '下载该版本': ' Download',
  '收银': 'Sell',
  '物流': 'In&Out',
  '报表': 'Repor',
  '查会员': 'Search  VIP',
  '犀牛EPOS': 'Xiniu EPOS',
  '产品': 'Software',
  '客户': 'Customer',
  'PC版下载': 'webPos',
  '移动版下载': 'APP',
  '智慧零售 赋能门店': 'Smart Retail Empowered Stores',
  '为您提供新零售所需要的一切': 'All New Retail You Need',
  '销售退换货': 'Sales & Return',
  '预售/赠送': 'Presale/Give Gift',
  '流行促销': 'Promotion',
  '会员/积分': 'VIP/Points',
  '储值/券': 'Value/Coupon',
  '收发货': 'Ship%Delevery',
  '盘点': 'Stock Check',
  '电商发货/退货': 'E-commerce Delivery',
  '真正的移动收银神器': 'Real Mobile Cashier Artifact',
  '商米/PDA/平板/手机': 'SUNMI/PDA/PAD/Mobile',
  '专为服饰零售行业客户而生': 'Built For Customers In The Apparel Retail Industry',
  '广州丽晶软件科技股份有限公司致力做最杰出的服饰管理专家，着意创建先进、精简、实用高效的电脑信息管理系统，用专注、创新见证着中国服装产业信息化发展进程。丽晶不仅仅要让企业在标准化的行业体系之中占有一席之地，达到灵活调度企业资源，快速感知市场变化，准确规划运营策略，实现销售增长的目的，更要竭尽全力增强服饰企业本身的独特竞争力，指引应用者凭添果敢的能力，激发决策者闪现睿智的灵感，在现在和未来发展与竞争中不断超越！': 'Guangzhou Regent Software Technology Co., Ltd. is committed to being the most outstanding clothing management expert. It is committed to creating advanced, streamlined, practical and efficient computer information management systems. It has witnessed the development of China\'s clothing industry informatization with focus and innovation. Regent must not only allow enterprises to occupy a place in the standardized industry system, to achieve flexible scheduling of corporate resources, rapid perception of market changes, accurate planning of operating strategies, and sales growth, but also to make every effort to enhance the unique competition of apparel companies themselves Power, guide users to rely on the ability to add courage, inspire decision-makers to show wise inspiration, and continue to surpass in the development and competition now and in the future!',
  '下载': 'Download',
  '全国热线': 'National Hotline',
  '周一至周五 9:00-18:00': 'Monday to Friday 9:00-18:00',
  '公司邮箱': 'Company Email',
  '粤ICP备12071402号-7': '',
  '粤ICP备12071402号': '粤ICP备12071402号',
  '扫码下载，货品管理尽在掌中': 'Scan Code to Download,Goods Management in the Hand',
  '安卓平板下载': 'pad',
  '安卓手机下载': 'Android Mobile',
  'iPhone下载': 'iPhone',
  'iPad下载': 'ipad',
  '品牌订制下载': 'Custom Download',
  '关于我们': 'About Us',
  '总部': '',
  '传真': 'FAX',
  '点击下载': 'Download',
  '企业后台登录': 'Company Background ',
  '运营管理后台': 'Operation Background',
  '犀牛EPOS · 定制版': 'Xiniu EPOS  · Custom',
  '移动端': '',
  '安卓手机': 'Android Mobile',
  '安卓平板': 'Android PAD',
  '定制版下载': 'Custom Download',
  '南京市中山东路18号国际贸易中心12层C3座': 'Block C3, 12 / F, International Trade Center, 18 Zhongshan East Road, Nanjing',
  '广州番禺区番禺大道北555号天安节能科技园15号楼102': 'Room 102, Building 15, Tianan Energy-saving Science and Technology Park, No. 555 Panyu Avenue North, Panyu District, Guangzhou'
});
// CONCATENATED MODULE: ./src/i18n/en/index.js
/*
 * @Author: JamesWong
 * @Description: 英文主入口
 * @Date: 2018-11-29 13:48:16
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-07 01:40:48
 */



















/* harmony default export */ var en = ({
  main: en_main,
  home: en_home,
  appversion: en_appversion,
  receipt: en_receipt,
  channel: en_channel,
  warehouse: en_warehouse,
  activeCode: en_activeCode,
  account: en_account,
  payment: en_payment,
  screen: en_screen,
  slip: en_slip,
  self: en_self,
  inout: en_inout,
  newSlip: en_newSlip,
  note: en_note,
  contract: en_contract,
  collaboraivePlatform: en_collaboraivePlatform,
  report: en_report
});
// CONCATENATED MODULE: ./src/i18n/zh-cn/preview.js
/* harmony default export */ var preview = ({
  '系统默认样式': '系统默认样式',
  '重打印': '重打印',
  '店铺编号print': '店铺编号',
  '单据日期': '单据日期',
  '核销单号print': '核销单号',
  '定金单号': '定金单号',
  '小票号print': '小票号',
  '操作时间print': '操作时间',
  '收银员print': '收银员',
  '营业员print': '营业员',
  '店铺电话print': '店铺电话',
  '店铺手机print': '店铺手机',
  '会员编号print': '会员编号',
  '会员姓名print': '会员姓名',
  '会员等级print': '会员等级',
  '销售备注print': '销售备注',
  '店铺地址print': '店铺地址',
  '已中所有促销': '已中所有促销',
  '已中整单促销': '已中整单促销',
  '总额print': '总额',
  '优惠print': '优惠',
  '应付print': '应付',
  '找零': '找零',
  '积分': '积分',
  '支付流水号': '支付流水号',
  '获得积分print': '获得积分',
  '积分余额print': '积分余额',
  '储值余额print': '储值余额',
  '代用券券号': '代用券券号',
  '顾客签名': '顾客签名',
  '该单所有的促销': '该单所有的促销',
  '促销描述': '促销描述',
  '货品print': '货品',
  '吊牌价print': '吊牌价',
  '会员价': '会员价',
  '折后价print': '折后价',
  '零售折扣/折后价': '零售折扣/折后价',
  '零售价print': '零售价',
  '零售折扣print': '零售折扣',
  '折扣/折后价': '折扣/折后价',
  '折扣print': '折扣',
  '数量print': '数量',
  '金额print': '金额',
  '合计print': '合计',
  '会员print': '会员',
  '顾客联': '顾客联',
  '店铺联': '店铺联',
  '税额/金额': '税额/金额',
  '税额': '税额',
  '代用券': '代用券',
  '不限': '不限',
  '满-金额': '满',
  '可用': '可用',
  '店铺': '店铺',
  '番禺区城店': '番禺区城店',
  '广州市番禺区天安节能科技园15号楼': '广州市番禺区天安节能科技园15号楼',
  '买满送优惠券': '买满送优惠券',
  '买满打折(按货品)': '买满打折(按货品)',
  '买满立减(按单)': '买满立减(按单)',
  '王晓': '王晓',
  '快递费': '快递费',
  '金属感香槟灰': '金属感香槟灰',
  '长袖上衣': '长袖上衣',
  'FS OTH 男装运动套头衫': 'FS OTH 男装运动套头衫',
  '现金支付': '现金支付',
  '高级会员': '高级会员',
  '方某某': '方某某',
  '张三': '张三',
  '日期': '日期'
});
// CONCATENATED MODULE: ./src/i18n/zh-hant/preview.js
/* harmony default export */ var zh_hant_preview = ({
  '系统默认样式': '系統默認樣式',
  '重打印': '重列印',
  '店铺编号print': '店鋪編號',
  '单据日期': '單據日期',
  '核销单号print': '核銷單號',
  '定金单号': '定金單號',
  '小票号print': '小票號',
  '操作时间print': '操作時間',
  '收银员print': '收銀員',
  '营业员print': '營業員',
  '店铺电话print': '店鋪電話',
  '店铺手机print': '店鋪手機',
  '会员编号print': '會員編號',
  '会员姓名print': '會員姓名',
  '会员等级print': '會員等級',
  '销售备注print': '銷售備註',
  '店铺地址print': '店鋪地址',
  '已中所有促销': '已中所有促銷',
  '已中整单促销': '已中整單促銷',
  '总额print': '總額',
  '优惠print': '優惠',
  '应付print': '應付',
  '找零': '找零',
  '积分': '積分',
  '支付流水号': '支付流水號',
  '获得积分print': '獲得積分',
  '积分余额print': '積分余額',
  '储值余额print': '儲值余額',
  '代用券券号': '代用券券號',
  '顾客签名': '顧客簽名',
  '该单所有的促销': '該單所有的促銷',
  '促销描述': '促銷描述',
  '货品print': '貨品',
  '吊牌价print': '吊牌價',
  '会员价': '會員價',
  '折后价print': '折後價',
  '零售折扣/折后价': '零售折扣/折后价',
  '零售价print': '零售价',
  '零售折扣print': '零售折扣',
  '折扣/折后价': '折扣/折後價',
  '折扣print': '折扣',
  '数量print': '數量',
  '金额print': '金額',
  '合计print': '合計',
  '会员print': '會員',
  '顾客联': '顧客聯',
  '店铺联': '店鋪聯',
  '税额/金额': '稅額/金額',
  '税额': '稅額',
  '代用券': '代用券',
  '不限': '不限',
  '满-金额': '满',
  '可用': '可用',
  '店铺': '店鋪',
  '番禺区城店': '番禺區城店',
  '广州市番禺区天安节能科技园15号楼': '廣州市番禺區天安節能科技園15號樓',
  '买满送优惠券': '買滿送優惠券',
  '买满打折(按货品)': '買滿打折(按貨品)',
  '买满立减(按单)': '買滿立減(按單)',
  '王晓': '王曉',
  '快递费': '快遞費',
  '金属感香槟灰': '金屬感香檳灰',
  '长袖上衣': '長袖上衣',
  'FS OTH 男装运动套头衫': 'FS OTH 男裝運動套頭衫',
  '现金支付': '現金支付',
  '高级会员': '高級會員',
  '方某某': '方某某',
  '张三': '張三',
  '日期': '日期'
});
// CONCATENATED MODULE: ./src/i18n/en/preview.js
/* harmony default export */ var en_preview = ({
  '系统默认样式': 'System Default Style',
  '重打印': 'Reprint',
  '店铺编号print': 'Shop',
  '单据日期': 'Date',
  '核销单号print': 'Trans',
  '定金单号': 'Deposit Receipt No.',
  '小票号print': 'Invoice #',
  '操作时间print': 'Time',
  '收银员print': 'Cashier',
  '营业员print': 'Staff',
  '店铺电话print': 'Phone',
  '店铺手机print': 'Mobile',
  '会员编号print': 'VIP Code',
  '会员姓名print': 'Member Name',
  '会员等级print': 'VIP Level',
  '销售备注print': 'Remarks',
  '店铺地址print': 'Address',
  '已中所有促销': 'In all promotion',
  '已中整单促销': 'In Promotion',
  '总额print': 'Total Amount',
  '优惠print': 'Discount',
  '应付print': 'Net',
  '找零': 'Change',
  '积分': 'Points',
  '支付流水号': 'Payment Serial No.',
  '获得积分print': 'Gain Point',
  '积分余额print': 'Balance',
  '储值余额print': 'Pre-paid Amount',
  '代用券券号': 'Coupon Code',
  '顾客签名': 'Signature',
  '该单所有的促销': 'All Promotions on this Ticket',
  '促销描述': 'Promotion Description',
  '货品print': 'Items',
  '吊牌价print': 'Price',
  '会员价': 'VIP Price',
  '折后价print': 'Net Price',
  '零售折扣/折后价': '零售折扣/折后价',
  '零售价print': '零售价',
  '零售折扣print': '零售折扣',
  '折扣/折后价': 'DCT/NET Price',
  '折扣print': 'Discount',
  '数量print': 'Qty',
  '金额print': 'Amount',
  '合计print': 'Total',
  '会员print': 'VIP No#',
  '顾客联': 'Customer Version',
  '店铺联': 'Shop Version',
  '税额/金额': 'TAX/Amt',
  '税额': 'GST Amt',
  '代用券': 'Coupon',
  '不限': 'Un-Limit',
  '满-金额': 'Amt ',
  '可用': ' Available',
  '店铺': 'Channel',
  '广州市番禺区天安节能科技园15号楼': 'Tian\'an Energy-saving Science and Technology Park, Panyu District, Guangzhou',
  '买满送优惠券': 'Coupon back at certain amt',
  '买满打折(按货品)': 'Deduct at certain Amt (by Goods)',
  '买满立减(按单)': 'Deduct at certain Amt (by Bill)',
  '王晓': 'Wang Xiao',
  '快递费': '快递费',
  '金属感香槟灰': '金属感香槟灰',
  '长袖上衣': '长袖上衣',
  'FS OTH 男装运动套头衫': 'FS OTH 男装运动套头衫',
  '现金支付': 'Cash',
  '高级会员': 'Higher',
  '方某某': 'Mr Fang',
  '张三': 'Zhang San',
  '日期': 'Date'
});
// EXTERNAL MODULE: ./node_modules/_element-ui@2.15.14@element-ui/lib/locale/lang/en.js
var lang_en = __webpack_require__("ayo1");
var en_default = /*#__PURE__*/__webpack_require__.n(lang_en);

// EXTERNAL MODULE: ./node_modules/_element-ui@2.15.14@element-ui/lib/locale/lang/zh-CN.js
var zh_CN = __webpack_require__("aCl7");
var zh_CN_default = /*#__PURE__*/__webpack_require__.n(zh_CN);

// EXTERNAL MODULE: ./node_modules/_element-ui@2.15.14@element-ui/lib/locale/lang/zh-TW.js
var zh_TW = __webpack_require__("UYs9");
var zh_TW_default = /*#__PURE__*/__webpack_require__.n(zh_TW);

// CONCATENATED MODULE: ./src/i18n/index.js

/*
 * @Author: JamesWong
 * @Description:  i18n 主入口
 * @Date: 2018-11-28 13:56:49
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-04 14:48:30
 */



// 随便吧 补补补



// element语言包




/* harmony default export */ var i18n = ({
  //  简体中文
  'zh-cn': extends_default()({}, zh_cn, zh_CN_default.a, preview),
  // 繁体中文
  'zh-hant': extends_default()({}, zh_hant, zh_TW_default.a, zh_hant_preview),
  'en': extends_default()({}, en, en_default.a, en_preview)
});
// EXTERNAL MODULE: ./src/api/management/v2/login.js + 1 modules
var login = __webpack_require__("7cbB");

// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__("0xDb");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/number/parse-float.js
var parse_float = __webpack_require__("0MWo");
var parse_float_default = /*#__PURE__*/__webpack_require__.n(parse_float);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/number/is-nan.js
var is_nan = __webpack_require__("wdUn");
var is_nan_default = /*#__PURE__*/__webpack_require__.n(is_nan);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("KH7x");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("ZLEe");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_throttle-debounce@1.1.0@throttle-debounce/debounce.js
var debounce = __webpack_require__("pQJX");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// CONCATENATED MODULE: ./src/components/infinite-scroll/types.js
function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function isHtmlElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}

var isFunction = function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
};

var isUndefined = function isUndefined(val) {
  return val === void 0;
};

var isDefined = function isDefined(val) {
  return val !== undefined && val !== null;
};
// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("hRKE");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./src/components/infinite-scroll/dom.js

/* istanbul ignore next */



var isServer = vue_esm["default"].prototype.$isServer;
// eslint-disable-next-line no-useless-escape
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
var on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
}

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
}

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
}

/* istanbul ignore next */
var getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((typeof styleName === 'undefined' ? 'undefined' : typeof_default()(styleName)) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
}

var isScroll = function isScroll(el, vertical) {
  if (isServer) return;

  var determinedDirection = vertical !== null || vertical !== undefined;
  var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');

  return overflow.match(/(scroll|auto)/);
};

var getScrollContainer = function getScrollContainer(el, vertical) {
  if (isServer) return;

  var parent = el;
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window;
    }
    if (isScroll(parent, vertical)) {
      return parent;
    }
    parent = parent.parentNode;
  }

  return parent;
};

var isInContainer = function isInContainer(el, container) {
  if (isServer || !el || !container) return false;

  var elRect = el.getBoundingClientRect();
  var containerRect = void 0;

  if ([window, document, document.documentElement, null, undefined].includes(container)) {
    containerRect = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    };
  } else {
    containerRect = container.getBoundingClientRect();
  }

  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
};
// CONCATENATED MODULE: ./src/components/infinite-scroll/src/main.js








var getStyleComputedProperty = function getStyleComputedProperty(element, property) {
  if (element === window) {
    element = document.documentElement;
  }

  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
};

var main_entries = function entries(obj) {
  return keys_default()(obj || {}).map(function (key) {
    return [key, obj[key]];
  });
};

var getPositionSize = function getPositionSize(el, prop) {
  return el === window || el === document ? document.documentElement[prop] : el[prop];
};

var getOffsetHeight = function getOffsetHeight(el) {
  return getPositionSize(el, 'offsetHeight');
};

var getClientHeight = function getClientHeight(el) {
  return getPositionSize(el, 'clientHeight');
};

var scope = 'ElInfiniteScroll';
var attributes = {
  delay: {
    type: Number,
    default: 200
  },
  distance: {
    type: Number,
    default: 0
  },
  disabled: {
    type: Boolean,
    default: false
  },
  immediate: {
    type: Boolean,
    default: true
  }
};

var main_getScrollOptions = function getScrollOptions(el, vm) {
  if (!isHtmlElement(el)) return {};

  return main_entries(attributes).reduce(function (map, _ref) {
    var _ref2 = slicedToArray_default()(_ref, 2),
        key = _ref2[0],
        option = _ref2[1];

    var type = option.type,
        defaultValue = option.default;

    var value = el.getAttribute('infinite-scroll-' + key);
    value = isUndefined(vm[value]) ? value : vm[value];
    switch (type) {
      case Number:
        value = Number(value);
        value = is_nan_default()(value) ? defaultValue : value;
        break;
      case Boolean:
        value = isDefined(value) ? value === 'false' ? false : Boolean(value) : defaultValue;
        break;
      default:
        value = type(value);
    }
    map[key] = value;
    return map;
  }, {});
};

var getElementTop = function getElementTop(el) {
  return el.getBoundingClientRect().top;
};

var main_handleScroll = function handleScroll(cb) {
  var _scope = this[scope],
      el = _scope.el,
      vm = _scope.vm,
      container = _scope.container,
      observer = _scope.observer;

  var _getScrollOptions = main_getScrollOptions(el, vm),
      distance = _getScrollOptions.distance,
      disabled = _getScrollOptions.disabled;

  if (disabled) return;

  var containerInfo = container.getBoundingClientRect();
  if (!containerInfo.width && !containerInfo.height) return;

  var shouldTrigger = false;

  if (container === el) {
    // be aware of difference between clientHeight & offsetHeight & window.getComputedStyle().height
    var scrollBottom = container.scrollTop + getClientHeight(container);
    shouldTrigger = container.scrollHeight - scrollBottom <= distance;
  } else {
    var heightBelowTop = getOffsetHeight(el) + getElementTop(el) - getElementTop(container);
    var offsetHeight = getOffsetHeight(container);
    var borderBottom = parse_float_default()(getStyleComputedProperty(container, 'borderBottomWidth'));
    shouldTrigger = heightBelowTop - offsetHeight + borderBottom <= distance;
  }

  if (shouldTrigger && isFunction(cb)) {
    cb.call(vm);
  } else if (observer) {
    observer.disconnect();
    this[scope].observer = null;
  }
};

/* harmony default export */ var src_main = ({
  name: 'InfiniteScroll',
  inserted: function inserted(el, binding, vnode) {
    var cb = binding.value;

    var vm = vnode.context;
    // only include vertical scroll
    var container = getScrollContainer(el, true);

    var _getScrollOptions2 = main_getScrollOptions(el, vm),
        delay = _getScrollOptions2.delay,
        immediate = _getScrollOptions2.immediate;

    var onScroll = debounce_default()(delay, main_handleScroll.bind(el, cb));

    el[scope] = { el: el, vm: vm, container: container, onScroll: onScroll };

    if (container) {
      container.addEventListener('scroll', onScroll);

      if (immediate) {
        var observer = el[scope].observer = new MutationObserver(onScroll);
        observer.observe(container, { childList: true, subtree: true });
        onScroll();
      }
    }
  },
  unbind: function unbind(el) {
    var _el$scope = el[scope],
        container = _el$scope.container,
        onScroll = _el$scope.onScroll;

    if (container) {
      container.removeEventListener('scroll', onScroll);
    }
  }
});
// CONCATENATED MODULE: ./src/components/infinite-scroll/index.js


/* istanbul ignore next */
src_main.install = function (Vue) {
  Vue.directive(src_main.name, src_main);
};

/* harmony default export */ var infinite_scroll = (src_main);
// CONCATENATED MODULE: ./src/components/el-table-infinite-scroll/table-infinite-scroll.js
/**
 * 对 element-ui 的无限滚动在 el-table 上使用的封装
 */


var elScope = 'ElInfiniteScroll'; // scope name
var msgTitle = '[el-table-infinite-scroll]: '; // message title
var elTableScrollWrapperClass = '.el-table__body-wrapper';

/* harmony default export */ var table_infinite_scroll = ({
  inserted: function inserted(el, binding, vnode, oldVnode) {
    // 获取 table 中的滚动层
    var scrollElem = el.querySelector(elTableScrollWrapperClass);

    // 如果没找到元素，返回错误
    if (!scrollElem) {
      // eslint-disable-next-line no-throw-literal
      throw msgTitle + '\u627E\u4E0D\u5230 ' + elTableScrollWrapperClass + ' \u5BB9\u5668';
    }

    // 设置自动滚动
    scrollElem.style.overflowY = 'auto';

    // dom 渲染后
    setTimeout(function () {
      if (!el.style.height) {
        scrollElem.style.height = '400px';
        console.warn(msgTitle + '\u8BF7\u5C3D\u91CF\u8BBE\u7F6E el-table \u7684\u9AD8\u5EA6\uFF0C\u53EF\u4EE5\u8BBE\u7F6E\u4E3A auto/100%\uFF08\u81EA\u9002\u5E94\u9AD8\u5EA6\uFF09\uFF0C\u672A\u8BBE\u7F6E\u4F1A\u53D6 400px \u7684\u9ED8\u8BA4\u503C\uFF08\u4E0D\u7136\u4F1A\u5BFC\u81F4\u4E00\u76F4\u52A0\u8F7D\uFF09');
      }

      asyncElOptions(vnode, el, scrollElem);

      // 绑定 infinite-scroll
      infinite_scroll.inserted(scrollElem, binding, vnode, oldVnode);

      // 将子集的引用放入 el 上，用于 unbind 中销毁事件
      el[elScope] = scrollElem[elScope];
    }, 0);
  },
  componentUpdated: function componentUpdated(el, binding, vnode) {
    asyncElOptions(vnode, el, el.querySelector(elTableScrollWrapperClass));
  },

  unbind: infinite_scroll.unbind

  /**
   * 同步 el-infinite-scroll 的配置项
   * @param sourceVNode
   * @param sourceElem
   * @param targetElem
   */
});function asyncElOptions(sourceVNode, sourceElem, targetElem) {
  var context = sourceVNode.context;
  var value = void 0;
  ['disabled', 'delay', 'immediate'].forEach(function (name) {
    name = 'infinite-scroll-' + name;
    value = sourceElem.getAttribute(name);
    if (value !== null) {
      targetElem.setAttribute(name, context[value] || value);
    }
  });

  // fix: windows/chrome 的 scrollTop + clientHeight 与 scrollHeight 不一致的 BUG
  var name = 'infinite-scroll-distance';
  value = sourceElem.getAttribute(name);
  value = context[value] || value;
  targetElem.setAttribute(name, value < 1 ? 1 : value);
}
// CONCATENATED MODULE: ./src/components/el-table-infinite-scroll/index.js
// directive


// Vue.use()
table_infinite_scroll.install = function (Vue) {
  Vue.directive('el-table-infinite-scroll', table_infinite_scroll);
};

// Vue.component()
/* harmony default export */ var el_table_infinite_scroll = (table_infinite_scroll);
// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















// language





// 下拉加载更多组件



vue_esm["default"].use(vue_i18n_esm["a" /* default */]);
vue_esm["default"].use(element_ui_common_default.a);
vue_esm["default"].use(plupload_full_min_default.a);
vue_esm["default"].use(infinite_scroll);
vue_esm["default"].use(el_table_infinite_scroll);

vue_esm["default"].prototype._Lodash = lodash;
Stimulsoft.Base.StiLicense.loadFromFile('/static/stimulsoft/license.key');
Stimulsoft.Base.Localization.StiLocalization.addLocalizationFile('/static/Localization/zh-CHS.xml', false, 'zh-CHS');
Stimulsoft.Base.Localization.StiLocalization.cultureName = 'zh-CHS';

// 关闭vue tips
vue_esm["default"].config.productionTip = false;
if (location.href.indexOf('token') !== -1) {
  // 检查地址栏是否有token
  var main_token = Object(utils["c" /* getUrlParams */])('token');
  if (main_token) {
    var params = {
      token: main_token
    };
    Object(login["a" /* getLoginInfoByToken */])(params).then(function (res) {
      if (res.code !== 20000) {
        return;
      }
      localStorage.setItem('manageLoginInfo', stringify_default()({
        token: res.data.token,
        appType: res.data.appType,
        companyCode: res.data.companyCode,
        name: res.data.name,
        account: res.data.account,
        bigVersionNo: Object(utils["d" /* versioncodeFormat */])(res.data.bigVersionNo)
      }));
      localStorage.setItem('loginRemindDto', stringify_default()(res.data.loginRemindDto || {}));
    });
  }
}
setTimeout(function () {
  router["a" /* default */].beforeEach(function (to, from, next) {
    nprogress_default.a.start();
    // 是否有token
    if (Object(auth["a" /* getToken */])() && to.path.indexOf('management') > -1) {
      if (store["a" /* default */].state.Management.name) {
        if (to.path === '/management/login') {
          return next({ path: '/management/index' });
        } else {
          next();
        }
      } else {
        next();
      }
    } else if (sysGetToken() && to.path.indexOf('operation') > -1) {
      if (to.path === '/operation/login') {
        next({ path: '/operation/index' });
      } else {
        next();
      }
    } else {
      // 未登录——跳转登录页
      if (to.path === '/management/login' || to.path === '/operation/login') {
        next();
      } else if (to.path.indexOf('management') > -1) {
        next({ path: '/management/login' });
      } else if (to.path.indexOf('operation') > -1) {
        next({ path: '/operation/login' });
      } else if (to.path === '/') {
        next();
      } else {
        next();
      }
    }
  });
  router["a" /* default */].afterEach(function () {
    nprogress_default.a.done();
  });
}, 0);

// 设置语言
var main_locale = 'zh-cn';
var lang = window.localStorage.getItem('LOCALE_KEY');
if (lang) {
  main_locale = lang;
} else {
  var jslang = (navigator.language || navigator.browserLanguage || 'zh-cn').toLowerCase();
  if (jslang.substr(0, 2) === 'zh') {
    main_locale = jslang === 'zh-cn' ? 'zh-cn' : 'zh-hant';
  } else if (jslang.substr(0, 2) === 'en') {
    main_locale = 'en';
  } else {
    main_locale = 'zh-cn';
  }
  window.localStorage.setItem('LOCALE_KEY', main_locale);
}
store["a" /* default */].commit('SET_LANGUAGE_CHANGE', main_locale);

var main_i18n = new vue_i18n_esm["a" /* default */]({
  locale: main_locale || 'zh-cn',
  fallbackLocale: 'zh-cn',
  messages: i18n
});
// element I18n
locale_default.a.i18n(function (key, value) {
  return main_i18n.t(key, value);
});

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: router["a" /* default */],
  i18n: main_i18n,
  store: store["a" /* default */],
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getToken;
/* unused harmony export setToken */
/* unused harmony export removeToken */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("sqb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var TokenKey = 'manage-token';

function getToken() {
  var manageLoginInfo = JSON.parse(localStorage.getItem('manageLoginInfo')) || {};
  return manageLoginInfo.token || '';
}

function setToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, token);
}

function removeToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(TokenKey);
}

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vue@2.7.16@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("nhZ1");

// EXTERNAL MODULE: ./node_modules/_vue-router@3.6.5@vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("lPSU");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("HzJ8");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/views/pages/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages = ({
  name: 'Index',
  data: function data() {
    return {
      transitionName: '',
      router: [{
        id: '1',
        name: this.$t('home.产品'),
        path: '/home'
      }, {
        id: '2',
        name: this.$t('home.客户'),
        path: '/customer'
      }, {
        id: '3',
        name: this.$t('home.PC版下载'),
        path: '/PCDownload'
      }, {
        id: '4',
        name: this.$t('home.移动版下载'),
        path: '/download'
      }, {
        id: '5',
        name: this.$t('home.定制版下载'),
        path: '/customDownload'
      }, {
        id: '6',
        name: this.$t('home.联系我们'),
        path: '/contactUs'
      }],
      language: [{ title: '简体中文', language: 'zh-cn' }, { title: '繁体中文', language: 'zh-hant' }, { title: 'English', language: 'en' }],
      activeLanguage: '简体中文'
    };
  },
  created: function created() {
    var _this = this;

    this.changeLanguage({ title: '简体中文', language: 'zh-cn' }, 0);
    this.language.map(function (item) {
      if (item.language === window.localStorage.getItem('LOCALE_KEY')) {
        _this.activeLanguage = item.title;
      }
    });
  },

  watch: {
    activeLanguage: function activeLanguage() {
      // window.location.reload()
    },
    $route: function $route(to, from) {
      var homeRoutes = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.$router.options.routes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var route = _step.value;

          if (route.path === '/index') {
            homeRoutes = route.children;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var fromIndex = 0;
      var toIndex = 0;
      for (var i = 0; i < homeRoutes.length; i++) {
        if (homeRoutes[i].name === from.name) {
          fromIndex = i;
        }
        if (homeRoutes[i].name === to.name) {
          toIndex = i;
        }
      }
      this.transitionName = toIndex < fromIndex ? 'slide-right' : 'slide-left';
    }
  },
  methods: {
    handleJump: function handleJump() {
      window.location.href = "http://admin.xiniuboss.com";
    },
    changeLanguage: function changeLanguage(val, type) {
      this.activeLanguage = val.title;
      this.$i18n.locale = val.language;
      localStorage.setItem('LOCALE_KEY', val.language);
      this.$store.commit('SET_LANGUAGE_CHANGE', val.language);
      if (type) {
        window.location.reload();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-9b07ba0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainboard"},[_c('div',{staticClass:"topbar"},[_c('router-link',{staticClass:"logo",attrs:{"tag":"div","active-class":"active","to":{path: '/index/home'}}},[_c('img',{attrs:{"src":__webpack_require__("ku+q"),"alt":"logo"}}),_vm._v(" "),_c('h1',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm.$t('home.犀牛EPOS')))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"navbar"},[_c('ul',[_vm._l((_vm.router),function(item,index){return _c('li',{key:index,class:_vm.activeLanguage === 'English' ? 'enMargin' : 'onEnMargin'},[_c('router-link',{attrs:{"active-class":"active","to":'/index' + item.path}},[_vm._v(_vm._s(item.name))])],1)}),_vm._v(" "),_c('li',[_c('el-dropdown',{staticClass:"right language",attrs:{"trigger":"click"}},[_c('span',{staticClass:"el-dropdown-link"},[_vm._v("\n                "+_vm._s(_vm.activeLanguage)),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},_vm._l((_vm.language),function(item){return _c('el-dropdown-item',{key:item.language,nativeOn:{"click":function($event){return _vm.changeLanguage(item, 1)}}},[_vm._v("\n                  "+_vm._s(item.title)+"\n                ")])}),1)],1)],1)],2)]),_vm._v(" "),_c('div',{staticClass:"router"},[_c('router-link',{staticClass:"management",attrs:{"tag":"div","to":{ path: '/management' }}},[_vm._v(_vm._s(_vm.$t('home.企业后台登录'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"operation",on:{"click":_vm.handleJump}},[_vm._v(_vm._s(_vm.$t('home.运营管理后台')))])],1)])],1),_vm._v(" "),_c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var views_pages = (esExports);
// CONCATENATED MODULE: ./src/views/pages/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("2rVw")
  __webpack_require__("oSFm")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b07ba0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  pages,
  views_pages,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_pages = (Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["default"].use(vue_router_esm["a" /* default */]);
var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/index'
  }, {
    path: '/management',
    redirect: '/management/index'
  }, {
    path: '/management/index',
    name: 'managementIndex',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(__webpack_require__.bind(null, "dVw7"));
    }
  }, {
    path: '/management/login',
    name: 'managementLogin',
    component: function component() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "cPKc"));
    }
  }, {
    path: '/management/set/:type',
    name: 'managementSet',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "uI4p"));
    },
    children: [{
      path: 'alipay/:id',
      name: 'alipay-details',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(__webpack_require__.bind(null, "cRAI"));
      }
    }, {
      path: 'wxpay/:id',
      name: 'wxpay-details',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, "BimU"));
      }
    }, {
      path: 'channelpay/:id',
      name: 'channel-set',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(33)]).then(__webpack_require__.bind(null, "wMNA"));
      }
    }, {
      path: 'receiptSet/:model/type/:id',
      name: 'channel-receipt-set',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(__webpack_require__.bind(null, "IhL+"));
      }
    }, {
      path: 'receiptModelSet/:model/type/:id',
      name: 'receipt-model-set',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, "Jr6t"));
      }
    },
    // 合同授权信息info页
    {
      path: 'contractAuthorizationInfo/:contractNo',
      name: 'contract-authorization-info',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "D87i"));
      }
    }, {
      path: 'storeAllAuthorizaed',
      name: 'store-all-authorizaed',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, "OEkW"));
      }
    }, {
      path: 'manageAllFacility',
      name: 'manage-all-facility',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "wvRL"));
      }
    }, {
      path: 'onlineMonitoring',
      name: 'online-monitoring',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "T7Ge"));
      }
    }, {
      path: 'storeAuthorizaedManage',
      name: 'store-authorizaed-manage',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "lk/r"));
      }
    }, {
      path: 'clearIdleList',
      name: 'clearIdleList',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(__webpack_require__.bind(null, "kk6G"));
      }
    }, {
      path: 'deviceChangeLog',
      name: 'deviceChangeLog',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "2Upv"));
      }
    }, {
      path: 'deviceUntiedLog',
      name: 'deviceUntiedLog',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, "YXD2"));
      }
    },
    // 短信
    {
      path: 'noteIndex',
      name: 'noteIndex',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "7GFR"));
      }
    }, {
      path: 'noteList',
      name: 'noteList',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "zPFx"));
      }
    }, {
      path: 'noNotePage',
      name: 'noNotePage',
      component: function component() {
        return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, "sI2Y"));
      }
    }, {
      path: 'noteModules',
      name: 'noteModules',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(__webpack_require__.bind(null, "qe79"));
      }
    }, {
      path: 'reportModules', // 报表配置模块
      name: 'reportModules',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "kuBJ"));
      }
    }, {
      path: 'channelInfo',
      name: 'channelInfo',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "8xJg"));
      }
    }, {
      path: 'newNontElement',
      name: 'newNontElement',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "LZua"));
      }
    }, {
      path: 'signatureElement',
      name: 'signatureElement',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "Xc8D"));
      }
    }, {
      path: 'nontEditElement',
      name: 'nontEditElement',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(__webpack_require__.bind(null, "iBYR"));
      }
    },
    // 公告
    {
      path: 'noticeIndex',
      name: 'noticeIndex',
      component: function component() {
        return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, "qse4"));
      }
    }]
  },
  // 官网相关
  {
    path: '/index',
    component: src_views_pages,
    redirect: '/index/home',
    hidden: true,
    children: [{
      path: 'home',
      name: '主页',
      component: function component() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "Stdb"));
      }
    }, {
      path: 'product',
      name: '产品',
      component: function component() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "mQWA"));
      }
    }, {
      path: 'customer',
      name: '客户',
      component: function component() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "E9bT"));
      }
    }, {
      path: 'PCDownload',
      name: 'PC版下载',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(__webpack_require__.bind(null, "E/k8"));
      }
    }, {
      path: 'download',
      name: '移动版下载',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "646t"));
      }
    }, {
      path: 'customDownload',
      name: '定制版下载',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, "6Hud"));
      }
    }, {
      path: 'contactUs',
      name: '联系我们',
      component: function component() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "p9j4"));
      }
    }]
  }, {
    path: '/paycall',
    name: 'pay-callback',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, "pt+g"));
    }
  }]
});

/* harmony default export */ var src_router = __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ku+q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rhino_logo.743cc9a.png";

/***/ }),

/***/ "oSFm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ve9D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.95b8c913e025a3e1f983.js